// App.jsx - single file, all CSS inside
// npm i react-stripe-checkout reactjs-popup
import { useState, useRef, useEffect, useCallback } from "react";
import Pay from "./Pay";

const API  = process.env.REACT_APP_API_URL || "https://learntok-backend-2026-24c204fe508e.herokuapp.com/warm";
const ADM  = process.env.REACT_APP_ADMIN_SECRET || "123";
const FREE = 4;
const SHARE_TEXT = `Just found my warm intro paths to top VCs using VCInvest!\n\nEnter your school, company and hometown. It finds funded founders who share your background. No cold emails.\n\nTry free: https://warmintro.app\n\n#startups #venturecapital #founders`;
const LI_URL = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent("https://warmintro.app")}&summary=${encodeURIComponent(SHARE_TEXT)}`;

const sc = (n,v,d=30) => { document.cookie=`${n}=${v};expires=${new Date(Date.now()+d*864e5).toUTCString()};path=/;SameSite=Lax`; };
const gc = n => document.cookie.split("; ").find(r=>r.startsWith(n+"="))?.split("=")[1]||null;

const SCHOOLS=["Phillips Exeter Academy","Phillips Andover Academy","Harvard-Westlake School","Stuyvesant High School","Thomas Jefferson High School","Horace Mann School","Collegiate School","Trinity School","Bronx Science","Brooklyn Tech","Palo Alto High School","Gunn High School","Menlo School","Bellarmine College Prep","Milton Academy","Deerfield Academy","Choate Rosemary Hall","Hotchkiss School","Groton School","Lawrenceville School","Loomis Chaffee","Lakeside School","Nueva School","Head-Royce School","Saratoga High School","Lynbrook High School"];
const COLLEGES=["Stanford University","MIT","Harvard University","Yale University","Princeton University","Columbia University","UPenn / Wharton","Dartmouth College","Brown University","Cornell University","Duke University","Northwestern University","University of Chicago","Johns Hopkins University","Caltech","Carnegie Mellon University","UC Berkeley","UCLA","University of Michigan","University of Virginia","Georgia Tech","University of Texas Austin","UIUC","Purdue University","University of Washington","USC","NYU","Boston University","Northeastern University","Babson College","Harvey Mudd College","IIT Bombay","IIT Delhi","IIT Madras","Peking University","Tsinghua University","Seoul National University","University of Toronto","University of Waterloo","Oxford University","Cambridge University","Imperial College London","ETH Zurich"];
const COMPANIES=["Google","Meta","Apple","Microsoft","Amazon","Netflix","Uber","Airbnb","Stripe","Palantir","Coinbase","Robinhood","Instacart","DoorDash","Lyft","Twitter / X","LinkedIn","Salesforce","Oracle","Workday","Snowflake","Databricks","MongoDB","Twilio","Okta","CrowdStrike","Datadog","OpenAI","Anthropic","DeepMind","Scale AI","SpaceX","Tesla","Rivian","Waymo","Goldman Sachs","Morgan Stanley","JPMorgan","McKinsey","BCG","Bain","Sequoia Capital","a16z","Benchmark","Accel","Y Combinator","Deloitte","Accenture","PwC","NASA","DARPA"];
const HOMETOWNS=["San Francisco, CA","New York, NY","Los Angeles, CA","Seattle, WA","Austin, TX","Boston, MA","Chicago, IL","Washington, DC","Miami, FL","Denver, CO","Atlanta, GA","Dallas, TX","San Jose, CA","Palo Alto, CA","Oakland, CA","Mountain View, CA","Mumbai, India","Delhi, India","Bangalore, India","Hyderabad, India","Chennai, India","Beijing, China","Shanghai, China","Shenzhen, China","Tel Aviv, Israel","Seoul, South Korea","Tokyo, Japan","Singapore","London, UK","Berlin, Germany","Paris, France","Toronto, Canada","Sydney, Australia","Dubai, UAE"];
const VCS=["Andreessen Horowitz (a16z)","Sequoia Capital","Benchmark","Accel Partners","Y Combinator","Kleiner Perkins","Greylock Partners","Lightspeed Venture Partners","General Catalyst","Index Ventures","NEA","Bessemer Venture Partners","Founders Fund","Tiger Global Management","SoftBank Vision Fund","GV (Google Ventures)","Intel Capital","Salesforce Ventures","Insight Partners","IVP","Norwest Venture Partners","Menlo Ventures","Battery Ventures","Spark Capital","Union Square Ventures","First Round Capital","Forerunner Ventures","Canaan Partners","Emergence Capital","Felicis Ventures","Initialized Capital","Lux Capital","Matrix Partners","Redpoint Ventures","True Ventures","Venrock","Warburg Pincus","Paradigm","Multicoin Capital","Pantera Capital","Electric Capital","Dragonfly Capital","Coatue Management","D1 Capital Partners","Altimeter Capital","Khosla Ventures","8VC","Data Collective (DCVC)","Ribbit Capital","QED Investors","Anthemis Group","Bain Capital Ventures","Summit Partners","Francisco Partners","Vista Equity","Silver Lake Partners","KKR Growth","General Atlantic","TA Associates","Flagship Pioneering","Third Rock Ventures","ARCH Venture Partners","5AM Ventures","Versant Ventures","OrbiMed","Atlas Venture","Social Capital","Obvious Ventures","HOF Capital","Craft Ventures","a16z Crypto","Variant Fund","Durable Capital","Lone Pine Capital","Viking Global","MPM Capital","RRE Ventures","SV Angel","Pear VC","CRV","Atomico","Balderton Capital","Northzone","Accel London"];
const CLR=[{bg:"#FEE2E2",text:"#991B1B",bd:"#FECACA",av:"#EF4444"},{bg:"#FEF3C7",text:"#92400E",bd:"#FDE68A",av:"#F59E0B"},{bg:"#D1FAE5",text:"#065F46",bd:"#A7F3D0",av:"#10B981"},{bg:"#DBEAFE",text:"#1E40AF",bd:"#BFDBFE",av:"#2563EB"},{bg:"#EDE9FE",text:"#4C1D95",bd:"#DDD6FE",av:"#7C3AED"},{bg:"#FCE7F3",text:"#831843",bd:"#FBCFE8",av:"#EC4899"}];
const ATC={pageview:"#2563EB",search:"#F59E0B",share:"#10B981",sale:"#EF4444",email_capture:"#F97316",outreach_generated:"#7C3AED"};
const ATB={pageview:"#EFF6FF",search:"#FFFBEB",share:"#ECFDF5",sale:"#FEF2F2",email_capture:"#FFF7ED",outreach_generated:"#F5F3FF"};
const ATI={pageview:"👁",search:"🔍",share:"🔗",sale:"💰",email_capture:"📧",outreach_generated:"✉️"};
const ATL={pageview:"Page View",search:"Search",share:"Share",sale:"Sale",email_capture:"Email",outreach_generated:"Outreach"};
const af=n=>n>=1000?(n/1000).toFixed(1)+"k":String(n||0);
const am=n=>"$"+(n||0).toFixed(2);
const ago=d=>{const s=Math.floor((Date.now()-new Date(d))/1000);if(s<60)return`${s}s`;if(s<3600)return`${Math.floor(s/60)}m`;if(s<86400)return`${Math.floor(s/3600)}h`;return`${Math.floor(s/86400)}d`;};

const STYLES = `
@import url('https://fonts.googleapis.com/css2?family=Inter:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400&family=DM+Mono:wght@400;500&display=swap');
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
:root{
  --y:#F59E0B;--g:#10B981;--r:#EF4444;--bl:#2563EB;--pu:#7C3AED;
  --ink:#0f0f0f;--ink2:#374151;--mu:#6B7280;--mu2:#9CA3AF;--mu3:#D1D5DB;
  --bg:#FFFFFF;--s1:#FFFFFF;--s2:#F9FAFB;--s3:#F3F4F6;--bd:#E5E7EB;
  --shadow-sm:0 1px 2px rgba(0,0,0,.05);
  --shadow:0 1px 3px rgba(0,0,0,.1),0 1px 2px rgba(0,0,0,.06);
  --shadow-md:0 4px 6px rgba(0,0,0,.07),0 2px 4px rgba(0,0,0,.06);
  --shadow-lg:0 10px 15px rgba(0,0,0,.1),0 4px 6px rgba(0,0,0,.05);
  --radius:8px;--radius-lg:12px;--radius-xl:16px;
}
html{scroll-behavior:smooth}
body{font-family:'Inter',sans-serif;background:var(--bg);color:var(--ink);line-height:1.5;-webkit-font-smoothing:antialiased}
button{font-family:inherit;cursor:pointer}
a{text-decoration:none}
input,textarea,select{font-family:inherit}
.nav{display:flex;align-items:center;justify-content:space-between;padding:16px 48px;border-bottom:1px solid var(--bd);position:sticky;top:0;background:rgba(255,255,255,.95);backdrop-filter:blur(16px);z-index:100}
.nav-logo{font-size:18px;font-weight:800;color:var(--ink);cursor:pointer;letter-spacing:-.5px}
.nav-logo em{font-style:normal;color:var(--y)}
.nav-links{display:flex;align-items:center;gap:28px}
.nav-link{font-size:14px;font-weight:500;color:var(--mu);transition:color .15s;cursor:pointer}
.nav-link:hover{color:var(--ink)}
.nav-actions{display:flex;align-items:center;gap:10px}
.btn-nav{background:var(--ink);color:#fff;border:none;padding:9px 20px;font-size:13px;font-weight:600;border-radius:var(--radius);transition:opacity .15s}
.btn-nav:hover{opacity:.85}
.credits-badge{display:flex;align-items:center;gap:8px;background:var(--s2);border:1px solid var(--bd);padding:6px 14px;border-radius:var(--radius)}
.credits-n{font-size:16px;font-weight:800;color:var(--y);font-family:'DM Mono',monospace}
.credits-lbl{font-size:9px;color:var(--mu);text-transform:uppercase;letter-spacing:.12em;font-weight:600}
.credits-buy{background:var(--ink);color:#fff;border:none;padding:5px 12px;font-size:11px;font-weight:700;border-radius:5px}
.btn-primary{display:inline-flex;align-items:center;justify-content:center;gap:8px;background:var(--ink);color:#fff;border:none;padding:14px 28px;font-size:14px;font-weight:700;border-radius:var(--radius);transition:all .15s;white-space:nowrap}
.btn-primary:hover{opacity:.85;transform:translateY(-1px);box-shadow:var(--shadow-md)}
.btn-primary:disabled{opacity:.4;cursor:not-allowed;transform:none}
.btn-yellow{background:var(--y);color:#000;border:none;padding:14px 28px;font-size:14px;font-weight:700;border-radius:var(--radius);transition:all .15s;cursor:pointer}
.btn-yellow:hover{filter:brightness(.95);transform:translateY(-1px);box-shadow:0 8px 24px rgba(245,158,11,.3)}
.btn-li{display:inline-flex;align-items:center;gap:8px;background:#0A66C2;color:#fff;border:none;padding:12px 22px;font-size:13px;font-weight:700;border-radius:var(--radius);transition:opacity .15s;cursor:pointer}
.btn-li:hover:not(:disabled){opacity:.9}
.btn-li .li-ic{background:#fff;color:#0A66C2;font-size:10px;font-weight:900;width:18px;height:18px;display:flex;align-items:center;justify-content:center;border-radius:3px}
.btn-ghost-sm{background:none;border:none;font-size:12px;color:var(--mu);text-decoration:underline;text-underline-offset:3px;padding:4px 0;cursor:pointer}
.btn-ghost-sm:hover{color:var(--ink)}
.inp{width:100%;background:var(--s2);border:1.5px solid var(--bd);color:var(--ink);font-size:14px;padding:11px 14px;border-radius:var(--radius);outline:none;transition:border-color .15s}
.inp:focus{border-color:var(--y);background:#fff}
.inp::placeholder{color:var(--mu3)}
.tag-y{display:inline-flex;align-items:center;padding:4px 12px;border-radius:100px;font-size:11px;font-weight:600;letter-spacing:.05em;text-transform:uppercase;background:#FEF3C7;color:#92400E;border:1px solid #FDE68A}
.tag-g{display:inline-flex;align-items:center;padding:4px 12px;border-radius:100px;font-size:11px;font-weight:600;letter-spacing:.05em;text-transform:uppercase;background:#D1FAE5;color:#065F46;border:1px solid #A7F3D0}
.overlay{position:fixed;inset:0;background:rgba(0,0,0,.55);z-index:1000;display:flex;align-items:center;justify-content:center;padding:12px;backdrop-filter:blur(3px)}
.modal{background:#fff;border-radius:var(--radius-xl);padding:32px 28px;max-width:480px;width:calc(100% - 24px);position:relative;max-height:92vh;overflow-y:auto;box-shadow:var(--shadow-lg);box-sizing:border-box}
@media(max-width:480px){.modal{padding:22px 16px;border-radius:16px;max-height:95vh}}
.modal::-webkit-scrollbar{width:3px}
.modal::-webkit-scrollbar-thumb{background:var(--bd)}
.modal-close{position:absolute;top:16px;right:16px;background:var(--s3);border:none;width:30px;height:30px;border-radius:50%;font-size:16px;display:flex;align-items:center;justify-content:center;color:var(--mu);cursor:pointer}
.modal-wide{max-width:560px}
.angel-hero{background:linear-gradient(160deg,#0A0500 0%,#150A00 60%,#0A0500 100%);padding:80px 48px;text-align:center;position:relative;overflow:hidden}
.angel-hero::after{content:'';position:absolute;top:-40%;left:50%;transform:translateX(-50%);width:700px;height:700px;border-radius:50%;background:radial-gradient(circle,rgba(245,158,11,.12) 0%,transparent 65%);pointer-events:none}
.angel-hero-inner{position:relative;z-index:1;max-width:900px;margin:0 auto}
.live-pill{display:inline-flex;align-items:center;gap:8px;background:rgba(16,185,129,.1);border:1px solid rgba(16,185,129,.2);color:#34D399;font-size:12px;font-weight:600;padding:8px 18px;border-radius:100px;margin-bottom:28px}
.live-dot{width:7px;height:7px;border-radius:50%;background:#10B981;animation:pulse-g 2s ease-in-out infinite}
@keyframes pulse-g{0%,100%{opacity:1}50%{opacity:.4}}
.angel-h1{font-size:clamp(34px,5.5vw,60px);font-weight:800;letter-spacing:-.5px;line-height:1.05;color:#fff;margin-bottom:16px}
.angel-h1 em{font-style:normal;color:var(--y)}
.angel-sub{font-size:16px;color:rgba(255,255,255,.5);max-width:500px;margin:0 auto 40px;line-height:1.7}
.angel-stats-row{display:flex;justify-content:center;border:1px solid rgba(255,255,255,.08);border-radius:var(--radius-lg);overflow:hidden;margin-bottom:44px;max-width:680px;margin-left:auto;margin-right:auto}
.angel-stat{flex:1;padding:20px 16px;border-right:1px solid rgba(255,255,255,.08);background:rgba(255,255,255,.03)}
.angel-stat:last-child{border-right:none}
.angel-stat-n{font-size:28px;font-weight:800;color:var(--y);font-family:'DM Mono',monospace;letter-spacing:-1px;line-height:1}
.angel-stat-l{font-size:10px;color:rgba(255,255,255,.3);text-transform:uppercase;letter-spacing:.1em;margin-top:5px;font-weight:600}
.angel-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:10px;max-width:900px;margin:0 auto 44px}
.angel-card{background:rgba(255,255,255,.04);border:1px solid rgba(255,255,255,.07);padding:18px 16px;border-radius:var(--radius-lg);text-align:left;transition:all .2s}
.angel-card:hover{background:rgba(255,255,255,.08);border-color:rgba(245,158,11,.25);transform:translateY(-2px)}
.angel-av{width:38px;height:38px;border-radius:50%;background:linear-gradient(135deg,var(--y),#F97316);color:#000;font-size:13px;font-weight:800;display:flex;align-items:center;justify-content:center;margin-bottom:10px}
.angel-name{font-size:13px;font-weight:700;color:#fff;margin-bottom:2px}
.angel-role{font-size:11px;color:rgba(255,255,255,.33);margin-bottom:6px;line-height:1.4}
.angel-notable{font-size:11px;color:rgba(245,158,11,.65);line-height:1.5}
.angel-ctas{display:flex;gap:12px;justify-content:center;flex-wrap:wrap}
.band{background:var(--s2);border-top:1px solid var(--bd);border-bottom:1px solid var(--bd);padding:14px 48px;display:flex;align-items:center;justify-content:center;gap:10px;flex-wrap:wrap}
.band-text{font-size:13px;color:var(--mu);font-weight:500}
.band-rule{height:1px;width:60px;background:var(--bd)}
.hero{padding:80px 48px;text-align:center;background:linear-gradient(180deg,#FFFDF5 0%,#fff 100%);position:relative;overflow:hidden}
.hero::before{content:'';position:absolute;top:-60px;left:50%;transform:translateX(-50%);width:800px;height:400px;background:radial-gradient(ellipse,rgba(245,158,11,.07) 0%,transparent 70%);pointer-events:none}
.hero-inner{position:relative;z-index:1;max-width:680px;margin:0 auto}
.hero-h1{font-size:clamp(40px,6vw,68px);font-weight:800;letter-spacing:-1.5px;line-height:.95;margin-bottom:20px;color:var(--ink)}
.hero-h1 em{font-style:normal;color:var(--y)}
.hero-h1 .stroke{-webkit-text-stroke:2.5px var(--ink);color:transparent}
.hero-sub{font-size:16px;color:var(--mu);line-height:1.7;max-width:460px;margin:0 auto 32px}
.hero-perks{display:flex;align-items:center;justify-content:center;gap:18px;flex-wrap:wrap;margin-top:20px}
.hero-perk{font-size:12px;color:var(--mu);font-weight:500;display:flex;align-items:center;gap:5px}
.hero-perk::before{content:'checkmark';font-size:12px;color:var(--g);font-weight:700;content:'✓'}
.proof-bar{background:#fafafa;border-top:1px solid var(--bd);border-bottom:1px solid var(--bd);padding:12px 48px;overflow:hidden}
.proof-items{display:flex;gap:28px;align-items:center;flex-wrap:wrap;justify-content:center}
.proof-item{font-size:12px;font-weight:600;color:var(--mu2);display:flex;align-items:center;gap:7px}
.proof-dot{width:5px;height:5px;border-radius:50%;background:var(--y);flex-shrink:0}
.stats-strip{display:flex;justify-content:center;padding:36px 48px;gap:0;border-top:1px solid var(--bd);background:#fff;flex-wrap:wrap}
.stat-item{flex:1;max-width:180px;text-align:center;padding:0 20px;border-right:1px solid var(--bd)}
.stat-item:last-child{border-right:none}
.stat-n{font-size:32px;font-weight:800;color:var(--ink);letter-spacing:-1px;font-family:'DM Mono',monospace}
.stat-l{font-size:11px;color:var(--mu);text-transform:uppercase;letter-spacing:.1em;margin-top:4px;font-weight:500}
.section{padding:72px 48px;max-width:1080px;margin:0 auto}
.section-eyebrow{font-size:12px;font-weight:600;letter-spacing:.1em;text-transform:uppercase;color:var(--y);margin-bottom:12px}
.section-title{font-size:clamp(26px,4vw,40px);font-weight:800;letter-spacing:-.5px;line-height:1.15;color:var(--ink);margin-bottom:14px}
.section-sub{font-size:16px;color:var(--mu);line-height:1.7;max-width:500px}
.section-center{text-align:center}
.section-center .section-sub{margin:0 auto}
.feat-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:18px;margin-top:44px}
.feat-card{background:#fff;border:1px solid var(--bd);padding:26px 22px;border-radius:var(--radius-lg);transition:all .2s;box-shadow:var(--shadow-sm)}
.feat-card:hover{box-shadow:var(--shadow-md);transform:translateY(-2px)}
.feat-ic{width:42px;height:42px;border-radius:10px;background:var(--s3);display:flex;align-items:center;justify-content:center;font-size:20px;margin-bottom:14px}
.feat-title{font-size:15px;font-weight:700;margin-bottom:7px}
.feat-desc{font-size:13px;color:var(--mu);line-height:1.65}
.steps-wrap{max-width:640px;margin:44px auto 0}
.step{display:flex;gap:18px;padding-bottom:32px;position:relative}
.step:not(:last-child)::before{content:'';position:absolute;left:17px;top:38px;bottom:0;width:2px;background:var(--bd)}
.step-num{width:36px;height:36px;min-width:36px;border-radius:50%;background:var(--ink);color:#fff;font-size:13px;font-weight:800;display:flex;align-items:center;justify-content:center;z-index:1;flex-shrink:0}
.step-body{padding-top:6px}
.step-title{font-size:15px;font-weight:700;margin-bottom:5px}
.step-desc{font-size:13px;color:var(--mu);line-height:1.65}
.testi-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:16px;margin-top:44px}
.testi{background:#fff;border:1px solid var(--bd);padding:22px;border-radius:var(--radius-lg);box-shadow:var(--shadow-sm)}
.testi-text{font-size:14px;color:var(--ink);line-height:1.7;margin-bottom:16px;font-style:italic}
.testi-text::before{content:open-quote;font-size:26px;color:var(--y);line-height:0;vertical-align:-10px;font-style:normal;font-weight:800}
.testi-author{display:flex;align-items:center;gap:10px}
.testi-av{width:32px;height:32px;border-radius:50%;background:var(--ink);color:#fff;font-size:12px;font-weight:700;display:flex;align-items:center;justify-content:center;flex-shrink:0}
.testi-name{font-size:13px;font-weight:700}
.testi-role{font-size:11px;color:var(--mu)}
.cta-band{background:var(--ink);color:#fff;padding:64px 48px;text-align:center}
.cta-band-title{font-size:clamp(26px,4vw,42px);font-weight:800;letter-spacing:-.5px;margin-bottom:12px}
.cta-band-sub{font-size:15px;color:rgba(255,255,255,.5);line-height:1.7;margin-bottom:32px}
.footer{background:var(--s2);border-top:1px solid var(--bd);padding:44px 48px 28px}
.footer-inner{max-width:1080px;margin:0 auto}
.footer-brand{text-align:center;margin-bottom:28px}
.footer-logo{font-size:18px;font-weight:800;color:var(--ink);margin-bottom:7px}
.footer-logo em{font-style:normal;color:var(--y)}
.footer-tagline{font-size:13px;color:var(--mu);max-width:340px;margin:0 auto;line-height:1.6}
.footer-chips{display:flex;flex-wrap:wrap;justify-content:center;gap:7px 14px;margin-bottom:28px}
.footer-chip{display:flex;align-items:center;gap:5px;font-size:12px;color:var(--mu)}
.footer-chip::before{content:'';width:4px;height:4px;border-radius:50%;background:var(--y);flex-shrink:0}
.footer-copy{text-align:center;font-size:12px;color:var(--mu2);padding-top:20px;border-top:1px solid var(--bd)}
.tool-wrap{max-width:960px;margin:0 auto;padding:40px 32px 100px}
.tool-topbar{display:flex;align-items:center;gap:16px;margin-bottom:36px;padding-bottom:18px;border-bottom:1px solid var(--bd)}
.back-btn{background:#fff;border:1.5px solid var(--bd);color:var(--mu);padding:7px 14px;font-size:12px;font-weight:600;border-radius:var(--radius);cursor:pointer;transition:all .15s}
.back-btn:hover{border-color:var(--ink);color:var(--ink)}
.tool-title{font-size:19px;font-weight:800}
.sec-head{display:flex;align-items:center;gap:10px;margin-bottom:16px;flex-wrap:wrap}
.sec-num{font-family:'DM Mono',monospace;font-size:10px;color:var(--y);background:#FEF3C7;border:1px solid #FDE68A;padding:2px 8px;border-radius:4px;font-weight:600}
.sec-ttl{font-size:16px;font-weight:800}
.sdd-grid{display:grid;grid-template-columns:1fr 1fr;gap:12px;margin-bottom:32px}
.sdd-wrap{position:relative}
.sdd-lbl{display:block;font-size:10px;font-weight:700;letter-spacing:.1em;text-transform:uppercase;color:var(--mu);margin-bottom:5px}
.sdd-trigger{display:flex;align-items:center;justify-content:space-between;gap:8px;background:#fff;border:1.5px solid var(--bd);padding:10px 13px;cursor:pointer;min-height:44px;transition:border-color .15s;font-size:13px;font-weight:600;border-radius:var(--radius)}
.sdd-trigger:hover,.sdd-trigger.open{border-color:var(--y)}
.sdd-ph{color:var(--mu3);font-weight:400}
.sdd-x{background:none;border:none;color:var(--mu2);font-size:16px;line-height:1;padding:0 2px;cursor:pointer}
.sdd-arr{font-size:9px;color:var(--mu3)}
.sdd-menu{position:absolute;top:calc(100% + 4px);left:0;right:0;background:#fff;border:1.5px solid var(--y);z-index:300;box-shadow:var(--shadow-lg);border-radius:var(--radius);overflow:hidden}
.sdd-search{width:100%;background:var(--s2);border:none;border-bottom:1px solid var(--bd);color:var(--ink);font-size:13px;padding:10px 12px;outline:none}
.sdd-list{max-height:200px;overflow-y:auto}
.sdd-list::-webkit-scrollbar{width:3px}
.sdd-list::-webkit-scrollbar-thumb{background:var(--bd)}
.sdd-item{padding:10px 12px;font-size:13px;cursor:pointer;border-bottom:1px solid var(--s3);transition:background .1s}
.sdd-item:hover{background:var(--s2)}
.sdd-item.active{color:var(--y);background:#FFFBEB;font-weight:700}
.sdd-custom{color:var(--g)}
.vc-section{margin-bottom:32px}
.vc-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(164px,1fr));gap:6px}
.vc-card{background:#fff;border:1.5px solid var(--bd);padding:10px 12px;font-size:11px;font-weight:600;text-align:left;cursor:pointer;transition:all .15s;color:var(--ink);display:flex;align-items:flex-start;justify-content:space-between;gap:5px;min-height:46px;border-radius:var(--radius)}
.vc-card.free:hover{border-color:var(--y);background:#FFFBEB}
.vc-card.free.sel{border-color:var(--y);background:#FFFBEB;color:#92400E}
.vc-card.locked{opacity:.3;cursor:not-allowed}
.vc-card.more{opacity:.55;justify-content:center;align-items:center;border-style:dashed}
.vc-card.more:hover{opacity:1}
.vc-nm{flex:1;line-height:1.3}
.vc-free-badge{font-size:7px;font-weight:800;color:var(--g);background:#D1FAE5;border:1px solid #A7F3D0;padding:2px 4px;border-radius:3px;flex-shrink:0}
.vc-upgrade{margin-top:10px;background:#FFFBEB;border:1px solid #FDE68A;padding:12px 16px;display:flex;align-items:center;justify-content:space-between;gap:12px;border-radius:var(--radius);font-size:13px;font-weight:600;flex-wrap:wrap}
.search-bar{background:var(--s2);border:1.5px solid var(--bd);padding:18px 22px;display:flex;align-items:center;justify-content:space-between;gap:14px;margin-bottom:36px;flex-wrap:wrap;border-radius:var(--radius-lg)}
.search-meta{font-size:13px;color:var(--mu)}
.search-meta strong{color:var(--ink)}
.status-txt{font-size:12px;color:var(--y);margin-top:4px;animation:blink 1s ease-in-out infinite alternate}
.error-txt{font-size:12px;color:var(--r);margin-top:4px}
@keyframes blink{from{opacity:.5}to{opacity:1}}
.no-creds{background:#FEF2F2;border:1px solid #FECACA;padding:18px 22px;margin-bottom:28px;display:flex;align-items:center;justify-content:space-between;gap:14px;flex-wrap:wrap;border-radius:var(--radius-lg)}
.no-creds-title{font-size:14px;font-weight:700;color:#991B1B}
.no-creds-sub{font-size:12px;color:#B91C1C;margin-top:3px}
.res-header{display:flex;align-items:baseline;gap:10px;margin-bottom:22px;padding-bottom:14px;border-bottom:1px solid var(--bd);flex-wrap:wrap}
.res-h2{font-size:21px;font-weight:800}
.res-count{font-size:12px;color:var(--mu)}
.group-label{display:flex;align-items:center;gap:9px;margin:22px 0 9px;flex-wrap:wrap}
.group-pill{font-size:9px;font-weight:700;letter-spacing:.07em;text-transform:uppercase;padding:3px 10px;border-radius:4px}
.group-val{font-size:14px;font-weight:800}
.group-count{font-size:11px;color:var(--mu);margin-left:auto}
.fc{background:#fff;border:1px solid var(--bd);border-left:4px solid var(--clr,var(--bd));margin-bottom:7px;border-radius:0 var(--radius-lg) var(--radius-lg) 0;box-shadow:var(--shadow-sm);transition:all .15s}
.fc:hover{box-shadow:var(--shadow-md);transform:translateX(2px)}
.fc-inner{display:flex;align-items:flex-start;gap:13px;padding:15px 17px}
.fc-av{width:40px;height:40px;min-width:40px;border-radius:10px;background:var(--clr,var(--bd));color:#fff;font-size:13px;font-weight:800;display:flex;align-items:center;justify-content:center}
.fc-body{flex:1;min-width:0}
.fc-top{display:flex;align-items:flex-start;justify-content:space-between;gap:8px;margin-bottom:2px}
.fc-name{font-size:14px;font-weight:800}
.fc-meta{font-size:11px;color:var(--mu);margin-bottom:5px}
.fc-meta b{color:var(--ink);font-weight:600}
.fc-desc{font-size:12px;color:var(--mu2);line-height:1.55;margin-bottom:5px}
.fc-conn{font-size:11px;color:var(--g);font-weight:600;margin-bottom:7px}
.fc-email-row{display:flex;align-items:center;gap:7px;background:#F0FDF4;border:1px solid #A7F3D0;padding:7px 11px;border-radius:var(--radius);margin-bottom:7px}
.fc-email-addr{font-size:12px;font-family:'DM Mono',monospace;color:#065F46;flex:1;word-break:break-all}
.fc-email-conf{font-size:9px;color:#6EE7B7;font-weight:700;text-transform:uppercase;flex-shrink:0}
.fc-copy-btn{background:#fff;border:1px solid #A7F3D0;color:#065F46;font-size:10px;font-weight:700;padding:3px 8px;border-radius:4px;cursor:pointer;white-space:nowrap}
.fc-copy-btn.done{background:#ECFDF5}
.fc-actions{display:flex;gap:5px;flex-wrap:wrap}
.fc-link{font-size:10px;font-weight:600;color:var(--mu);border:1px solid var(--bd);padding:4px 9px;border-radius:5px;transition:all .15s}
.fc-link:hover{border-color:var(--ink);color:var(--ink)}
.fc-draft-btn{background:var(--ink);color:#fff;border:none;font-size:10px;font-weight:700;padding:4px 11px;border-radius:5px;cursor:pointer;transition:opacity .15s}
.fc-draft-btn:hover{opacity:.8}
.fc-portfolio-badge{font-size:9px;background:#FEF3C7;color:#92400E;border:1px solid #FDE68A;padding:2px 6px;border-radius:4px;font-weight:700;white-space:nowrap}
.share-blur-wrap{filter:blur(5px);opacity:.2;pointer-events:none;user-select:none}
.share-wall{background:#fff;border:1.5px solid var(--bd);padding:28px;border-radius:var(--radius-xl);box-shadow:var(--shadow-md);margin-top:10px}
.share-wall-title{font-size:19px;font-weight:800;margin-bottom:7px}
.share-wall-sub{font-size:13px;color:var(--mu);line-height:1.6;margin-bottom:18px}
.share-preview{background:var(--s2);border:1px solid var(--bd);padding:13px 15px;border-radius:var(--radius);margin-bottom:16px}
.share-preview-lbl{font-size:9px;font-weight:700;letter-spacing:.1em;text-transform:uppercase;color:var(--mu2);margin-bottom:6px}
.share-preview-text{font-size:12px;color:var(--mu);line-height:1.7;white-space:pre-line}
.share-actions{display:flex;flex-direction:column;gap:8px;align-items:flex-start}
.btn-copy-share{background:#fff;color:var(--g);border:1.5px solid #A7F3D0;padding:9px 18px;font-size:12px;font-weight:700;border-radius:var(--radius);cursor:pointer}
.outreach-email-bar{background:#F0FDF4;border:1px solid #A7F3D0;padding:11px 13px;border-radius:var(--radius);margin-bottom:16px;display:flex;align-items:center;gap:9px}
.outreach-email-addr{font-size:13px;font-family:'DM Mono',monospace;color:#065F46;font-weight:600;flex:1}
.ob-lbl{font-size:10px;font-weight:700;letter-spacing:.09em;text-transform:uppercase;color:var(--mu);margin-bottom:5px}
.ob-box{background:var(--s2);border:1px solid var(--bd);padding:12px 13px;font-size:12px;line-height:1.75;white-space:pre-line;border-radius:var(--radius);margin-bottom:9px;user-select:text}
.ob-textarea{width:100%;background:var(--s2);border:1.5px solid var(--y);font-size:12px;padding:11px 13px;outline:none;resize:vertical;min-height:140px;line-height:1.75;border-radius:var(--radius);margin-bottom:9px}
.ec-benefits{display:flex;flex-direction:column;gap:6px;margin-bottom:18px}
.ec-benefit{display:flex;align-items:center;gap:8px;font-size:13px}
.ec-benefit-check{color:var(--g);font-weight:700;flex-shrink:0}
.steps-indicator{display:flex;align-items:center;margin-bottom:26px}
.si-dot{width:26px;height:26px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:12px;font-weight:700;flex-shrink:0;z-index:1}
.si-dot.done{background:var(--g);color:#fff}
.si-dot.active{background:var(--ink);color:#fff}
.si-dot.todo{background:var(--s3);color:var(--mu)}
.si-line{flex:1;height:2px;background:var(--bd)}
.si-line.done{background:var(--g)}
.analysis-box{text-align:center;padding:14px 0}
.analysis-spinner{font-size:42px;animation:spin-slow 2.5s linear infinite;display:block;margin:0 auto 14px}
@keyframes spin-slow{to{transform:rotate(360deg)}}
.analysis-bar-bg{background:var(--s3);border-radius:100px;height:6px;margin:18px 0;overflow:hidden}
.analysis-bar-fill{height:100%;background:linear-gradient(90deg,var(--y),var(--g));border-radius:100px;transition:width .4s ease}
.analysis-steps-list{text-align:left;margin:14px 0}
.analysis-step-row{display:flex;align-items:center;gap:8px;font-size:13px;color:var(--mu);padding:5px 0}
.analysis-step-row.done{color:var(--g);font-weight:600}
.match-reveal{background:linear-gradient(135deg,#FFFBEB,#FEF3C7);border:2px solid var(--y);border-radius:var(--radius-lg);padding:24px;text-align:center;margin:18px 0}
.match-number{font-size:58px;font-weight:800;color:var(--ink);letter-spacing:-2px;font-family:'DM Mono',monospace;line-height:1}
.match-label{font-size:13px;color:var(--mu);margin-top:5px}
.phone-row{display:flex;gap:8px;margin-bottom:20px;width:100%;box-sizing:border-box}
.cc-select{background:var(--s2);border:1.5px solid var(--bd);color:var(--ink);font-size:13px;font-weight:600;padding:0 8px;border-radius:var(--radius);outline:none;cursor:pointer;flex-shrink:0;width:90px;min-width:0;transition:border-color .15s;height:50px;-webkit-appearance:none;appearance:none}
.cc-select:focus{border-color:var(--y)}
.phone-inp{flex:1;min-width:0;background:var(--s2);border:1.5px solid var(--bd);color:var(--ink);font-size:15px;padding:13px 14px;border-radius:var(--radius);outline:none;transition:border-color .15s;font-family:inherit;box-sizing:border-box;width:100%}
.phone-inp:focus{border-color:var(--y);background:#fff}
.phone-inp::placeholder{color:var(--mu3)}
.otp-input{width:100%;background:var(--s2);border:2px solid var(--bd);color:var(--ink);font-family:'DM Mono',monospace;font-size:26px;letter-spacing:.4em;padding:13px;text-align:center;outline:none;border-radius:var(--radius);transition:border-color .15s;margin-bottom:14px}
.otp-input:focus{border-color:var(--y);background:#fff}

.search-loading{background:#fff;border:1px solid var(--bd);border-radius:var(--radius-xl);padding:36px 32px;margin-bottom:12px;box-shadow:var(--shadow-sm)}
.sl-title{font-size:18px;font-weight:800;margin-bottom:6px}
.sl-sub{font-size:13px;color:var(--mu);margin-bottom:28px;line-height:1.6}
.sl-steps{display:flex;flex-direction:column;gap:10px;margin-bottom:24px}
.sl-step{display:flex;align-items:center;gap:12px;padding:12px 16px;border-radius:var(--radius-lg);border:1.5px solid var(--bd);background:#fff;transition:all .4s}
.sl-step.active{border-color:var(--y);background:#FFFBEB}
.sl-step.done{border-color:#A7F3D0;background:#F0FDF4}
.sl-step.done .sl-step-ic{background:var(--g);color:#fff}
.sl-step.active .sl-step-ic{background:var(--y);color:#000;animation:pulse-ic .8s ease-in-out infinite alternate}
@keyframes pulse-ic{from{transform:scale(1)}to{transform:scale(1.1)}}
.sl-step-ic{width:32px;height:32px;border-radius:8px;background:var(--s3);display:flex;align-items:center;justify-content:center;font-size:15px;flex-shrink:0;transition:all .3s}
.sl-step-body{flex:1}
.sl-step-title{font-size:13px;font-weight:700;color:var(--ink);margin-bottom:2px}
.sl-step-desc{font-size:11px;color:var(--mu);line-height:1.5}
.sl-step-check{font-size:14px;color:var(--g);flex-shrink:0;opacity:0;transition:opacity .3s}
.sl-step.done .sl-step-check{opacity:1}
.sl-bar-wrap{height:4px;background:var(--s3);border-radius:100px;overflow:hidden;margin-bottom:10px}
.sl-bar{height:100%;background:linear-gradient(90deg,var(--y),var(--g));border-radius:100px;transition:width 1.2s ease}
.sl-bar-label{font-size:11px;color:var(--mu);display:flex;justify-content:space-between}
.sl-found-ticker{display:flex;align-items:center;gap:8px;padding:10px 16px;background:var(--s2);border-radius:var(--radius);font-size:12px;color:var(--mu);margin-top:4px}
.sl-found-n{font-size:15px;font-weight:800;color:var(--g);font-family:'DM Mono',monospace;min-width:24px}
.skel{background:linear-gradient(90deg,var(--s3) 25%,#ebebeb 50%,var(--s3) 75%);background-size:200% 100%;animation:shimmer 1.5s infinite;margin-bottom:8px;border-radius:var(--radius-lg)}
@keyframes shimmer{0%{background-position:200% 0}100%{background-position:-200% 0}}
.adm-layout{display:flex;min-height:100vh;background:#F8F9FA}
.adm-sidebar{width:216px;min-width:216px;background:#fff;border-right:1px solid var(--bd);display:flex;flex-direction:column;padding:22px 0;position:sticky;top:0;height:100vh}
.adm-logo{padding:0 20px 24px;font-size:16px;font-weight:800}
.adm-logo em{font-style:normal;color:var(--y)}
.adm-nav-section{font-size:9px;font-weight:700;letter-spacing:.15em;text-transform:uppercase;color:var(--mu3);padding:0 20px;margin-bottom:4px;margin-top:14px}
.adm-nav-item{display:flex;align-items:center;gap:8px;padding:9px 20px;font-size:13px;font-weight:600;color:var(--mu);cursor:pointer;transition:all .12s;border-left:3px solid transparent}
.adm-nav-item:hover{color:var(--ink);background:#F9FAFB}
.adm-nav-item.on{color:var(--ink);border-left-color:var(--y);background:#FFFBEB}
.adm-period{margin-top:auto;padding:0 12px 8px}
.adm-period select{width:100%;background:var(--s2);border:1px solid var(--bd);font-size:12px;padding:7px 9px;outline:none;border-radius:var(--radius)}
.adm-main{flex:1;overflow:auto;padding:32px 36px 80px}
.adm-header{display:flex;align-items:flex-start;justify-content:space-between;margin-bottom:22px;flex-wrap:wrap;gap:12px}
.adm-title{font-size:20px;font-weight:800}
.adm-subtitle{font-size:12px;color:var(--mu);margin-top:3px}
.adm-refresh{background:#fff;border:1px solid var(--bd);color:var(--mu);font-size:12px;font-weight:600;padding:7px 13px;border-radius:var(--radius);box-shadow:var(--shadow-sm);cursor:pointer;transition:all .12s}
.adm-refresh:hover{border-color:#aaa;color:var(--ink)}
.adm-login-wrap{min-height:100vh;display:flex;align-items:center;justify-content:center;background:#F8F9FA}
.adm-login-box{background:#fff;border:1px solid var(--bd);padding:40px 32px;max-width:340px;width:100%;text-align:center;border-radius:var(--radius-xl);box-shadow:var(--shadow-lg)}
.adm-login-logo{font-size:19px;font-weight:800;margin-bottom:4px}
.adm-login-logo em{font-style:normal;color:var(--y)}
.adm-login-sub{font-size:13px;color:var(--mu);margin-bottom:22px}
.adm-stat-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(152px,1fr));gap:9px;margin-bottom:20px}
.adm-stat{background:#fff;border:1px solid var(--bd);padding:16px 18px;border-radius:9px;position:relative;overflow:hidden;box-shadow:var(--shadow-sm)}
.adm-stat::before{content:'';position:absolute;top:0;left:0;right:0;height:3px;background:var(--acc,#eee);border-radius:3px 3px 0 0}
.adm-stat-ic{font-size:17px;margin-bottom:8px}
.adm-stat-v{font-size:24px;font-weight:800;font-family:'DM Mono',monospace;letter-spacing:-1px;line-height:1}
.adm-stat-l{font-size:10px;color:var(--mu);text-transform:uppercase;letter-spacing:.08em;margin-top:4px;font-weight:600}
.adm-chart-wrap{background:#fff;border:1px solid var(--bd);padding:18px 18px 6px;margin-bottom:16px;border-radius:9px}
.adm-chart-title{font-size:13px;font-weight:700;margin-bottom:14px;display:flex;align-items:center;gap:10px;flex-wrap:wrap}
.adm-legend{display:flex;gap:10px;flex-wrap:wrap;margin-left:auto}
.adm-leg-item{display:flex;align-items:center;gap:5px;font-size:11px;color:var(--mu);font-weight:500}
.adm-leg-dot{width:7px;height:7px;border-radius:2px}
.adm-bars{display:flex;align-items:flex-end;gap:3px;height:90px;overflow-x:auto;padding-bottom:20px;position:relative}
.adm-bars::after{content:'';position:absolute;bottom:20px;left:0;right:0;height:1px;background:var(--bd)}
.adm-bar-col{display:flex;flex-direction:column;align-items:center;min-width:20px;flex:1}
.adm-bar-segs{display:flex;flex-direction:column;justify-content:flex-end;height:70px;width:100%;gap:1px}
.adm-bar-seg{width:100%;min-height:2px;border-radius:2px 2px 0 0}
.adm-bar-seg:hover{opacity:.7}
.adm-bar-lbl{font-size:7px;color:var(--mu);font-family:'DM Mono',monospace;white-space:nowrap;transform:rotate(-45deg);margin-top:4px;transform-origin:top center}
.adm-2col{display:grid;grid-template-columns:1fr 1fr;gap:12px;margin-bottom:16px}
.adm-panel{background:#fff;border:1px solid var(--bd);padding:16px 18px;border-radius:9px;box-shadow:var(--shadow-sm)}
.adm-panel-title{font-size:10px;font-weight:700;letter-spacing:.09em;text-transform:uppercase;color:var(--mu);margin-bottom:12px}
.adm-rank-row{display:flex;align-items:center;gap:8px;padding:6px 0;border-bottom:1px solid var(--s3);font-size:12px}
.adm-rank-row:last-child{border-bottom:none}
.adm-rank-n{font-size:9px;font-weight:700;color:var(--mu3);width:13px;font-family:'DM Mono',monospace}
.adm-rank-lbl{flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}
.adm-rank-bar-wrap{width:56px;height:4px;background:var(--s3);border-radius:2px}
.adm-rank-bar{height:100%;border-radius:2px;transition:width .4s}
.adm-rank-count{font-size:10px;color:var(--mu);font-family:'DM Mono',monospace;min-width:20px;text-align:right;font-weight:600}
.adm-feed-wrap{background:#fff;border:1px solid var(--bd);border-radius:9px;overflow:hidden;margin-bottom:16px}
.adm-feed-hdr{padding:12px 18px;font-size:10px;font-weight:700;letter-spacing:.09em;text-transform:uppercase;color:var(--mu);border-bottom:1px solid var(--bd)}
.adm-feed-row{border-bottom:1px solid var(--s3)}
.adm-feed-row:last-child{border-bottom:none}
.adm-feed-top{display:flex;align-items:flex-start;gap:8px;padding:10px 14px;cursor:pointer;transition:background .1s}
.adm-feed-top:hover{background:#FAFAFA}
.adm-feed-ic{font-size:13px;width:17px;text-align:center;flex-shrink:0}
.adm-feed-badge{font-size:9px;font-weight:700;letter-spacing:.04em;text-transform:uppercase;padding:2px 6px;border-radius:4px;flex-shrink:0;line-height:1.4}
.adm-feed-sum{flex:1;font-size:11px;color:#777;line-height:1.6}
.adm-feed-sum strong{color:var(--ink);font-weight:700}
.adm-feed-time{font-size:9px;color:var(--mu);font-family:'DM Mono',monospace;white-space:nowrap}
.adm-expand{padding:0 14px 12px 39px}
.adm-exp-subj-row{display:flex;align-items:center;gap:7px;margin-bottom:6px}
.adm-exp-subj-lbl{font-size:8px;font-weight:700;letter-spacing:.1em;text-transform:uppercase;color:var(--mu);flex-shrink:0}
.adm-exp-subj-val{font-size:13px;font-weight:700}
.adm-exp-body-lbl{font-size:8px;font-weight:700;letter-spacing:.1em;text-transform:uppercase;color:var(--mu);margin-bottom:5px}
.adm-exp-body{background:var(--s2);border:1px solid var(--bd);border-radius:6px;padding:10px 12px;font-size:12px;line-height:1.75;white-space:pre-line;margin-bottom:7px;user-select:text}
.adm-copy-btn{display:inline-flex;align-items:center;gap:4px;background:var(--ink);color:#fff;border:none;padding:5px 11px;font-size:11px;font-weight:700;border-radius:5px;margin-right:5px;cursor:pointer;transition:opacity .15s}
.adm-copy-btn:hover{opacity:.85}
.adm-copy-btn.done{background:var(--g)}
.adm-copy-btn.addr{background:#EEF2FF;color:#4338CA}
.adm-open-mail{display:inline-flex;align-items:center;gap:4px;background:#F0FDF4;color:#15803D;border:1px solid #BBF7D0;padding:4px 10px;font-size:11px;font-weight:700;border-radius:5px}
.adm-loading{display:flex;align-items:center;justify-content:center;min-height:50vh;font-size:13px;color:var(--mu);gap:8px}
.adm-spinner{width:15px;height:15px;border:2px solid var(--bd);border-top-color:var(--y);border-radius:50%;animation:spin .6s linear infinite}
.adm-empty{padding:24px;text-align:center;font-size:13px;color:var(--mu)}
.adm-text-inp{background:var(--s2);border:1.5px solid var(--bd);font-size:13px;padding:8px 11px;outline:none;border-radius:var(--radius);transition:border-color .15s;width:100%}
.adm-text-inp:focus{border-color:var(--y)}
.adm-text-inp::placeholder{color:var(--mu3)}
.adm-add-btn{background:var(--ink);color:#fff;border:none;padding:8px 16px;font-size:13px;font-weight:700;border-radius:var(--radius);white-space:nowrap;cursor:pointer;transition:opacity .15s}
.adm-add-btn:hover{opacity:.85}
.adm-add-btn:disabled{opacity:.5}
.adm-angel-row{display:flex;align-items:center;gap:9px;padding:9px 0;border-bottom:1px solid var(--s3)}
.adm-angel-row:last-child{border-bottom:none}
.adm-angel-av{width:30px;height:30px;border-radius:50%;background:var(--y);color:#000;font-size:10px;font-weight:800;display:flex;align-items:center;justify-content:center;flex-shrink:0}
.adm-angel-info{flex:1;min-width:0}
.adm-angel-name{font-size:13px;font-weight:700}
.adm-angel-sub{font-size:11px;color:var(--mu)}
.adm-del-btn{background:none;border:1px solid #FECACA;color:var(--r);font-size:11px;font-weight:600;padding:3px 8px;border-radius:4px;cursor:pointer}
.adm-del-btn:hover{background:#FEF2F2}
.adm-product-row{padding:10px 0;border-bottom:1px solid var(--s3)}
.adm-product-row:last-child{border-bottom:none}
.adm-product-url{font-size:13px;font-weight:700;margin-bottom:2px}
.adm-product-url a{color:var(--bl)}
.adm-product-meta{font-size:11px;color:var(--mu);margin-top:2px}
.verified-badge{display:inline-block;font-size:9px;font-weight:700;padding:2px 6px;border-radius:4px;background:#D1FAE5;color:#065F46;margin-left:5px}
.pending-badge{display:inline-block;font-size:9px;font-weight:700;padding:2px 6px;border-radius:4px;background:#FEF3C7;color:#92400E;margin-left:5px}
.adm-sms-area{width:100%;background:var(--s2);border:1.5px solid var(--bd);font-size:13px;padding:11px;outline:none;border-radius:var(--radius);resize:vertical;min-height:96px;margin-bottom:11px;line-height:1.6}
.adm-sms-area:focus{border-color:var(--y)}
.adm-sms-send{background:#0A66C2;color:#fff;border:none;padding:10px 22px;font-size:13px;font-weight:700;border-radius:var(--radius);cursor:pointer;transition:opacity .15s}
.adm-sms-send:hover:not(:disabled){opacity:.9}
.adm-sms-send:disabled{opacity:.5;cursor:not-allowed}
@keyframes spin{to{transform:rotate(360deg)}}

.products-section{background:#fff;padding:72px 48px;border-top:1px solid var(--bd)}
.products-inner{max-width:1080px;margin:0 auto}
.product-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:14px;margin-top:44px}
.product-card{background:#fff;border:1px solid var(--bd);border-radius:var(--radius-xl);overflow:hidden;box-shadow:var(--shadow-sm);transition:all .2s;cursor:default}
.product-card:hover{box-shadow:var(--shadow-lg);transform:translateY(-3px)}
.product-card-top{padding:22px 22px 14px;position:relative}
.product-card-logo{width:44px;height:44px;border-radius:10px;display:flex;align-items:center;justify-content:center;font-size:20px;margin-bottom:12px;flex-shrink:0}
.product-card-name{font-size:16px;font-weight:800;color:var(--ink);margin-bottom:4px}
.product-card-tagline{font-size:13px;color:var(--mu);line-height:1.5;margin-bottom:10px;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden}
.product-card-tags{display:flex;gap:6px;flex-wrap:wrap;margin-bottom:14px}
.product-tag{font-size:10px;font-weight:600;padding:3px 9px;border-radius:100px;letter-spacing:.04em}
.product-card-divider{height:1px;background:var(--bd);margin:0 -0px}
.product-card-stats{display:flex;gap:0;padding:14px 22px 18px}
.product-stat{flex:1;text-align:center;padding:0 10px;border-right:1px solid var(--bd)}
.product-stat:last-child{border-right:none}
.product-stat-n{font-size:16px;font-weight:800;color:var(--ink);font-family:'DM Mono',monospace;letter-spacing:-.5px}
.product-stat-l{font-size:9px;color:var(--mu);text-transform:uppercase;letter-spacing:.1em;margin-top:3px;font-weight:600}
.product-card-funding{display:flex;align-items:center;justify-content:space-between;padding:0 22px 16px;flex-wrap:wrap;gap:8px}
.product-funding-ask{font-size:12px;font-weight:700;color:var(--ink)}
.product-funding-type{font-size:10px;color:var(--mu);font-weight:500}
.product-card-badge{position:absolute;top:16px;right:16px;font-size:9px;font-weight:700;padding:3px 8px;border-radius:100px;letter-spacing:.05em;text-transform:uppercase}
@media(max-width:1100px){.product-grid{grid-template-columns:repeat(3,1fr)}}@media(max-width:700px){.product-grid{grid-template-columns:repeat(2,1fr)}}
@media(max-width:480px){.product-grid{grid-template-columns:1fr}.products-section{padding:44px 14px}}

/* ── TABLET ── */
@media(max-width:900px){
  .feat-grid,.testi-grid{grid-template-columns:1fr 1fr}
  .angel-grid{grid-template-columns:repeat(2,1fr)}
  .adm-2col{grid-template-columns:1fr}
  .product-grid{grid-template-columns:repeat(2,1fr)}
  .nav-links{display:none}
}

/* ── MOBILE ── */
@media(max-width:640px){
  /* nav */
  .nav{padding:12px 16px;gap:8px}
  .nav-logo{font-size:16px}
  .nav-actions{gap:6px}
  .btn-nav{padding:7px 14px;font-size:12px}

  /* angel hero */
  .angel-hero{padding:44px 16px 36px}
  .angel-h1{font-size:clamp(28px,7vw,40px)}
  .angel-sub{font-size:14px}
  .angel-grid{grid-template-columns:1fr 1fr;gap:8px}
  .angel-av{width:32px;height:32px;font-size:11px}
  .angel-name{font-size:12px}
  .angel-role{font-size:10px}
  .angel-notable{font-size:10px}
  .angel-stats-row{display:grid;grid-template-columns:1fr 1fr}
  .angel-stat{border-right:none;border-bottom:1px solid rgba(255,255,255,.08);padding:14px 12px}
  .angel-stat-n{font-size:22px}
  .angel-ctas{flex-direction:column;align-items:stretch;gap:10px}
  .angel-ctas button{width:100%;text-align:center}

  /* products */
  .product-grid{grid-template-columns:1fr 1fr;gap:10px}
  .product-card-top{padding:14px 14px 10px}
  .product-card-logo{width:36px;height:36px;font-size:16px}
  .product-card-name{font-size:13px}
  .product-card-tagline{font-size:11px}
  .products-section{padding:40px 14px}

  /* hero */
  .hero{padding:44px 16px}
  .hero-h1{font-size:clamp(36px,9vw,52px);letter-spacing:-1px}
  .hero-sub{font-size:15px}
  .hero-perks{gap:10px}
  .hero-perk{font-size:11px}

  /* proof / stats */
  .proof-bar{padding:10px 16px}
  .proof-items{gap:16px}
  .proof-item{font-size:11px}
  .stats-strip{flex-wrap:wrap;padding:20px 16px;gap:0}
  .stat-item{flex:1 1 48%;border-right:none;border-bottom:1px solid var(--bd);padding:12px 10px;text-align:center}
  .stat-n{font-size:26px}

  /* sections */
  .section{padding:44px 16px}
  .section-title{font-size:clamp(22px,6vw,32px)}
  .feat-grid,.testi-grid{grid-template-columns:1fr;gap:12px}
  .steps-wrap{margin-top:28px}
  .band{padding:10px 16px;gap:6px}
  .band-rule{display:none}
  .cta-band{padding:44px 16px}
  .cta-band-title{font-size:clamp(22px,6vw,32px)}
  .footer{padding:32px 16px 20px}
  .footer-chips{gap:5px 10px}

  /* tool */
  .tool-wrap{padding:18px 12px 80px}
  .tool-topbar{flex-wrap:wrap;gap:8px;margin-bottom:20px}
  .sdd-grid{grid-template-columns:1fr;gap:10px}
  .vc-grid{grid-template-columns:repeat(auto-fill,minmax(130px,1fr))}
  .search-bar,.no-creds{flex-direction:column;align-items:stretch;gap:10px}
  .fc-inner{gap:10px;padding:13px 14px}
  .fc-av{display:none}
  .fc-email-row{flex-wrap:wrap;gap:6px}
  .fc-actions{flex-wrap:wrap}

  /* admin */
  .adm-layout{flex-direction:column}
  .adm-sidebar{width:100%;min-width:0;height:auto;position:sticky;top:0;z-index:40;flex-direction:row;padding:8px 10px;overflow-x:auto;gap:2px;border-right:none;border-bottom:1px solid var(--bd);background:#fff}
  .adm-logo{padding:0;font-size:13px;margin-right:6px;white-space:nowrap;align-self:center}
  .adm-nav-section{display:none}
  .adm-nav-item{white-space:nowrap;padding:6px 8px;border-left:none;border-bottom:3px solid transparent;border-radius:0;font-size:12px}
  .adm-nav-item.on{border-bottom-color:var(--y);border-left-color:transparent;background:transparent}
  .adm-main{padding:12px 10px 60px}
  .adm-period{margin-top:0;margin-left:auto;align-self:center;padding:0 6px 0 0}
  .adm-period select{width:auto;font-size:11px}
  .adm-stat-grid{grid-template-columns:repeat(2,1fr);gap:8px}
  .adm-stat{padding:12px 14px}
  .adm-stat-v{font-size:20px}
  .adm-2col{grid-template-columns:1fr}
  .adm-header{flex-direction:column;gap:8px;align-items:flex-start}
  .adm-bars{height:70px}
  .adm-bar-segs{height:52px}

  /* dashboards */
  .credits-badge{padding:5px 10px;gap:6px}
  .credits-n{font-size:14px}
}

/* ── VERY SMALL ── */
@media(max-width:380px){
  .angel-grid{grid-template-columns:1fr}
  .product-grid{grid-template-columns:1fr}
  .adm-stat-grid{grid-template-columns:1fr 1fr}
  .hero-h1{font-size:32px}
}
/* ── CHAT MOBILE ── */
@media(max-width:640px){
  .msg-credits{padding:5px 10px;font-size:12px}
  .msg-credits-n{font-size:15px}
}

/* ════════════════════════════════════
   DASHBOARD - MOBILE RESPONSIVE
════════════════════════════════════ */

/* Topbar */
.dash-topbar{display:flex;align-items:center;justify-content:space-between;padding:0 24px;height:58px;background:#fff;border-bottom:1px solid #F3F4F6;position:sticky;top:0;z-index:50}
@media(max-width:640px){
  .dash-topbar{padding:0 14px;height:52px}
}

/* Tab nav */
.dash-tabs{background:#fff;border-bottom:1px solid #F3F4F6;padding:0 24px;display:flex;gap:0;overflow-x:auto;-webkit-overflow-scrolling:touch;scrollbar-width:none}
.dash-tabs::-webkit-scrollbar{display:none}
.dash-tab{padding:14px 20px;border:none;border-bottom:2px solid transparent;background:none;font-size:13px;font-weight:500;color:#9CA3AF;cursor:pointer;transition:all .15s;white-space:nowrap;flex-shrink:0}
.dash-tab.active{font-weight:700;color:#0f0f0f;border-bottom-color:#F59E0B}
@media(max-width:640px){
  .dash-tabs{padding:0 8px}
  .dash-tab{padding:12px 14px;font-size:12px}
}

/* Content area */
.dash-content{max-width:1000px;margin:0 auto;padding:24px 20px 80px}
@media(max-width:640px){
  .dash-content{padding:16px 12px 80px}
}

/* Angel grid */
.angel-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(280px,1fr));gap:12px}
@media(max-width:640px){
  .angel-grid{grid-template-columns:1fr;gap:10px}
}

/* ── INBOX MOBILE - full screen single pane ── */
.inbox-wrap{background:#fff;border:1px solid #E5E7EB;border-radius:16px;overflow:hidden;display:grid;grid-template-columns:280px 1fr;min-height:560px}
@media(max-width:700px){
  .inbox-wrap{grid-template-columns:1fr;border-radius:12px;min-height:0}
  .inbox-list-col{border-right:none!important;border-bottom:1px solid #F3F4F6}
  .inbox-chat-col{display:none}
  .inbox-chat-col.active{display:flex;position:fixed;inset:0;z-index:200;background:#fff;flex-direction:column}
  .inbox-back-btn{display:flex!important}
}
.inbox-back-btn{display:none;align-items:center;gap:8px;background:none;border:none;font-size:14px;font-weight:600;color:#0f0f0f;cursor:pointer;padding:14px 18px;border-bottom:1px solid #F3F4F6;flex-shrink:0}
@media(max-width:700px){
  .inbox-back-btn{display:flex!important}
  .inbox-close-x{display:none!important}
}

/* Credits badge compact on mobile */
@media(max-width:640px){
  .credits-badge-label{display:none}
  .credits-badge{padding:5px 10px!important}
}

/* Profile grid */
.profile-fields-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(180px,1fr));gap:10px}
@media(max-width:640px){
  .profile-fields-grid{grid-template-columns:1fr 1fr}
}

/* Pricing modal grid */
.tier-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:14px}
@media(max-width:640px){
  .tier-grid{grid-template-columns:1fr;gap:10px}
}

/* Buy credits modal */
@media(max-width:640px){
  .buy-modal-inner{padding:24px 18px!important;margin:8px!important}
}

/* Bulk compose modal */
@media(max-width:640px){
  .bulk-modal-inner{padding:20px 16px!important}
}

/* Select mode bar */
.select-bar{display:flex;align-items:center;justify-content:space-between;gap:10px;flex-wrap:wrap}
@media(max-width:640px){
  .select-bar{flex-direction:column;align-items:stretch;gap:8px}
}

/* Login card */
.login-card{background:#fff;border:1px solid #E5E7EB;border-radius:20px;padding:40px 36px;max-width:400px;width:100%;box-shadow:0 4px 24px rgba(0,0,0,.06)}
@media(max-width:480px){
  .login-card{padding:28px 20px;border-radius:16px;border:none;box-shadow:none}
}


/* ════════════════════════════════════
   HOMEPAGE - MOBILE RESPONSIVE
════════════════════════════════════ */
.hp-nav{display:flex;align-items:center;justify-content:space-between;padding:0 40px;height:60px;border-bottom:1px solid #F3F4F6;background:rgba(255,255,255,.95);backdrop-filter:blur(12px);position:sticky;top:0;z-index:100}
.hp-nav-links{display:flex;align-items:center;gap:24px}
.hp-nav-link{font-size:13px;font-weight:500;color:#6B7280;text-decoration:none}
.hp-nav-cta{background:#0f0f0f;color:#fff;border:none;padding:9px 20px;font-size:13px;font-weight:600;border-radius:8px;cursor:pointer}

.hp-hero{background:#fff;border-bottom:1px solid #F3F4F6;padding:80px 48px 72px;text-align:center;position:relative;overflow:hidden}
.hp-hero-inner{position:relative;max-width:760px;margin:0 auto}
.hp-hero h1{font-size:clamp(32px,6vw,64px);font-weight:800;line-height:1.08;letter-spacing:-1.5px;color:#0f0f0f;margin-bottom:20px}
.hp-hero p{font-size:18px;color:#6B7280;line-height:1.7;max-width:520px;margin:0 auto 36px}
.hp-hero-btns{display:flex;gap:12px;justify-content:center;flex-wrap:wrap;margin-bottom:48px}
.hp-hero-btn-primary{background:#0f0f0f;color:#fff;border:none;padding:16px 36px;font-size:15px;font-weight:700;border-radius:10px;cursor:pointer;letter-spacing:-.3px;transition:opacity .15s}
.hp-hero-btn-secondary{background:#fff;color:#0f0f0f;border:1.5px solid #E5E7EB;padding:16px 32px;font-size:15px;font-weight:600;border-radius:10px;cursor:pointer;text-decoration:none;display:inline-flex;align-items:center;gap:8px;transition:border-color .15s}

.hp-stats{display:grid;grid-template-columns:repeat(4,1fr);border-top:1px solid #F3F4F6;border-bottom:1px solid #F3F4F6}
.hp-stat{padding:20px 24px;text-align:center;border-right:1px solid #F3F4F6}
.hp-stat:last-child{border-right:none}
.hp-stat-n{font-size:22px;font-weight:800;color:#0f0f0f;letter-spacing:-1px;margin-bottom:2px}
.hp-stat-l{font-size:11px;color:#9CA3AF;font-weight:600;text-transform:uppercase;letter-spacing:.08em}

.hp-section{padding:64px 48px}
.hp-section-inner{max-width:960px;margin:0 auto}
.hp-section-eyebrow{font-size:12px;font-weight:700;letter-spacing:.1em;text-transform:uppercase;color:#F59E0B;margin-bottom:12px}
.hp-section-title{font-size:clamp(22px,3.5vw,32px);font-weight:800;letter-spacing:-1px;color:#0f0f0f;line-height:1.2}

.hp-steps{display:grid;grid-template-columns:repeat(3,1fr);gap:24px;margin-top:40px}
.hp-step{background:#fff;border:1px solid #E5E7EB;border-radius:16px;padding:28px 24px;position:relative;overflow:hidden}
.hp-step-num{position:absolute;top:14px;right:18px;font-size:48px;font-weight:800;color:#F3F4F6;line-height:1;letter-spacing:-2px;user-select:none}
.hp-step-icon{font-size:28px;margin-bottom:14px}
.hp-step-title{font-size:16px;font-weight:700;color:#0f0f0f;margin-bottom:8px}
.hp-step-desc{font-size:14px;color:#6B7280;line-height:1.65}

.hp-newsletter{display:grid;grid-template-columns:1fr 1fr;gap:64px;align-items:center}
.hp-nl-mockup{background:#FAFAFA;border:1.5px solid #E5E7EB;border-radius:20px;overflow:hidden;box-shadow:0 20px 60px rgba(0,0,0,.06)}
.hp-nl-bar{background:#0f0f0f;padding:14px 20px;display:flex;align-items:center;gap:8px}
.hp-nl-dot{width:10px;height:10px;border-radius:50%}
.hp-nl-title{flex:1;text-align:center;font-size:11px;color:rgba(255,255,255,.4);font-family:monospace}
.hp-nl-body{padding:20px 22px}
.hp-nl-row{background:#fff;border:1px solid #E5E7EB;border-radius:10px;padding:12px 14px;display:flex;align-items:center;justify-content:space-between;gap:10;margin-bottom:10px}

.hp-angels-header{display:flex;align-items:flex-end;justify-content:space-between;margin-bottom:36px;flex-wrap:wrap;gap:12px}
.hp-angels-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:14px}
.hp-angel-card{background:#fff;border:1px solid #E5E7EB;border-radius:14px;padding:18px 16px}
.hp-angel-av{width:40px;height:40px;border-radius:10px;font-size:14px;font-weight:800;display:flex;align-items:center;justify-content:center;margin-bottom:10px;letter-spacing:-.5px}
.hp-angel-name{font-size:13px;font-weight:700;color:#0f0f0f;margin-bottom:2px;line-height:1.3}
.hp-angel-title{font-size:11px;color:#9CA3AF;margin-bottom:8px;line-height:1.4}
.hp-angel-focus{font-size:10px;background:#F9FAFB;border:1px solid #E5E7EB;color:#6B7280;padding:3px 8px;border-radius:6px;font-weight:600;line-height:1.4}
.hp-angel-verified{font-size:10px;color:#10B981;font-weight:700;margin-top:6px}

.hp-footer{border-top:1px solid #F3F4F6;padding:48px 48px 32px;background:#fff}
.hp-footer-inner{max-width:960px;margin:0 auto}
.hp-footer-grid{display:grid;grid-template-columns:2fr 1fr 1fr 1fr;gap:40px;margin-bottom:40px}
.hp-footer-col-title{font-size:11px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:#9CA3AF;margin-bottom:14px}
.hp-footer-link{display:block;font-size:13px;color:#6B7280;text-decoration:none;margin-bottom:8px}
.hp-footer-bottom{border-top:1px solid #F3F4F6;padding-top:24px;display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:12px}
.hp-footer-badges{display:flex;gap:16px}
.hp-footer-badge{font-size:11px;color:#D1D5DB;font-weight:600}

/* ── HOMEPAGE TABLET ── */
@media(max-width:900px){
  .hp-steps{grid-template-columns:1fr 1fr}
  .hp-newsletter{grid-template-columns:1fr;gap:36px}
  .hp-nl-mockup{display:none}
  .hp-angels-grid{grid-template-columns:repeat(3,1fr)}
  .hp-footer-grid{grid-template-columns:1fr 1fr;gap:28px}
  .hp-footer-badges{display:none}
}

/* ── HOMEPAGE MOBILE ── */
@media(max-width:640px){
  .hp-nav{padding:0 16px;height:54px}
  .hp-nav-links{gap:14px}
  .hp-nav-link{display:none}
  .hp-nav-link:last-of-type{display:block}
  .hp-nav-cta{padding:8px 16px;font-size:12px}

  .hp-hero{padding:44px 18px 48px}
  .hp-hero p{font-size:16px}
  .hp-hero-btns{flex-direction:column;align-items:stretch;margin-bottom:32px}
  .hp-hero-btn-primary,.hp-hero-btn-secondary{width:100%;justify-content:center;padding:15px 24px}

  .hp-stats{grid-template-columns:1fr 1fr}
  .hp-stat{padding:14px 12px}
  .hp-stat:nth-child(2){border-right:none}
  .hp-stat:nth-child(3){border-right:1px solid #F3F4F6;border-top:1px solid #F3F4F6}
  .hp-stat:nth-child(4){border-top:1px solid #F3F4F6;border-right:none}
  .hp-stat-n{font-size:18px}
  .hp-stat-l{font-size:10px}

  .hp-section{padding:44px 18px}
  .hp-section-title{font-size:22px}
  .hp-steps{grid-template-columns:1fr;gap:12px;margin-top:28px}
  .hp-step{padding:22px 18px}
  .hp-step-num{font-size:36px;top:12px;right:14px}

  .hp-newsletter{grid-template-columns:1fr;gap:28px}
  .hp-nl-mockup{display:none}

  .hp-angels-header{flex-direction:column;align-items:flex-start;margin-bottom:24px}
  .hp-angels-grid{grid-template-columns:repeat(2,1fr);gap:10px}
  .hp-angel-card{padding:14px 12px}
  .hp-angel-av{width:34px;height:34px;font-size:12px;border-radius:8px}
  .hp-angel-name{font-size:12px}
  .hp-angel-title{font-size:10px}

  .hp-footer{padding:36px 18px 24px}
  .hp-footer-grid{grid-template-columns:1fr;gap:20px}
  .hp-footer-bottom{flex-direction:column;align-items:flex-start;gap:8px}
}

@media(max-width:380px){
  .hp-angels-grid{grid-template-columns:1fr}
  .hp-steps{gap:10px}
}

`;

// Inject styles immediately at module level - prevents FOUC
(function(){
  if(typeof document==='undefined')return;
  if(document.getElementById('wi-styles'))return;
  const el=document.createElement('style');
  el.id='wi-styles';
  el.textContent=STYLES;
  document.head.appendChild(el);
})();

// ─── SHARED COMPONENTS ───────────────────────────────────────────────────────

function SearchableDropdown({label,placeholder,options,value,onChange}){
  const[open,setOpen]=useState(false);const[q,setQ]=useState('');const ref=useRef(null);
  const filtered=options.filter(o=>o.toLowerCase().includes(q.toLowerCase())).slice(0,40);
  useEffect(()=>{const h=e=>{if(ref.current&&!ref.current.contains(e.target))setOpen(false)};document.addEventListener('mousedown',h);return()=>document.removeEventListener('mousedown',h)},[]);
  return(
    <div className="sdd-wrap" ref={ref}>
      <label className="sdd-lbl">{label}</label>
      <div className={`sdd-trigger${open?' open':''}`} onClick={()=>setOpen(o=>!o)}>
        <span className={value?'':'sdd-ph'}>{value||placeholder}</span>
        <div style={{display:'flex',alignItems:'center',gap:5}}>
          {value&&<button className="sdd-x" onClick={e=>{e.stopPropagation();onChange('');setQ('')}}>x</button>}
          <span className="sdd-arr">{open?'▲':'▼'}</span>
        </div>
      </div>
      {open&&(
        <div className="sdd-menu">
          <input className="sdd-search" placeholder="Search..." value={q} onChange={e=>setQ(e.target.value)} autoFocus onClick={e=>e.stopPropagation()}/>
          <div className="sdd-list">
            {filtered.map(o=><div key={o} className={`sdd-item${value===o?' active':''}`} onClick={()=>{onChange(o);setQ('');setOpen(false)}}>{o}</div>)}
            {q&&!options.includes(q)&&<div className="sdd-item sdd-custom" onClick={()=>{onChange(q);setQ('');setOpen(false)}}>+ Use "{q}"</div>}
          </div>
        </div>
      )}
    </div>
  );
}

function VCGrid({selected,onSelect,onUpgrade}){
  const[showAll,setShowAll]=useState(false);
  const visible=showAll?VCS:VCS.slice(0,30);
  return(
    <div className="vc-section">
      <div className="sec-head"><span className="sec-num">02</span><span className="sec-ttl">Target VC Firm</span><span style={{fontSize:11,color:'var(--mu)',marginLeft:'auto'}}>First 10 free - 90+ with Pro</span></div>
      <div className="vc-grid">
        {visible.map((f,i)=>{const free=i<10,sel=selected===f;return(
          <button key={f} className={`vc-card${free?' free':'  locked'}${sel?' sel':''}`} onClick={()=>free&&onSelect(f)} title={free?f:'Upgrade to unlock'}>
            <span className="vc-nm">{f}</span>
            {free&&<span className="vc-free-badge">FREE</span>}
            {!free&&<span style={{fontSize:9}}>lock</span>}
          </button>
        );})}
        {!showAll&&<button className="vc-card more" onClick={()=>setShowAll(true)}>+{VCS.length-30} more</button>}
      </div>
      {showAll&&<div className="vc-upgrade"><span>Unlock all {VCS.length} VC firms with Pro</span><button className="btn-primary" style={{padding:'8px 16px',fontSize:13}} onClick={onUpgrade}>Upgrade - $9</button></div>}
    </div>
  );
}

function FounderCard({founder,ci=0,onOutreach}){
  const col=CLR[ci%CLR.length];
  const[cp,setCp]=useState(false);
  function copyEmail(){navigator.clipboard.writeText(founder.likelyEmail).then(()=>{setCp(true);setTimeout(()=>setCp(false),2000)})}
  return(
    <div className="fc" style={{'--clr':col.av}}>
      <div className="fc-inner">
        <div className="fc-av" style={{background:col.av}}>{(founder.name||'?').split(' ').map(w=>w[0]).slice(0,2).join('')}</div>
        <div className="fc-body">
          <div className="fc-top">
            <div><div className="fc-name">{founder.name}</div><div className="fc-meta">{founder.role} at <b>{founder.company}</b></div></div>
            {founder.isFallback&&<span className="fc-portfolio-badge">PORTFOLIO</span>}
          </div>
          {founder.description&&<div className="fc-desc">{founder.description}</div>}
          <div className="fc-conn">Connected via: {founder.connection}</div>
          {founder.likelyEmail&&(
            <div className="fc-email-row">
              <span>email</span>
              <span className="fc-email-addr">{founder.likelyEmail}</span>
              <span className="fc-email-conf">best guess</span>
              <button className={`fc-copy-btn${cp?' done':''}`} onClick={copyEmail}>{cp?'Copied':'Copy'}</button>
            </div>
          )}
          <div className="fc-actions">
            {founder.profileUrl&&<a href={founder.profileUrl} target="_blank" rel="noreferrer" className="fc-link">LinkedIn</a>}
            <button className="fc-draft-btn" onClick={()=>onOutreach(founder)}>Draft Email</button>
          </div>
        </div>
      </div>
    </div>
  );
}

function ShareWall({onUnlock,hiddenCount}){
  const[copied,setCopied]=useState(false);
  const[unlocking,setUnlocking]=useState(false);
  async function share(openLi=true){
    setUnlocking(true);
    try{await fetch(API+'/unlock',{method:'POST'})}catch(_){}
    sc('wi_sh','1',30);
    if(openLi)window.open(LI_URL,'_blank','width=600,height=600');
    setTimeout(()=>{onUnlock();setUnlocking(false)},500);
  }
  return(
    <div>
      <div style={{textAlign:'center',padding:'12px 0 4px',fontSize:13,color:'var(--mu)'}}>
        <span style={{display:'block',fontSize:26,marginBottom:6}}>lock</span>
        <strong style={{color:'var(--ink)'}}>{hiddenCount} more founders</strong> hidden below
      </div>
      <div className="share-wall">
        <div className="share-wall-title">Unlock your full results</div>
        <div className="share-wall-sub">Share VCInvest on LinkedIn to reveal every connection we found.</div>
        <div className="share-preview"><div className="share-preview-lbl">Your post (pre-filled)</div><div className="share-preview-text">{SHARE_TEXT}</div></div>
        <div className="share-actions">
          <button className="btn-li" onClick={()=>share(true)} disabled={unlocking}>
            <span className="li-ic">in</span>{unlocking?'Unlocking...':'Share on LinkedIn and Unlock'}
          </button>
          <button className="btn-copy-share" onClick={()=>{navigator.clipboard.writeText(SHARE_TEXT);setCopied(true);setTimeout(()=>setCopied(false),2000)}}>{copied?'Copied!':'Copy text to paste yourself'}</button>
          <button className="btn-ghost-sm" onClick={()=>share(false)}>I already shared, just unlock</button>
        </div>
      </div>
    </div>
  );
}

function EmailCapture({onCapture,onDismiss}){
  const[email,setEmail]=useState('');const[loading,setLoading]=useState(false);const[done,setDone]=useState(false);
  async function submit(){
    if(!email.includes('@'))return;setLoading(true);
    try{await fetch(API+'/capture-email',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({email})});sc('wi_em',email,365);setDone(true);setTimeout(()=>onCapture(email),1000)}
    catch(_){onCapture(email)}finally{setLoading(false)}
  }
  if(done)return<div className="overlay"><div className="modal" style={{textAlign:'center',padding:'48px 32px'}}><div style={{fontSize:36,marginBottom:12}}>mail</div><div style={{fontSize:16,fontWeight:700,marginBottom:6}}>You are on the list.</div><div style={{fontSize:13,color:'var(--mu)'}}>First update hits your inbox within 24 hours.</div></div></div>;
  return(
    <div className="overlay">
      <div className="modal">
        <button className="modal-close" onClick={onDismiss}>x</button>
        <div className="tag-y" style={{marginBottom:14}}>Investor Intelligence</div>
        <div style={{fontSize:20,fontWeight:800,marginBottom:8,lineHeight:1.2}}>Get access to 80+ investor updates</div>
        <div style={{fontSize:13,color:'var(--mu)',lineHeight:1.6,marginBottom:18}}>Every 48 hours - curated intel on what top VCs are funding, who is raising, and warm intro tips from founders who have closed rounds.</div>
        <div className="ec-benefits">
          {['Weekly funding round summaries','Warm intro tactics that actually work','VC partner moves and new thesis updates','Founder playbooks for getting meetings'].map(b=>(
            <div key={b} className="ec-benefit"><span className="ec-benefit-check">check</span>{b}</div>
          ))}
        </div>
        <input className="inp" type="email" placeholder="your@email.com" value={email} onChange={e=>setEmail(e.target.value)} onKeyDown={e=>e.key==='Enter'&&submit()} autoFocus style={{marginBottom:12}}/>
        <button className="btn-primary" style={{width:'100%'}} onClick={submit} disabled={loading||!email.includes('@')}>{loading?'Subscribing...':'Get Investor Updates'}</button>
        <div style={{fontSize:10,color:'var(--mu2)',marginTop:10,textAlign:'center'}}>Free forever. No spam. Unsubscribe anytime.</div>
      </div>
    </div>
  );
}

function OutreachModal({founder,onClose}){
  const[loading,setLoading]=useState(true);const[email,setEmail]=useState(null);const[editMode,setEditMode]=useState(false);const[body,setBody]=useState('');const[cp,setCp]=useState(false);

  useEffect(()=>{
    fetch(API+'/generate-outreach',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({founder})})
      .then(r=>r.json()).then(d=>{setEmail(d);setBody(d.body||'')}).catch(()=>setEmail({subject:'Quick intro ask',body:'Could not generate. Try again.'})).finally(()=>setLoading(false))
  },[]);
  function copy(){const txt=`Subject: ${email?.subject||''}\n\n${editMode?body:email?.body||''}`;navigator.clipboard.writeText(txt).then(()=>{setCp(true);setTimeout(()=>setCp(false),2000)})}
  return(
    <div className="overlay">
      <div className="modal modal-wide">
        <button className="modal-close" onClick={onClose}>x</button>
        <div className="tag-y" style={{marginBottom:12}}>AI Outreach Email</div>
        <div style={{fontSize:18,fontWeight:800,marginBottom:12}}>Email to {founder.name}</div>
        {founder.likelyEmail&&<div className="outreach-email-bar"><span className="outreach-email-addr">{founder.likelyEmail}</span><button className="fc-copy-btn" onClick={()=>navigator.clipboard.writeText(founder.likelyEmail)}>Copy</button></div>}
        {loading?<div style={{padding:'28px 0',textAlign:'center',color:'var(--mu)',fontSize:13}}>Generating personalized email...</div>:(
          <>
            <div style={{marginBottom:10}}><div className="ob-lbl">Subject</div><div style={{background:'var(--s2)',border:'1px solid var(--bd)',padding:'10px 13px',fontSize:13,fontWeight:600,borderRadius:'var(--radius)'}}>{email?.subject}</div></div>
            <div style={{marginBottom:12}}>
              <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:6}}>
                <div className="ob-lbl">Body</div>
                <button onClick={()=>setEditMode(m=>!m)} style={{background:'none',border:'1px solid var(--bd)',color:'var(--mu)',fontSize:10,padding:'3px 8px',borderRadius:4,cursor:'pointer'}}>{editMode?'Preview':'Edit'}</button>
              </div>
              {editMode?<textarea className="ob-textarea" value={body} onChange={e=>setBody(e.target.value)}/>:<div className="ob-box">{email?.body}</div>}
            </div>
            <div style={{display:'flex',gap:8,flexWrap:'wrap',alignItems:'center'}}>
              <button className="btn-primary" style={{padding:'8px 18px',fontSize:13,background:cp?'var(--g)':'var(--ink)'}} onClick={copy}>{cp?'Copied!':'Copy Email'}</button>
              {founder.likelyEmail&&<a href={`mailto:${founder.likelyEmail}?subject=${encodeURIComponent(email?.subject||'')}&body=${encodeURIComponent((editMode?body:email?.body)||'')}`} style={{display:'inline-flex',alignItems:'center',gap:5,background:'var(--s2)',border:'1px solid var(--bd)',padding:'8px 14px',fontSize:12,fontWeight:600,borderRadius:'var(--radius)',color:'var(--ink)'}}>Open in Mail</a>}
            </div>
          </>
        )}
      </div>
    </div>
  );
}


// ─── DEMO PRODUCTS SHOWCASE ───────────────────────────────────────────────────
const ALL_PRODUCTS = [
  {e:'📊',bg:'#EFF6FF',c:'#1D4ED8',n:'Trackflow',t:'Lightweight OKR tracking for remote teams. No bloat, just clarity.',tags:[{l:'SaaS',bg:'#DBEAFE',c:'#1E40AF'},{l:'Productivity',bg:'#EDE9FE',c:'#5B21B6'}],angels:43,badge:'Raising',bb:'#FEF3C7',bc:'#92400E'},
  {e:'🛒',bg:'#F0FDF4',c:'#15803D',n:'Shelfie',t:'Inventory alerts and reorder automation for Shopify stores.',tags:[{l:'E-commerce',bg:'#D1FAE5',c:'#065F46'},{l:'Automation',bg:'#FEF3C7',c:'#92400E'}],angels:29,badge:'New',bb:'#D1FAE5',bc:'#065F46'},
  {e:'🎙️',bg:'#FFF7ED',c:'#C2410C',n:'Podscribe',t:'Auto-generates show notes and clips from podcast recordings.',tags:[{l:'Creator Tools',bg:'#FEE2E2',c:'#991B1B'},{l:'AI',bg:'#F5F3FF',c:'#5B21B6'}],angels:61,badge:'Hot',bb:'#FEE2E2',bc:'#B91C1C'},
  {e:'🏠',bg:'#FDF4FF',c:'#7E22CE',n:'Rently',t:'Tenant screening and lease management for independent landlords.',tags:[{l:'PropTech',bg:'#F3E8FF',c:'#6B21A8'},{l:'Fintech',bg:'#DBEAFE',c:'#1E40AF'}],angels:37,badge:'Raising',bb:'#FEF3C7',bc:'#92400E'},
  {e:'🍽️',bg:'#FFF1F2',c:'#BE123C',n:'MenuMetrics',t:'Menu performance analytics for independent restaurants.',tags:[{l:'Restaurant Tech',bg:'#FFE4E6',c:'#9F1239'},{l:'Analytics',bg:'#D1FAE5',c:'#065F46'}],angels:22,badge:'New',bb:'#D1FAE5',bc:'#065F46'},
  {e:'🤝',bg:'#FFFBEB',c:'#B45309',n:'Referly',t:'Referral program infrastructure for B2B SaaS. Setup in one afternoon.',tags:[{l:'Growth',bg:'#FEF3C7',c:'#92400E'},{l:'B2B SaaS',bg:'#DBEAFE',c:'#1E40AF'}],angels:78,badge:'Featured',bb:'#F59E0B',bc:'#000'},
  {e:'📦',bg:'#F0F9FF',c:'#0369A1',n:'Packify',t:'Packaging supplier comparison and ordering for DTC brands.',tags:[{l:'Supply Chain',bg:'#E0F2FE',c:'#0369A1'},{l:'E-commerce',bg:'#D1FAE5',c:'#065F46'}],angels:31,badge:'Raising',bb:'#FEF3C7',bc:'#92400E'},
  {e:'🧾',bg:'#FEFCE8',c:'#854D0E',n:'Expensio',t:'Receipt scanning and expense categorization for freelancers.',tags:[{l:'Fintech',bg:'#DBEAFE',c:'#1E40AF'},{l:'Freelance',bg:'#FEF3C7',c:'#92400E'}],angels:18,badge:'New',bb:'#D1FAE5',bc:'#065F46'},
  {e:'🎓',bg:'#F5F3FF',c:'#6D28D9',n:'StudyPod',t:'AI tutoring that adapts to each student learning style in real time.',tags:[{l:'EdTech',bg:'#EDE9FE',c:'#5B21B6'},{l:'AI',bg:'#F5F3FF',c:'#5B21B6'}],angels:54,badge:'Hot',bb:'#FEE2E2',bc:'#B91C1C'},
  {e:'🏋️',bg:'#FFF1F2',c:'#9F1239',n:'GymOS',t:'Client management and billing software built for boutique fitness studios.',tags:[{l:'Fitness',bg:'#FFE4E6',c:'#9F1239'},{l:'SaaS',bg:'#DBEAFE',c:'#1E40AF'}],angels:26,badge:'Raising',bb:'#FEF3C7',bc:'#92400E'},
  {e:'🌿',bg:'#F0FDF4',c:'#166534',n:'GreenCart',t:'Carbon footprint tracker embedded at checkout for Shopify merchants.',tags:[{l:'Climate',bg:'#D1FAE5',c:'#065F46'},{l:'E-commerce',bg:'#D1FAE5',c:'#065F46'}],angels:47,badge:'Hot',bb:'#FEE2E2',bc:'#B91C1C'},
  {e:'📅',bg:'#EFF6FF',c:'#1E40AF',n:'Calendr',t:'Smart scheduling that blocks focus time automatically around meetings.',tags:[{l:'Productivity',bg:'#DBEAFE',c:'#1E40AF'},{l:'SaaS',bg:'#EDE9FE',c:'#5B21B6'}],angels:33,badge:'Raising',bb:'#FEF3C7',bc:'#92400E'},
  {e:'🔒',bg:'#FDF4FF',c:'#7E22CE',n:'VaultKey',t:'Password and secrets manager built for small engineering teams.',tags:[{l:'Security',bg:'#F3E8FF',c:'#6B21A8'},{l:'DevTools',bg:'#DBEAFE',c:'#1E40AF'}],angels:41,badge:'Raising',bb:'#FEF3C7',bc:'#92400E'},
  {e:'🚚',bg:'#FFFBEB',c:'#92400E',n:'Fleeto',t:'Last-mile delivery route optimization for local courier fleets.',tags:[{l:'Logistics',bg:'#FEF3C7',c:'#92400E'},{l:'B2B',bg:'#DBEAFE',c:'#1E40AF'}],angels:19,badge:'New',bb:'#D1FAE5',bc:'#065F46'},
  {e:'💬',bg:'#F0F9FF',c:'#0369A1',n:'ChurnGuard',t:'Detects at-risk SaaS customers 30 days before they cancel.',tags:[{l:'Customer Success',bg:'#E0F2FE',c:'#0369A1'},{l:'B2B SaaS',bg:'#DBEAFE',c:'#1E40AF'}],angels:66,badge:'Hot',bb:'#FEE2E2',bc:'#B91C1C'},
  {e:'🖼️',bg:'#FFF7ED',c:'#C2410C',n:'Framely',t:'Print-on-demand art marketplace with artist revenue sharing.',tags:[{l:'Marketplace',bg:'#FFEDD5',c:'#C2410C'},{l:'Creator',bg:'#FEE2E2',c:'#991B1B'}],angels:24,badge:'New',bb:'#D1FAE5',bc:'#065F46'},
  {e:'🧪',bg:'#F5F3FF',c:'#5B21B6',n:'LabLog',t:'Digital lab notebook for biotech researchers replacing paper protocols.',tags:[{l:'BioTech',bg:'#EDE9FE',c:'#5B21B6'},{l:'Research',bg:'#DBEAFE',c:'#1E40AF'}],angels:38,badge:'Raising',bb:'#FEF3C7',bc:'#92400E'},
  {e:'🏡',bg:'#F0FDF4',c:'#15803D',n:'Homevibe',t:'AI interior design suggestions based on photos of your existing space.',tags:[{l:'Home',bg:'#D1FAE5',c:'#065F46'},{l:'AI',bg:'#F5F3FF',c:'#5B21B6'}],angels:52,badge:'Hot',bb:'#FEE2E2',bc:'#B91C1C'},
  {e:'🎮',bg:'#FDF4FF',c:'#7E22CE',n:'StreamDeck',t:'Analytics dashboard for Twitch and YouTube gaming creators.',tags:[{l:'Gaming',bg:'#F3E8FF',c:'#6B21A8'},{l:'Creator',bg:'#FEE2E2',c:'#991B1B'}],angels:29,badge:'New',bb:'#D1FAE5',bc:'#065F46'},
  {e:'🌎',bg:'#EFF6FF',c:'#1D4ED8',n:'Localify',t:'Hyper-local event discovery app for cities under 500k population.',tags:[{l:'Consumer',bg:'#DBEAFE',c:'#1E40AF'},{l:'Events',bg:'#FEF3C7',c:'#92400E'}],angels:21,badge:'Raising',bb:'#FEF3C7',bc:'#92400E'},
  {e:'📣',bg:'#FFF1F2',c:'#BE123C',n:'NoiseMaker',t:'Micro-influencer campaign management for consumer brands.',tags:[{l:'Marketing',bg:'#FFE4E6',c:'#9F1239'},{l:'Influencer',bg:'#F3E8FF',c:'#6B21A8'}],angels:44,badge:'Raising',bb:'#FEF3C7',bc:'#92400E'},
  {e:'🧘',bg:'#F0FDF4',c:'#166534',n:'Mindsync',t:'Therapist-approved mental wellness check-ins for HR teams.',tags:[{l:'Mental Health',bg:'#D1FAE5',c:'#065F46'},{l:'HR Tech',bg:'#DBEAFE',c:'#1E40AF'}],angels:57,badge:'Hot',bb:'#FEE2E2',bc:'#B91C1C'},
  {e:'🛡️',bg:'#FFFBEB',c:'#92400E',n:'Trustly',t:'Automated SOC 2 compliance tracking for early-stage startups.',tags:[{l:'Security',bg:'#FEF3C7',c:'#92400E'},{l:'Compliance',bg:'#DBEAFE',c:'#1E40AF'}],angels:35,badge:'Raising',bb:'#FEF3C7',bc:'#92400E'},
  {e:'🐾',bg:'#FFF7ED',c:'#C2410C',n:'PawTrack',t:'GPS health monitoring wearable subscription for dogs and cats.',tags:[{l:'Pet Tech',bg:'#FFEDD5',c:'#C2410C'},{l:'Hardware',bg:'#F3E8FF',c:'#6B21A8'}],angels:28,badge:'New',bb:'#D1FAE5',bc:'#065F46'},
  {e:'🧑‍💻',bg:'#F5F3FF',c:'#6D28D9',n:'DevHire',t:'Technical skills assessment platform replacing whiteboard interviews.',tags:[{l:'HR Tech',bg:'#EDE9FE',c:'#5B21B6'},{l:'DevTools',bg:'#DBEAFE',c:'#1E40AF'}],angels:49,badge:'Hot',bb:'#FEE2E2',bc:'#B91C1C'},
  {e:'🚿',bg:'#F0F9FF',c:'#0369A1',n:'WaterSense',t:'Smart water usage monitor for multifamily residential buildings.',tags:[{l:'CleanTech',bg:'#E0F2FE',c:'#0369A1'},{l:'IoT',bg:'#D1FAE5',c:'#065F46'}],angels:23,badge:'New',bb:'#D1FAE5',bc:'#065F46'},
  {e:'📱',bg:'#FDF4FF',c:'#7E22CE',n:'AppWarm',t:'Mobile app onboarding builder that reduces day-1 churn by 40%.',tags:[{l:'Growth',bg:'#F3E8FF',c:'#6B21A8'},{l:'Mobile',bg:'#DBEAFE',c:'#1E40AF'}],angels:62,badge:'Hot',bb:'#FEE2E2',bc:'#B91C1C'},
  {e:'🍕',bg:'#FFF1F2',c:'#9F1239',n:'SliceOps',t:'Kitchen display and order management system for ghost kitchens.',tags:[{l:'Restaurant Tech',bg:'#FFE4E6',c:'#9F1239'},{l:'Operations',bg:'#FEF3C7',c:'#92400E'}],angels:17,badge:'New',bb:'#D1FAE5',bc:'#065F46'},
  {e:'🔬',bg:'#FFFBEB',c:'#B45309',n:'SpectrAI',t:'AI-powered materials analysis for manufacturing quality control.',tags:[{l:'Deep Tech',bg:'#FEF3C7',c:'#92400E'},{l:'AI',bg:'#F5F3FF',c:'#5B21B6'}],angels:40,badge:'Raising',bb:'#FEF3C7',bc:'#92400E'},
  {e:'📰',bg:'#EFF6FF',c:'#1D4ED8',n:'Briefd',t:'AI newsletter writer that matches your tone from past issues.',tags:[{l:'Media',bg:'#DBEAFE',c:'#1E40AF'},{l:'AI',bg:'#F5F3FF',c:'#5B21B6'}],angels:34,badge:'Raising',bb:'#FEF3C7',bc:'#92400E'},
  {e:'🛺',bg:'#F0FDF4',c:'#15803D',n:'Routr',t:'Shared ride coordination app for corporate office commutes.',tags:[{l:'Mobility',bg:'#D1FAE5',c:'#065F46'},{l:'Enterprise',bg:'#DBEAFE',c:'#1E40AF'}],angels:26,badge:'Raising',bb:'#FEF3C7',bc:'#92400E'},
  {e:'🎨',bg:'#FDF4FF',c:'#7E22CE',n:'Paleto',t:'Brand asset management and design token system for growing teams.',tags:[{l:'Design',bg:'#F3E8FF',c:'#6B21A8'},{l:'SaaS',bg:'#DBEAFE',c:'#1E40AF'}],angels:45,badge:'Raising',bb:'#FEF3C7',bc:'#92400E'},
  {e:'🤖',bg:'#FFFBEB',c:'#92400E',n:'BotDesk',t:'AI customer support agent that learns from your help docs.',tags:[{l:'AI',bg:'#FEF3C7',c:'#92400E'},{l:'Customer Support',bg:'#E0F2FE',c:'#0369A1'}],angels:71,badge:'Hot',bb:'#FEE2E2',bc:'#B91C1C'},
  {e:'🌱',bg:'#F0FDF4',c:'#166534',n:'HarvestIQ',t:'Precision irrigation scheduling for small-scale organic farms.',tags:[{l:'AgTech',bg:'#D1FAE5',c:'#065F46'},{l:'IoT',bg:'#DBEAFE',c:'#1E40AF'}],angels:20,badge:'New',bb:'#D1FAE5',bc:'#065F46'},
  {e:'🧳',bg:'#FFF7ED',c:'#C2410C',n:'PackRight',t:'AI packing list generator that syncs with your calendar and weather.',tags:[{l:'Travel',bg:'#FFEDD5',c:'#C2410C'},{l:'Consumer',bg:'#DBEAFE',c:'#1E40AF'}],angels:32,badge:'Raising',bb:'#FEF3C7',bc:'#92400E'},
  {e:'💊',bg:'#F5F3FF',c:'#5B21B6',n:'DoseTrack',t:'Medication adherence app for elderly patients with caregiver alerts.',tags:[{l:'HealthTech',bg:'#EDE9FE',c:'#5B21B6'},{l:'Senior Care',bg:'#D1FAE5',c:'#065F46'}],angels:38,badge:'Raising',bb:'#FEF3C7',bc:'#92400E'},
  {e:'📸',bg:'#FFF1F2',c:'#BE123C',n:'SnapSell',t:'Mobile product photography editor optimized for Amazon listings.',tags:[{l:'E-commerce',bg:'#FFE4E6',c:'#9F1239'},{l:'AI',bg:'#F5F3FF',c:'#5B21B6'}],angels:27,badge:'New',bb:'#D1FAE5',bc:'#065F46'},
  {e:'🏦',bg:'#EFF6FF',c:'#1E40AF',n:'LedgerLite',t:'Simple double-entry bookkeeping for solopreneurs who hate spreadsheets.',tags:[{l:'Fintech',bg:'#DBEAFE',c:'#1E40AF'},{l:'Accounting',bg:'#FEF3C7',c:'#92400E'}],angels:36,badge:'Raising',bb:'#FEF3C7',bc:'#92400E'},
  {e:'🎯',bg:'#FFFBEB',c:'#B45309',n:'FocusFire',t:'Pomodoro and deep work tracker with team accountability features.',tags:[{l:'Productivity',bg:'#FEF3C7',c:'#92400E'},{l:'Team',bg:'#DBEAFE',c:'#1E40AF'}],angels:19,badge:'New',bb:'#D1FAE5',bc:'#065F46'},
  {e:'🎵',bg:'#FDF4FF',c:'#7E22CE',n:'Stemly',t:'Royalty-free music licensing marketplace for indie content creators.',tags:[{l:'Music',bg:'#F3E8FF',c:'#6B21A8'},{l:'Marketplace',bg:'#DBEAFE',c:'#1E40AF'}],angels:42,badge:'Raising',bb:'#FEF3C7',bc:'#92400E'},
  {e:'🧑‍⚕️',bg:'#F0FDF4',c:'#166534',n:'CareCoord',t:'Patient care coordination software for independent medical practices.',tags:[{l:'HealthTech',bg:'#D1FAE5',c:'#065F46'},{l:'SaaS',bg:'#DBEAFE',c:'#1E40AF'}],angels:53,badge:'Hot',bb:'#FEE2E2',bc:'#B91C1C'},
  {e:'🏗️',bg:'#F0F9FF',c:'#0369A1',n:'SiteSync',t:'Construction site progress tracking via weekly drone photo comparison.',tags:[{l:'Construction',bg:'#E0F2FE',c:'#0369A1'},{l:'PropTech',bg:'#F3E8FF',c:'#6B21A8'}],angels:30,badge:'Raising',bb:'#FEF3C7',bc:'#92400E'},
  {e:'📊',bg:'#F5F3FF',c:'#6D28D9',n:'Dashify',t:'No-code analytics dashboards connected to any Postgres or Airtable.',tags:[{l:'Analytics',bg:'#EDE9FE',c:'#5B21B6'},{l:'No-code',bg:'#D1FAE5',c:'#065F46'}],angels:48,badge:'Raising',bb:'#FEF3C7',bc:'#92400E'},
  {e:'🌐',bg:'#FFFBEB',c:'#92400E',n:'TranslateKit',t:'Localization SDK for mobile apps. Ship in 40 languages in one sprint.',tags:[{l:'Developer Tools',bg:'#FEF3C7',c:'#92400E'},{l:'Global',bg:'#DBEAFE',c:'#1E40AF'}],angels:25,badge:'New',bb:'#D1FAE5',bc:'#065F46'},
  {e:'🧑‍🎨',bg:'#FFF7ED',c:'#C2410C',n:'CommissionHub',t:'Freelance artist commission management - contracts, payments, revisions.',tags:[{l:'Creator',bg:'#FFEDD5',c:'#C2410C'},{l:'Marketplace',bg:'#F3E8FF',c:'#6B21A8'}],angels:22,badge:'New',bb:'#D1FAE5',bc:'#065F46'},
  {e:'🛡️',bg:'#EFF6FF',c:'#1D4ED8',n:'InsureBot',t:'AI insurance recommendation engine for gig economy workers.',tags:[{l:'InsurTech',bg:'#DBEAFE',c:'#1E40AF'},{l:'Gig Economy',bg:'#FEF3C7',c:'#92400E'}],angels:39,badge:'Raising',bb:'#FEF3C7',bc:'#92400E'},
  {e:'🔋',bg:'#F0FDF4',c:'#15803D',n:'ChargeMap',t:'EV charging station finder and reservation app for fleet managers.',tags:[{l:'CleanTech',bg:'#D1FAE5',c:'#065F46'},{l:'Mobility',bg:'#E0F2FE',c:'#0369A1'}],angels:46,badge:'Raising',bb:'#FEF3C7',bc:'#92400E'},
  {e:'👶',bg:'#FDF4FF',c:'#7E22CE',n:'BabyLog',t:'Pediatric milestone tracker and symptom journal for new parents.',tags:[{l:'Consumer',bg:'#F3E8FF',c:'#6B21A8'},{l:'Health',bg:'#D1FAE5',c:'#065F46'}],angels:31,badge:'New',bb:'#D1FAE5',bc:'#065F46'},
  {e:'🎪',bg:'#FFF1F2',c:'#9F1239',n:'EventKit',t:'All-in-one ticketing and vendor management for local event organizers.',tags:[{l:'Events',bg:'#FFE4E6',c:'#9F1239'},{l:'Marketplace',bg:'#DBEAFE',c:'#1E40AF'}],angels:58,badge:'Hot',bb:'#FEE2E2',bc:'#B91C1C'},
  {e:'🧑‍🏫',bg:'#FFFBEB',c:'#B45309',n:'Coursify',t:'Micro-course builder for subject matter experts with built-in payments.',tags:[{l:'EdTech',bg:'#FEF3C7',c:'#92400E'},{l:'Creator',bg:'#FFEDD5',c:'#C2410C'}],angels:64,badge:'Hot',bb:'#FEE2E2',bc:'#B91C1C'},
  {e:'🔗',bg:'#F0F9FF',c:'#0369A1',n:'LinkVault',t:'Team link management and knowledge base for remote-first companies.',tags:[{l:'Productivity',bg:'#E0F2FE',c:'#0369A1'},{l:'Team',bg:'#DBEAFE',c:'#1E40AF'}],angels:27,badge:'New',bb:'#D1FAE5',bc:'#065F46'},
];

function ProductShowcase({onList}){
  const[showAll,setShowAll]=useState(false);
  const visible=showAll?ALL_PRODUCTS:ALL_PRODUCTS.slice(0,12);
  return(
    <div className="products-section">
      <div className="products-inner">
        <div className="section-center">
          <div className="section-eyebrow">Active on VCInvest</div>
          <div className="section-title">Startups angels are looking at right now</div>
          <div className="section-sub" style={{marginBottom:0}}>Real founders actively raising. Angels browse and reach out directly - no intermediaries.</div>
        </div>
        <div className="product-grid" style={{marginTop:36}}>
          {visible.map(p=>(
            <div key={p.n} className="product-card">
              <div className="product-card-top">
                <div style={{display:'flex',alignItems:'flex-start',gap:12}}>
                  <div className="product-card-logo" style={{background:p.bg,color:p.c}}>{p.e}</div>
                  <div style={{flex:1,minWidth:0,paddingRight:52}}>
                    <div className="product-card-name">{p.n}</div>
                    <div className="product-card-tagline">{p.t}</div>
                  </div>
                </div>
                <div className="product-card-badge" style={{background:p.bb,color:p.bc}}>{p.badge}</div>
                <div className="product-card-tags">{p.tags.map(t=><span key={t.l} className="product-tag" style={{background:t.bg,color:t.c}}>{t.l}</span>)}</div>
              </div>
              <div className="product-card-divider"/>
              <div style={{padding:'14px 20px 16px',display:'flex',alignItems:'center',justifyContent:'space-between',gap:10,flexWrap:'wrap'}}>
                <div style={{display:'flex',alignItems:'center',gap:7}}>
                  <span style={{width:7,height:7,borderRadius:'50%',background:'var(--g)',display:'inline-block',flexShrink:0,boxShadow:'0 0 0 2px rgba(16,185,129,.2)'}}/>
                  <span style={{fontSize:12,fontWeight:700,color:'var(--ink)'}}>{p.angels}+ angel investors</span>
                  <span style={{fontSize:12,color:'var(--mu)'}}>shortlisted</span>
                </div>
                <span style={{fontSize:10,color:'var(--mu)',background:'var(--s2)',border:'1px solid var(--bd)',padding:'3px 8px',borderRadius:100,fontWeight:600}}>Accepting intros</span>
              </div>
            </div>
          ))}
        </div>
        {!showAll&&(
          <div style={{textAlign:'center',marginTop:32}}>
            <button onClick={()=>setShowAll(true)} style={{background:'#fff',color:'#0f0f0f',border:'1.5px solid #E5E7EB',padding:'14px 36px',fontSize:14,fontWeight:700,borderRadius:11,cursor:'pointer',display:'inline-flex',alignItems:'center',gap:8,boxShadow:'0 1px 3px rgba(0,0,0,.04)',transition:'all .15s'}}
              onMouseEnter={e=>{e.currentTarget.style.borderColor='#0f0f0f';e.currentTarget.style.boxShadow='0 4px 12px rgba(0,0,0,.08)';e.currentTarget.style.transform='translateY(-1px)';}}
              onMouseLeave={e=>{e.currentTarget.style.borderColor='#E5E7EB';e.currentTarget.style.boxShadow='0 1px 3px rgba(0,0,0,.04)';e.currentTarget.style.transform='translateY(0)';}}>
              Show all {ALL_PRODUCTS.length} startups
              <span style={{fontSize:16,transition:'transform .15s'}}>↓</span>
            </button>
          </div>
        )}
        <div style={{textAlign:'center',marginTop:28,paddingTop:28,borderTop:'1px solid var(--bd)'}}>
          <div style={{fontSize:13,color:'var(--mu)',marginBottom:14}}>Want your startup listed? It takes 2 minutes and it is free.</div>
          <button className="btn-primary" style={{padding:'13px 32px',fontSize:14}} onClick={onList}>List My Startup</button>
        </div>
      </div>
    </div>
  );
}

// ─── ANGEL SECTION ───────────────────────────────────────────────────────────

// Static angels shown on homepage - realistic but not famous names
const HOMEPAGE_ANGELS = [
  {name:'Marcus Chen',title:'Partner, Gradient Ventures',focus:'AI/ML, Developer Tools',checks:'$25K–$100K',bg:'#EFF6FF',c:'#1D4ED8'},
  {name:'Priya Nair',title:'Angel Investor',focus:'FinTech, Consumer',checks:'$10K–$50K',bg:'#F0FDF4',c:'#15803D'},
  {name:'Jordan Blake',title:'GP, Hustle Fund',focus:'B2B SaaS, No-Code',checks:'$25K–$75K',bg:'#FDF4FF',c:'#7E22CE'},
  {name:'Aisha Mohammed',title:'Principal, Precursor VC',focus:'HealthTech, EdTech',checks:'$50K–$200K',bg:'#FFFBEB',c:'#B45309'},
  {name:'David Park',title:'Scout, General Catalyst',focus:'Marketplace, Logistics',checks:'$20K–$100K',bg:'#FFF1F2',c:'#BE123C'},
  {name:'Sofia Reyes',title:'Angel, Backstage Capital',focus:'Consumer, Creator Economy',checks:'$10K–$50K',bg:'#F0F9FF',c:'#0369A1'},
  {name:'Tyler Brooks',title:'Partner, Matchstick Ventures',focus:'PropTech, CleanTech',checks:'$100K–$250K',bg:'#F5F3FF',c:'#6D28D9'},
  {name:'Nadia Okafor',title:'Angel Investor',focus:'BioTech, Mental Health',checks:'$25K–$75K',bg:'#FFF7ED',c:'#C2410C'},
];

function AngelSection({onList}){
  const[angels,setAngels]=useState([]);
  useEffect(()=>{
    fetch(API+'/angels').then(r=>r.json())
      .then(d=>setAngels((d.angels||[]).filter(a=>!a.isSignedUp)))
      .catch(()=>{});
  },[]);
  const displayAngels=angels.length>=4?angels.slice(0,8):HOMEPAGE_ANGELS;

  return(
    <>
      {/* ── HERO ── */}
      <div className="hp-hero">
        <div style={{position:'absolute',inset:0,backgroundImage:'radial-gradient(#E5E7EB 1px,transparent 1px)',backgroundSize:'28px 28px',opacity:.4,pointerEvents:'none'}}/>
        <div className="hp-hero-inner">
          <div style={{display:'inline-flex',alignItems:'center',gap:8,background:'#F0FDF4',border:'1px solid #A7F3D0',color:'#065F46',fontSize:12,fontWeight:700,letterSpacing:'.08em',textTransform:'uppercase',padding:'6px 16px',borderRadius:100,marginBottom:24}}>
            <span style={{width:7,height:7,borderRadius:'50%',background:'#10B981',display:'inline-block',boxShadow:'0 0 0 3px rgba(16,185,129,.2)'}}/>
            500+ angel investors active this week
          </div>
          <h1>
            Get your startup funded! <br/>
            <span style={{background:'linear-gradient(135deg,#F59E0B,#EF4444)',WebkitBackgroundClip:'text',WebkitTextFillColor:'transparent',backgroundClip:'text'}}>500+ angel investors</span>
          </h1>
          <p>List your startup for free, and get it funded within 7 Days!</p>
          <div className="hp-hero-btns">
            <button className="hp-hero-btn-primary" onClick={onList}>List My Startup - Free →</button>
            <a className="hp-hero-btn-secondary" href="/invest">I am an investor →</a>
          </div>
          {/* Stats */}
          <div className="hp-stats">
            {[['500+','Angel Investors'],['Weekly','Newsletter'],['< 48h','First Message'],['Free','To List']].map(([n,l])=>(
              <div key={l} className="hp-stat">
                <div className="hp-stat-n">{n}</div>
                <div className="hp-stat-l">{l}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── HOW IT WORKS ── */}
      <div className="hp-section" style={{background:'#FAFAFA',borderBottom:'1px solid #F3F4F6'}}>
        <div className="hp-section-inner">
          <div style={{textAlign:'center',marginBottom:8}}>
            <div className="hp-section-eyebrow">How It Works</div>
            <div className="hp-section-title">List once. Reach 500+ angels every week.</div>
          </div>
          <div className="hp-steps">
            {[
              {n:'01',icon:'✍️',title:'List your startup',desc:'Submit in 2 minutes - URL, category, vision, traction, and funding ask. Completely free.'},
              {n:'02',icon:'📬',title:'Weekly newsletter goes out',desc:'Every Monday we send a curated digest to 500+ verified angels. Your startup is featured with full details.'},
              {n:'03',icon:'💬',title:'Angels message you directly',desc:'Interested investors reach out in your founder dashboard. You reply when you\'re ready.'},
            ].map(step=>(
              <div key={step.n} className="hp-step">
                <div className="hp-step-num">{step.n}</div>
                <div className="hp-step-icon">{step.icon}</div>
                <div className="hp-step-title">{step.title}</div>
                <div className="hp-step-desc">{step.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ── NEWSLETTER ── */}
      <div className="hp-section" style={{background:'#fff',borderBottom:'1px solid #F3F4F6'}}>
        <div className="hp-section-inner">
          <div className="hp-newsletter">
            <div>
              <div className="hp-section-eyebrow">Weekly Newsletter</div>
              <div className="hp-section-title" style={{marginBottom:16}}>Every Monday,<br/>500+ angels see your startup</div>
              <p style={{fontSize:15,color:'#6B7280',lineHeight:1.7,marginBottom:24}}>We curate the best startups and send a weekly digest to our verified angel network. Featured companies see an average of 8-12 inbound messages.</p>
              <div style={{display:'flex',flexDirection:'column',gap:12,marginBottom:28}}>
                {['Your startup featured with traction and funding ask','Angels can message you directly with one click','Newsletter sent every Monday at 9am EST','Update your profile anytime'].map(b=>(
                  <div key={b} style={{display:'flex',alignItems:'flex-start',gap:10,fontSize:14,color:'#374151'}}>
                    <span style={{width:18,height:18,borderRadius:'50%',background:'#F0FDF4',border:'1px solid #A7F3D0',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0,fontSize:10,color:'#10B981',fontWeight:800,marginTop:1}}>✓</span>
                    {b}
                  </div>
                ))}
              </div>
              <button onClick={onList} style={{background:'#F59E0B',color:'#000',border:'none',padding:'14px 28px',fontSize:14,fontWeight:700,borderRadius:10,cursor:'pointer',width:'100%',maxWidth:320}}>
                Get Featured in Next Newsletter →
              </button>
            </div>
            <div className="hp-nl-mockup">
              <div className="hp-nl-bar">
                <div className="hp-nl-dot" style={{background:'#EF4444'}}/>
                <div className="hp-nl-dot" style={{background:'#F59E0B'}}/>
                <div className="hp-nl-dot" style={{background:'#10B981'}}/>
                <div className="hp-nl-title">VCInvest Weekly - Monday 9AM</div>
              </div>
              <div className="hp-nl-body">
                <div style={{fontSize:11,color:'#9CA3AF',marginBottom:4}}>From: hello@vcinvest.pro · To: angel@fund.co</div>
                <div style={{fontSize:14,fontWeight:700,color:'#0f0f0f',marginBottom:14}}>🚀 This Week: 12 Startups Actively Raising</div>
                {[{name:'Trackflow',cat:'SaaS',raise:'$250K seed',tag:'📈 $4.2K MRR'},{name:'GreenCart',cat:'CleanTech',raise:'$500K seed',tag:'🌿 3,400 users'},{name:'BotDesk',cat:'AI',raise:'$1M pre-seed',tag:'🤖 47 customers'}].map(s=>(
                  <div key={s.name} className="hp-nl-row">
                    <div><div style={{fontSize:13,fontWeight:700,color:'#0f0f0f'}}>{s.name}</div><div style={{fontSize:11,color:'#9CA3AF'}}>{s.cat} · {s.raise}</div></div>
                    <div style={{fontSize:11,background:'#F0FDF4',color:'#065F46',padding:'3px 9px',borderRadius:100,fontWeight:700,whiteSpace:'nowrap'}}>{s.tag}</div>
                  </div>
                ))}
                <div style={{textAlign:'center',fontSize:12,color:'#9CA3AF',paddingTop:4}}>+ 9 more startups in this issue →</div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  );
}

const ALL_CATS=[
  'AI / Machine Learning','SaaS / B2B Software','FinTech / Payments','HealthTech / MedTech',
  'E-commerce / DTC','EdTech / Learning','CleanTech / Climate','Consumer App',
  'Developer Tools','Marketplace','PropTech / Real Estate','HR Tech / Future of Work',
  'Creator Economy','Gaming / Esports','Logistics / Supply Chain','BioTech / Life Sciences',
  'CyberSecurity','AgTech / FoodTech','LegalTech','InsurTech',
  'Web3 / Crypto / NFT','Hardware / IoT','SpaceTech / DeepTech','Restaurant Tech',
  'RetailTech','TravelTech / Hospitality','SportsTech / FitnessTech','Social / Community',
  'Mental Health / Wellness','Media / Entertainment','AutoTech / Mobility',
  'SupplyChain / Manufacturing','Data Analytics / BI','No-Code / Low-Code',
  'Construction Tech / PropTech','Pet Tech','Fashion Tech','Beauty Tech',
  'Senior Care / Aging Tech','Parenting / Family Tech','Gov Tech / Civic Tech',
  'Non-Profit Tech / Social Impact','Recruitment / Talent Tech',
  'Sales Tech / Revenue Ops','Marketing Tech / AdTech','Customer Success / CX',
  'Accounting / Tax Tech','Real Estate Investing','Wealth Management / WealthTech',
  'Micro-SaaS / Niche Software','API / Infrastructure','Payments / Billing',
  'Privacy / Compliance Tech','Remote Work Tools','Event Tech','Podcast / Audio Tech',
  'Video / Streaming Tech','Newsletter / Content Tools','Community Platforms',
  'Personal Finance','Student / Campus Tech','Language Learning','Tutoring / Test Prep',
  'Corporate Training','Telemedicine / Telehealth','Clinical Trials / Research',
  'Dental Tech','Veterinary Tech','Genomics / Precision Medicine',
  'Drug Discovery','Medical Devices','Nutrition / Diet Tech',
  'Wearables','Smart Home','Energy Tech','Water Tech',
  'Carbon Credits / Offsetting','Recycling / Waste Tech','Ocean / Marine Tech',
  'Mining Tech','Oil & Gas Tech','Nuclear / Alternative Energy',
  'Robotics','Drones / UAV','Autonomous Vehicles','Quantum Computing',
  '3D Printing / Additive Manufacturing','Nanotechnology','AR / VR / XR',
  'Computer Vision','NLP / Voice Tech','Generative AI','AI Agents / Automation',
  'Blockchain / DeFi','NFT / Digital Collectibles','DAO Tools',
  'Gig Economy / Freelance','Childcare Tech','Home Services',
  'Immigration Tech','Military / Defense Tech','Aerospace',
];

// ─── CATEGORY PICKER (searchable) ────────────────────────────────────────────
function CatPicker({value, onChange}){
  const[open,setOpen]=useState(false);
  const[q,setQ]=useState('');
  const ref=useRef(null);
  useEffect(()=>{
    const h=e=>{if(ref.current&&!ref.current.contains(e.target))setOpen(false)};
    document.addEventListener('mousedown',h);return()=>document.removeEventListener('mousedown',h);
  },[]);
  const filtered=ALL_CATS.filter(c=>c.toLowerCase().includes(q.toLowerCase())).slice(0,20);
  return(
    <div style={{position:'relative'}} ref={ref}>
      <div onClick={()=>setOpen(o=>!o)} style={{display:'flex',alignItems:'center',justifyContent:'space-between',background:'var(--s2)',border:`1.5px solid ${open?'var(--y)':'var(--bd)'}`,padding:'11px 14px',borderRadius:'var(--radius)',cursor:'pointer',fontSize:14,fontWeight:value?600:400,color:value?'var(--ink)':'var(--mu3)',transition:'border-color .15s',minHeight:46}}>
        <span>{value||'Select your category...'}</span>
        <div style={{display:'flex',alignItems:'center',gap:6}}>
          {value&&<button onClick={e=>{e.stopPropagation();onChange('');setQ('')}} style={{background:'none',border:'none',color:'var(--mu2)',fontSize:16,lineHeight:1,cursor:'pointer',padding:'0 2px'}}>×</button>}
          <span style={{fontSize:9,color:'var(--mu3)'}}>{open?'▲':'▼'}</span>
        </div>
      </div>
      {open&&(
        <div style={{position:'absolute',top:'calc(100% + 4px)',left:0,right:0,background:'#fff',border:'1.5px solid var(--y)',borderRadius:'var(--radius)',zIndex:400,boxShadow:'0 8px 24px rgba(0,0,0,.12)',overflow:'hidden'}}>
          <div style={{padding:'8px 10px',borderBottom:'1px solid var(--bd)',background:'var(--s2)'}}>
            <input autoFocus value={q} onChange={e=>setQ(e.target.value)} placeholder="Search categories..." style={{width:'100%',background:'none',border:'none',outline:'none',fontSize:13,color:'var(--ink)'}}/>
          </div>
          <div style={{maxHeight:220,overflowY:'auto'}}>
            {filtered.length===0&&<div style={{padding:'14px 12px',fontSize:13,color:'var(--mu)',textAlign:'center'}}>No results for "{q}"</div>}
            {filtered.map(c=>(
              <div key={c} onClick={()=>{onChange(c);setQ('');setOpen(false)}} style={{padding:'10px 13px',fontSize:13,cursor:'pointer',background:value===c?'#FFFBEB':'#fff',color:value===c?'#92400E':'var(--ink)',fontWeight:value===c?700:400,borderBottom:'1px solid var(--s3)',transition:'background .1s'}}
                onMouseEnter={e=>e.currentTarget.style.background=value===c?'#FFFBEB':'var(--s2)'}
                onMouseLeave={e=>e.currentTarget.style.background=value===c?'#FFFBEB':'#fff'}
              >{c}</div>
            ))}
          </div>
          <div style={{padding:'8px 12px',borderTop:'1px solid var(--bd)',background:'var(--s2)',fontSize:10,color:'var(--mu)',textAlign:'center'}}>{ALL_CATS.length} categories - type to filter</div>
        </div>
      )}
    </div>
  );
}

// ─── AI AUTOFILL ─────────────────────────────────────────────────────────────
function AiAutofill({name,category,url,description,onFill}){
  const[status,setStatus]=useState('idle'); // idle | filling | done | error
  const timerRef=useRef(null);
  const firedRef=useRef(false); // only auto-fill once per session

  useEffect(()=>{
    // Trigger when description has 4+ words and hasn't fired yet
    const wordCount=(description||'').trim().split(/\s+/).filter(Boolean).length;
    if(wordCount<4||firedRef.current)return;
    clearTimeout(timerRef.current);
    timerRef.current=setTimeout(async()=>{
      if(firedRef.current)return;
      firedRef.current=true;
      setStatus('filling');
      try{
        const res=await fetch(
          (typeof API!=='undefined'?API:'https://learntok-backend-2026-24c204fe508e.herokuapp.com/warm')+'/ai-autofill',
          {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({name,category,url,description})}
        );
        const data=await res.json();
        if(!data.ok)throw new Error(data.error||'Failed');
        // Only fill empty fields — don't overwrite what they typed
        onFill(data.fields);
        setStatus('done');
        setTimeout(()=>setStatus('idle'),4000);
      }catch(_){setStatus('error');setTimeout(()=>setStatus('idle'),3000);firedRef.current=false;}
    },1500);
    return()=>clearTimeout(timerRef.current);
  },[description]);

  if(status==='idle')return null;
  return(
    <div style={{display:'flex',alignItems:'center',gap:6,fontSize:11,fontWeight:600,padding:'4px 10px',borderRadius:100,
      background:status==='filling'?'#EEF2FF':status==='done'?'#F0FDF4':'#FEF2F2',
      color:status==='filling'?'#4338CA':status==='done'?'#065F46':'#DC2626',
      border:`1px solid ${status==='filling'?'#C7D2FE':status==='done'?'#A7F3D0':'#FECACA'}`}}>
      {status==='filling'&&<span style={{animation:'spin .6s linear infinite',display:'inline-block'}}>⟳</span>}
      {status==='done'&&'✓'}
      {status==='filling'?'AI filling your profile...':status==='done'?'Vision & traction filled by AI':'AI fill failed - try editing more'}
    </div>
  );
}

// ─── PRODUCT MODAL ────────────────────────────────────────────────────────────
function ProductModal({onClose}){
  // Steps: 1=name+category, 2=analyzing, 3=match reveal, 4=phone, 5=otp, 6=details, 7=done
  const[step,setStep]=useState(1);
  const[name,setName]=useState('');
  const[category,setCategory]=useState('');
  const[phone,setPhone]=useState('');
  const[cc,setCc]=useState('+1');
  const[otp,setOtp]=useState('');
  const[form,setForm]=useState({url:'',description:'',vision:'',traction:'',funding:'',checkSize:''});
  const[matchCount,setMatchCount]=useState(0);
  const[loading,setLoading]=useState(false);
  const[err,setErr]=useState('');
  const[aStep,setAStep]=useState(0);
  const[token,setToken]=useState('');
  const ASTEPS=['Finding angels in your category...','Filtering by funding stage...','Matching check size preferences...','Ranking best-fit investors...'];

  async function runAnalysis(){
    if(!name.trim()){setErr('Please enter your name');return}
    if(!category){setErr('Please select a category');return}
    setErr('');setStep(2);setAStep(0);
    for(let i=0;i<ASTEPS.length;i++){await new Promise(r=>setTimeout(r,700));setAStep(i+1)}
    setMatchCount(400);
    setStep(3);
  }

  async function safePost(url,body){
    const r=await fetch(url,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});
    const text=await r.text();
    if(text.trim().startsWith('<'))throw new Error(r.status===404?'API not reachable - check deployment':'Server error '+r.status);
    let d;try{d=JSON.parse(text)}catch(_){throw new Error('Unexpected response');}
    if(!r.ok)throw new Error(d.error||'Something went wrong');
    return d;
  }

  async function sendOtp(){
    if(!phone||phone.length<5){setErr('Enter a valid phone number');return}
    setErr('');setLoading(true);
    try{
      await safePost(API+'/founder/send-otp',{phone:cc+phone.replace(/^0+/,''),name,matchCount,category,source:localStorage.getItem('wi_source')||document.referrer||'direct',signupUrl:localStorage.getItem('wi_signup_url')||window.location.href});
      setStep(5);
    }catch(e){setErr(e.message)}
    setLoading(false);
  }

  async function verify(){
    if(otp.length!==6){setErr('Enter the 6-digit code');return}
    setLoading(true);setErr('');
    try{
      const d=await safePost(API+'/founder/verify-otp',{phone:cc+phone.replace(/^0+/,''),otp});
      if(d.token){
        localStorage.setItem('wi_founder_token',d.token);
        setToken(d.token);
        // Account is saved ✅ - name + category already in DB from sendOtp
      }
      setStep(6);
    }catch(e){setErr(e.message)}
    setLoading(false);
  }

  async function saveDetails(){
    setLoading(true);setErr('');
    try{
      if(token){
        await fetch(API+'/founder/me',{method:'PUT',headers:{'Content-Type':'application/json','x-founder-token':token},body:JSON.stringify({...form,name,category})});
      }
    }catch(_){}
    setStep(7);setLoading(false);
  }

  const pct=Math.round((aStep/ASTEPS.length)*100);

  // Progress dots: 4 steps shown
  const SLABELS=['Startup','Phone','Details','Done'];
  const dotMap={1:1,2:1,3:1,4:2,5:2,6:3,7:4};
  const dotStep=dotMap[step]||1;

  const CC_OPTIONS=[
    ['+1','🇺🇸 +1'],['+1','🇨🇦 +1'],['+44','🇬🇧 +44'],['+91','🇮🇳 +91'],
    ['+61','🇦🇺 +61'],['+49','🇩🇪 +49'],['+33','🇫🇷 +33'],['+55','🇧🇷 +55'],
    ['+52','🇲🇽 +52'],['+65','🇸🇬 +65'],['+971','🇦🇪 +971'],['+81','🇯🇵 +81'],
    ['+82','🇰🇷 +82'],['+86','🇨🇳 +86'],['+972','🇮🇱 +972'],['+31','🇳🇱 +31'],
    ['+46','🇸🇪 +46'],['+47','🇳🇴 +47'],['+34','🇪🇸 +34'],['+39','🇮🇹 +39'],
    ['+7','🇷🇺 +7'],['+27','🇿🇦 +27'],['+234','🇳🇬 +234'],['+254','🇰🇪 +254'],
    ['+62','🇮🇩 +62'],['+60','🇲🇾 +60'],['+63','🇵🇭 +63'],['+92','🇵🇰 +92'],
    ['+880','🇧🇩 +880'],['+64','🇳🇿 +64'],
  ];

  return(
    <div className="overlay">
      <div className="modal modal-wide">
        <button className="modal-close" onClick={onClose}>×</button>

        {/* Progress */}
        {step<7&&(
          <div className="steps-indicator" style={{marginBottom:26}}>
            {SLABELS.map((s,i)=>(
              <span key={s} style={{display:'contents'}}>
                <div className={`si-dot${dotStep>i+1?' done':dotStep===i+1?' active':' todo'}`}>
                  {dotStep>i+1?'✓':i+1}
                </div>
                {i<3&&<div className={`si-line${dotStep>i+1?' done':''}`}/>}
              </span>
            ))}
          </div>
        )}

        {/* ── STEP 1: Name + Category ── */}
        {step===1&&<>
          <div className="tag-y" style={{marginBottom:12}}>List Your Startup - Free</div>
          <div style={{fontSize:19,fontWeight:800,marginBottom:6,color:'var(--ink)'}}>Who are you and what are you building?</div>
          <div style={{fontSize:13,color:'var(--mu)',marginBottom:22,lineHeight:1.6}}>Takes 2 minutes. Your startup gets featured in our weekly newsletter to 500+ angel investors.</div>
          {err&&<div style={{fontSize:12,color:'var(--r)',background:'#FEF2F2',border:'1px solid #FECACA',padding:'10px 14px',borderRadius:'var(--radius)',marginBottom:14}}>⚠ {err}</div>}
          <div style={{marginBottom:16}}>
            <label className="sdd-lbl">Your Name</label>
            <input className="inp" placeholder="e.g. Ronak Joshi" value={name} onChange={e=>setName(e.target.value)} autoFocus/>
          </div>
          <div style={{marginBottom:8}}>
            <label className="sdd-lbl">Startup Category</label>
            <CatPicker value={category} onChange={v=>setCategory(v)}/>
            {category&&(
              <div style={{fontSize:11,color:'var(--g)',fontWeight:600,marginTop:8,display:'flex',alignItems:'center',gap:6}}>
                <span style={{width:6,height:6,borderRadius:'50%',background:'var(--g)',display:'inline-block'}}/>
                500+ angels actively investing in {category}
              </div>
            )}
          </div>
          <div style={{height:24}}/>
          <button className="btn-primary" style={{width:'100%',fontSize:15,padding:'14px 0'}} onClick={runAnalysis} disabled={!name.trim()||!category}>
            Find My Matched Angels →
          </button>
        </>}

        {/* ── STEP 2: Analyzing ── */}
        {step===2&&<div className="analysis-box">
          <span style={{fontSize:44,display:'block',marginBottom:14,animation:'spin-slow 2.5s linear infinite'}}>🔍</span>
          <div style={{fontSize:18,fontWeight:800,marginBottom:6}}>Scanning the angel network...</div>
          <div style={{fontSize:13,color:'var(--mu)',marginBottom:18}}>Finding investors active in <strong>{category}</strong></div>
          <div className="analysis-bar-bg"><div className="analysis-bar-fill" style={{width:`${pct}%`}}/></div>
          <div className="analysis-steps-list">
            {ASTEPS.map((s,i)=><div key={s} className={`analysis-step-row${aStep>i?' done':''}`}>
              <span style={{width:18,fontSize:12,flexShrink:0}}>{aStep>i?'✓':'○'}</span>{s}
            </div>)}
          </div>
        </div>}

        {/* ── STEP 3: Match reveal ── */}
        {step===3&&<>
          <div style={{textAlign:'center',marginBottom:20}}>
            <div style={{fontSize:36,marginBottom:10}}>🎯</div>
            <div style={{fontSize:20,fontWeight:800,marginBottom:5}}>Great news, {name.split(' ')[0]}!</div>
            <div style={{fontSize:13,color:'var(--mu)'}}>Here are the angels matched to your startup</div>
          </div>
          <div className="match-reveal">
            <div className="match-number">400+</div>
            <div className="match-label">angels investing in <strong>{category}</strong></div>
          </div>
          <div style={{background:'#F0FDF4',border:'1px solid #A7F3D0',borderRadius:'var(--radius)',padding:'13px 16px',marginBottom:20,fontSize:13,color:'#065F46',lineHeight:1.6}}>
            ✓ Verify your phone to unlock your investor list and get notified when angels message you.
          </div>
          <button className="btn-primary" style={{width:'100%',fontSize:15,padding:'14px 0'}} onClick={()=>setStep(4)}>
            Unlock My Investor List →
          </button>
        </>}

        {/* ── STEP 4: Phone ── */}
        {step===4&&<>
          <div style={{textAlign:'center',marginBottom:22}}>
            <div style={{fontSize:36,marginBottom:10}}>📱</div>
            <div style={{fontSize:19,fontWeight:800,marginBottom:8}}>Verify your phone number</div>
            <div style={{fontSize:13,color:'var(--mu)',lineHeight:1.6}}>We will text a quick code. Angels will message you here when interested.</div>
          </div>
          {err&&<div style={{fontSize:12,color:'var(--r)',background:'#FEF2F2',border:'1px solid #FECACA',padding:'10px 14px',borderRadius:'var(--radius)',marginBottom:14}}>{err}</div>}
          <label className="sdd-lbl">Your Phone Number</label>
          <div className="phone-row" style={{marginBottom:8}}>
            <select className="cc-select" value={cc} onChange={e=>setCc(e.target.value)}>
              {CC_OPTIONS.map(([v,l])=><option key={l} value={v}>{l}</option>)}
            </select>
            <input className="phone-inp" type="tel" placeholder="555 000 0000" value={phone} onChange={e=>setPhone(e.target.value.replace(/[^0-9\s\-]/g,''))} autoFocus autoComplete="off"/>
          </div>
          <div style={{fontSize:11,color:'var(--mu)',marginBottom:20,textAlign:'center'}}>Standard SMS rates apply.</div>
          <button className="btn-primary" style={{width:'100%'}} onClick={sendOtp} disabled={loading||phone.length<5}>
            {loading?'Sending...':'Send Verification Code'}
          </button>
        </>}

        {/* ── STEP 5: OTP ── */}
        {step===5&&<>
          <div style={{textAlign:'center',marginBottom:24}}>
            <div style={{fontSize:36,marginBottom:10}}>💬</div>
            <div style={{fontSize:19,fontWeight:800,marginBottom:8}}>Enter your code</div>
            <div style={{fontSize:13,color:'var(--mu)'}}>Sent to <strong>{cc}{phone}</strong></div>
          </div>
          {err&&<div style={{fontSize:12,color:'var(--r)',marginBottom:12,textAlign:'center'}}>{err}</div>}
          <input className="otp-input" placeholder="000000" maxLength={6} value={otp} onChange={e=>setOtp(e.target.value.replace(/[^0-9]/g,''))} autoFocus/>
          <button className="btn-primary" style={{width:'100%',marginBottom:10}} onClick={verify} disabled={loading||otp.length!==6}>
            {loading?'Verifying...':'Confirm →'}
          </button>
          <button className="btn-ghost-sm" style={{width:'100%',textAlign:'center'}} onClick={sendOtp}>Resend code</button>
        </>}

        {/* ── STEP 6: Details (optional) ── */}
        {step===6&&<>
          <div style={{background:'#F0FDF4',border:'1px solid #A7F3D0',borderRadius:'var(--radius)',padding:'12px 16px',marginBottom:16,display:'flex',alignItems:'center',gap:10}}>
            <span style={{fontSize:20}}>✅</span>
            <div>
              <div style={{fontSize:13,fontWeight:700,color:'#065F46'}}>Account created! You're live.</div>
              <div style={{fontSize:12,color:'#065F46',opacity:.8}}>Angels can already find {name.split(' ')[0]}'s startup. Add details to get more messages.</div>
            </div>
          </div>
          <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:4,gap:10,flexWrap:'wrap'}}>
            <div style={{fontSize:18,fontWeight:800,color:'var(--ink)'}}>Add startup details <span style={{fontSize:13,fontWeight:500,color:'var(--mu)'}}>- optional</span></div>
          </div>
          <div style={{fontSize:13,color:'var(--mu)',marginBottom:18,lineHeight:1.6}}>Startups with full details get <strong>3x more angel messages</strong>. Start typing and AI will help fill the rest.</div>
          {err&&<div style={{fontSize:12,color:'var(--r)',background:'#FEF2F2',border:'1px solid #FECACA',padding:'10px 14px',borderRadius:'var(--radius)',marginBottom:14}}>{err}</div>}
          <div style={{marginBottom:14}}>
            <label className="sdd-lbl">Product URL</label>
            <input className="inp" placeholder="https://yourproduct.com" value={form.url} onChange={e=>setForm(f=>({...f,url:e.target.value}))}/>
          </div>
          <div style={{marginBottom:6}}>
            <label className="sdd-lbl">What does your product do?</label>
            <textarea className="inp" rows={2} style={{resize:'none'}} placeholder="e.g. We help restaurants cut no-shows..." value={form.description} onChange={e=>setForm(f=>({...f,description:e.target.value}))}/>
          </div>
          {/* AI auto-fills vision + traction once description has 4+ words */}
          <div style={{marginBottom:14,display:'flex',justifyContent:'flex-end'}}>
            <AiAutofill
              name={name} category={category} url={form.url} description={form.description}
              onFill={fields=>setForm(f=>({
                ...f,
                vision:f.vision||fields.vision||f.vision,
                traction:f.traction||fields.traction||f.traction,
              }))}
            />
          </div>

          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12,marginBottom:22}}>
            <div>
              <label className="sdd-lbl">Total raise target</label>
              <select className="inp" value={form.funding} onChange={e=>setForm(f=>({...f,funding:e.target.value}))}>
                <option value="">Select...</option>
                {['$25K - $75K','$75K - $150K (Pre-seed)','$150K - $300K','$300K - $500K (Seed)','$500K - $1M','$1M - $3M (Series A prep)','$3M+'].map(o=><option key={o} value={o}>{o}</option>)}
              </select>
            </div>
            <div>
              <label className="sdd-lbl">Check size per angel</label>
              <select className="inp" value={form.checkSize||''} onChange={e=>setForm(f=>({...f,checkSize:e.target.value}))}>
                <option value="">Select...</option>
                {['$1K - $5K','$5K - $10K','$10K - $25K','$25K - $50K','$50K - $100K','$100K - $200K','$200K+'].map(o=><option key={o} value={o}>{o}</option>)}
              </select>
            </div>
          </div>
          <button className="btn-primary" style={{width:'100%',fontSize:15,padding:'14px 0'}} onClick={saveDetails} disabled={loading}>
            {loading?'Saving...':'Save & Go to Dashboard →'}
          </button>
        </>}

        {/* ── STEP 7: Done ── */}
        {step===7&&<div style={{textAlign:'center',padding:'16px 0'}}>
          <div style={{fontSize:52,marginBottom:14}}>🚀</div>
          <div style={{fontSize:22,fontWeight:800,marginBottom:10,color:'var(--ink)'}}>You are live, {name.split(' ')[0]}!</div>
          <div style={{fontSize:14,color:'var(--mu)',lineHeight:1.7,marginBottom:8}}>Your startup is now visible to <strong style={{color:'var(--ink)'}}>500+ matched angels</strong>.</div>
          <div style={{fontSize:13,color:'var(--mu)',marginBottom:24,lineHeight:1.6,padding:'12px 16px',background:'#F0FDF4',border:'1px solid #A7F3D0',borderRadius:'var(--radius)'}}>
            📬 You will be featured in the next Monday newsletter.<br/>We will text you when an angel sends you a message.
          </div>
          <button className="btn-primary" style={{width:'100%',marginBottom:10,fontSize:15,padding:'14px 0'}} onClick={()=>window.location.href='/dashboard'}>
            Go to My Dashboard →
          </button>
          <button className="btn-ghost-sm" style={{width:'100%',textAlign:'center'}} onClick={onClose}>Back to homepage</button>
        </div>}
      </div>
    </div>
  );
}


// ─── ADMIN COMPONENTS ─────────────────────────────────────────────────────────
function ABar({data}){
  if(!data?.length)return<div className="adm-empty">No data yet</div>;
  const types=['pageview','search','share','sale','email_capture'];
  const max=Math.max(...data.map(d=>types.reduce((s,t)=>s+(d[t]||0),0)),1);
  return(
    <div className="adm-bars">
      {data.slice(-30).map((d,i)=>(
        <div key={i} className="adm-bar-col">
          <div className="adm-bar-segs">
            {types.filter(t=>d[t]>0).map(t=><div key={t} className="adm-bar-seg" style={{height:`${(d[t]/max)*68}px`,background:ATC[t]}}/>)}
          </div>
          <div className="adm-bar-lbl">{d.day.slice(5)}</div>
        </div>
      ))}
    </div>
  );
}

function ARank({title,items,lk,ck,color}){
  const max=Math.max(...(items||[]).map(i=>i[ck]||0),1);
  return(
    <div className="adm-panel">
      <div className="adm-panel-title">{title}</div>
      {(!items?.length)&&<div className="adm-empty" style={{padding:'10px 0'}}>No data</div>}
      {(items||[]).map((item,i)=>(
        <div key={i} className="adm-rank-row">
          <span className="adm-rank-n">{i+1}</span>
          <span className="adm-rank-lbl">{item[lk]||'(direct)'}</span>
          <div className="adm-rank-bar-wrap"><div className="adm-rank-bar" style={{width:`${(item[ck]/max)*100}%`,background:color}}/></div>
          <span className="adm-rank-count">{item[ck]}</span>
        </div>
      ))}
    </div>
  );
}

function AFeedRow({e}){
  const[open,setOpen]=useState(false);const[cp,setCp]=useState({});
  const hasEmail=e.type==='outreach_generated'&&e.meta?.body;
  function copy(k,txt){navigator.clipboard.writeText(txt).then(()=>{setCp(p=>({...p,[k]:true}));setTimeout(()=>setCp(p=>({...p,[k]:false})),2000)})}
  return(
    <div className="adm-feed-row">
      <div className="adm-feed-top" onClick={()=>hasEmail&&setOpen(o=>!o)}>
        <span className="adm-feed-ic">{ATI[e.type]||'dot'}</span>
        <span className="adm-feed-badge" style={{background:ATB[e.type]||'#f3f4f6',color:ATC[e.type]||'#666'}}>{ATL[e.type]||e.type}</span>
        <div className="adm-feed-sum">
          {e.type==='sale'&&<><strong>${e.meta?.amount||9}</strong>{e.meta?.email&&` · ${e.meta.email}`}</>}
          {e.type==='email_capture'&&<strong>{e.meta?.email||'?'}</strong>}
          {e.type==='search'&&<><strong>{e.meta?.vcFirm||'?'}</strong> · {e.meta?.free?'free':'paid'}</>}
          {e.type==='outreach_generated'&&<><strong>{e.meta?.founder}</strong> at {e.meta?.company}</>}
          {e.type==='pageview'&&(e.meta?.path||'/')}
        </div>
        <span className="adm-feed-time">{ago(e.createdAt)} ago</span>
      </div>
      {hasEmail&&open&&(
        <div className="adm-expand">
          <div className="adm-exp-subj-row"><span className="adm-exp-subj-lbl">Subject</span><span className="adm-exp-subj-val">{e.meta.subject}</span></div>
          <div className="adm-exp-body-lbl">Body</div>
          <div className="adm-exp-body">{e.meta.body}</div>
          <button className={`adm-copy-btn${cp.f?' done':''}`} onClick={()=>copy('f',`Subject: ${e.meta.subject}\n\n${e.meta.body}`)}>{cp.f?'Copied':'Copy'}</button>
          {e.meta.toEmail&&<button className={`adm-copy-btn addr${cp.a?' done':''}`} onClick={()=>copy('a',e.meta.toEmail)}>{cp.a?'Copied':'Address'}</button>}
        </div>
      )}
    </div>
  );
}

function AdminAngels(){
  const[angels,setAngels]=useState([]);const[name,setName]=useState('');const[title,setTitle]=useState('');const[notable,setNotable]=useState('');const[loading,setLoading]=useState(false);
  const load=()=>fetch(API+'/admin/angels',{headers:{'x-admin-secret':ADM}}).then(r=>r.json()).then(d=>setAngels(d.angels||[]));
  useEffect(()=>{load()},[]);
  async function add(){if(!name.trim())return;setLoading(true);await fetch(API+'/admin/angels',{method:'POST',headers:{'Content-Type':'application/json','x-admin-secret':ADM},body:JSON.stringify({name,title,notable})});setName('');setTitle('');setNotable('');await load();setLoading(false)}
  async function del(id){await fetch(API+'/admin/angels/'+id,{method:'DELETE',headers:{'x-admin-secret':ADM}});await load()}
  return(
    <div>
      <div className="adm-stat-grid" style={{marginBottom:18}}>
        <div className="adm-stat" style={{'--acc':'#F59E0B'}}><div className="adm-stat-ic">angel</div><div className="adm-stat-v">{angels.length}</div><div className="adm-stat-l">Total Angels</div></div>
        <div className="adm-stat" style={{'--acc':'#10B981'}}><div className="adm-stat-ic">check</div><div className="adm-stat-v">{angels.filter(a=>a.active).length}</div><div className="adm-stat-l">Active</div></div>
      </div>
      <div className="adm-panel" style={{marginBottom:14}}>
        <div className="adm-panel-title">Add Angel Investor</div>
        <div style={{display:'flex',gap:8,marginBottom:8,flexWrap:'wrap'}}>
          <input className="adm-text-inp" placeholder="Full Name *" value={name} onChange={e=>setName(e.target.value)} style={{flex:'2 1 150px'}}/>
          <button className="adm-add-btn" onClick={add} disabled={loading}>Add</button>
        </div>
        <div style={{display:'flex',gap:8,flexWrap:'wrap'}}>
          <input className="adm-text-inp" placeholder="Title / Role" value={title} onChange={e=>setTitle(e.target.value)} style={{flex:'1 1 130px'}}/>
          <input className="adm-text-inp" placeholder="Notable investment" value={notable} onChange={e=>setNotable(e.target.value)} style={{flex:'1 1 130px'}}/>
        </div>
      </div>
      <div className="adm-panel">
        <div className="adm-panel-title">Angel List ({angels.length})</div>
        {!angels.length&&<div className="adm-empty">No angels yet</div>}
        {angels.map(a=>(
          <div key={a._id} className="adm-angel-row">
            <div className="adm-angel-av">{(a.name||'?').split(' ').map(w=>w[0]).slice(0,2).join('')}</div>
            <div className="adm-angel-info"><div className="adm-angel-name">{a.name}</div><div className="adm-angel-sub">{a.title}{a.notable&&' · '+a.notable}</div></div>
            <button className="adm-del-btn" onClick={()=>del(a._id)}>Remove</button>
          </div>
        ))}
      </div>
    </div>
  );
}

function AdminProducts(){
  const[products,setProducts]=useState([]);
  const[expanded,setExpanded]=useState(null);
  const[smsMsg,setSmsMsg]=useState('');
  const[smsSending,setSmsSending]=useState(false);
  const[smsResult,setSmsResult]=useState(null);
  const[smsTarget,setSmsTarget]=useState(null);

  useEffect(()=>{fetch(API+'/admin/products',{headers:{'x-admin-secret':ADM}}).then(r=>r.json()).then(d=>setProducts(d.products||[]))},[]);

  async function sendSms(){
    if(!smsMsg.trim())return;
    setSmsSending(true);setSmsResult(null);
    try{
      if(smsTarget){
        const p=products.find(x=>x._id===smsTarget);
        await fetch('https://datingggo-d609631f502c.herokuapp.com/send-smsd',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({messages:[{phoneNumber:p.phone,message:smsMsg}]})});
        setSmsResult({sent:1});
      }else{
        const r=await fetch(API+'/admin/bulk-sms',{method:'POST',headers:{'Content-Type':'application/json','x-admin-secret':ADM},body:JSON.stringify({message:smsMsg})});
        setSmsResult(await r.json());
      }
    }catch(e){setSmsResult({error:e.message})}
    setSmsSending(false);
  }

  const verified=products.filter(p=>p.verified);

  return(
    <div>
      <div className="adm-stat-grid" style={{marginBottom:18}}>
        <div className="adm-stat" style={{'--acc':'#7C3AED'}}><div className="adm-stat-ic">🚀</div><div className="adm-stat-v">{products.length}</div><div className="adm-stat-l">Total</div></div>
        <div className="adm-stat" style={{'--acc':'#10B981'}}><div className="adm-stat-ic">✅</div><div className="adm-stat-v">{verified.length}</div><div className="adm-stat-l">Verified</div></div>
        <div className="adm-stat" style={{'--acc':'#F59E0B'}}><div className="adm-stat-ic">⏳</div><div className="adm-stat-v">{products.filter(p=>!p.verified).length}</div><div className="adm-stat-l">Pending</div></div>
      </div>

      <div className="adm-panel" style={{marginBottom:14}}>
        <div className="adm-panel-title" style={{display:'flex',alignItems:'center',justifyContent:'space-between',flexWrap:'wrap',gap:8}}>
          <span>📱 SMS - {smsTarget?`to ${products.find(p=>p._id===smsTarget)?.phone}`:`Bulk to ${verified.length} verified`}</span>
          {smsTarget&&<button onClick={()=>setSmsTarget(null)} style={{background:'none',border:'none',color:'var(--bl)',fontSize:11,cursor:'pointer',fontWeight:600}}>Switch to bulk</button>}
        </div>
        <textarea className="adm-sms-area" placeholder="Type your message..." value={smsMsg} onChange={e=>setSmsMsg(e.target.value)} style={{minHeight:72}}/>
        <div style={{display:'flex',alignItems:'center',gap:10,flexWrap:'wrap'}}>
          <button className="adm-sms-send" onClick={sendSms} disabled={smsSending||!smsMsg.trim()}>{smsSending?'Sending...':smsTarget?'Send to Founder':`Send to ${verified.length} Founders`}</button>
          {smsResult&&!smsResult.error&&<span style={{fontSize:12,color:'var(--g)',fontWeight:700}}>✓ Sent to {smsResult.sent}</span>}
          {smsResult?.error&&<span style={{fontSize:12,color:'var(--r)'}}>Error: {smsResult.error}</span>}
          <span style={{fontSize:10,color:'var(--mu)',marginLeft:'auto'}}>{smsMsg.length}/160</span>
        </div>
      </div>

      <div className="adm-panel">
        <div className="adm-panel-title">Submitted Products ({products.length})</div>
        {!products.length&&<div className="adm-empty">No submissions yet</div>}
        {products.map(p=>(
          <div key={p._id} className="adm-product-row">
            <div style={{display:'flex',alignItems:'flex-start',justifyContent:'space-between',gap:8,flexWrap:'wrap'}}>
              <div style={{flex:1,minWidth:0}}>
                <div className="adm-product-url">
                  <a href={p.url} target="_blank" rel="noreferrer">{p.url}</a>
                  <span className={p.verified?'verified-badge':'pending-badge'}>{p.verified?'Verified':'Pending'}</span>
                  {p.category&&<span style={{fontSize:9,background:'#EDE9FE',color:'#5B21B6',padding:'2px 6px',borderRadius:4,marginLeft:5,fontWeight:700}}>{p.category}</span>}
                  {p.source&&p.source!=='direct'&&<span style={{fontSize:9,background:'#FEF3C7',color:'#92400E',padding:'2px 6px',borderRadius:4,marginLeft:5,fontWeight:700}}>📍 {p.source}</span>}
                </div>
                <div className="adm-product-meta" style={{marginTop:3}}>
                  {p.funding}{p.checkSize&&<> · Check: {p.checkSize}</>} · {p.phone} · {p.matchCount?.toLocaleString()} matches · {new Date(p.createdAt).toLocaleDateString()}
                </div>
              </div>
              <div style={{display:'flex',gap:6,flexShrink:0}}>
                <button onClick={()=>setExpanded(expanded===p._id?null:p._id)} style={{background:'var(--s2)',border:'1px solid var(--bd)',color:'var(--mu)',fontSize:11,fontWeight:600,padding:'4px 10px',borderRadius:5,cursor:'pointer',whiteSpace:'nowrap'}}>{expanded===p._id?'Hide':'Details'}</button>
                {p.verified&&<button onClick={()=>{setSmsTarget(p._id);setSmsMsg('');setSmsResult(null);window.scrollTo(0,0)}} style={{background:'#0A66C2',color:'#fff',border:'none',fontSize:11,fontWeight:700,padding:'4px 10px',borderRadius:5,cursor:'pointer'}}>SMS</button>}
              </div>
            </div>
            {expanded===p._id&&(
              <div style={{marginTop:10,display:'flex',flexDirection:'column',gap:8}}>
                {p.description&&<div style={{background:'var(--s2)',border:'1px solid var(--bd)',padding:'10px 13px',borderRadius:'var(--radius)',fontSize:12,color:'var(--ink2)',lineHeight:1.65}}><div style={{fontSize:9,fontWeight:700,textTransform:'uppercase',letterSpacing:'.1em',color:'var(--mu)',marginBottom:5}}>Description</div>{p.description}</div>}
                {p.vision&&<div style={{background:'#F5F3FF',border:'1px solid #DDD6FE',padding:'10px 13px',borderRadius:'var(--radius)',fontSize:12,color:'#3B0764',lineHeight:1.65}}><div style={{fontSize:9,fontWeight:700,textTransform:'uppercase',letterSpacing:'.1em',color:'#7C3AED',marginBottom:5}}>Vision</div>{p.vision}</div>}
                {p.traction&&<div style={{background:'#F0FDF4',border:'1px solid #A7F3D0',padding:'10px 13px',borderRadius:'var(--radius)',fontSize:12,color:'#065F46',lineHeight:1.65}}><div style={{fontSize:9,fontWeight:700,textTransform:'uppercase',letterSpacing:'.1em',color:'#10B981',marginBottom:5}}>Traction</div>{p.traction}</div>}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}


function AdminChats(){
  const[convs,setConvs]=useState([]);const[active,setActive]=useState(null);
  const[messages,setMessages]=useState([]);const[text,setText]=useState('');
  const[asRole,setAsRole]=useState('angel'); // 'angel' or 'founder'
  const[sending,setSending]=useState(false);const[loading,setLoading]=useState(true);

  useEffect(()=>{
    fetch(API+'/admin/conversations',{headers:{'x-admin-secret':ADM}})
      .then(r=>r.json()).then(d=>setConvs(d.conversations||[])).finally(()=>setLoading(false));
  },[]);

  useEffect(()=>{
    if(!active)return;
    const load=()=>fetch(`${API}/admin/conversation-messages?founderId=${active.founderId}&angelId=${active.angelId}`,{headers:{'x-admin-secret':ADM}}).then(r=>r.json()).then(d=>setMessages(d.messages||[]));
    load();const t=setInterval(load,3000);return()=>clearInterval(t);
  },[active]);

  async function sendAs(){
    if(!text.trim()||!active)return;
    setSending(true);
    try{
      const endpoint=asRole==='angel'?'/admin/message-as-angel':'/admin/message-as-founder';
      await fetch(API+endpoint,{method:'POST',headers:{'Content-Type':'application/json','x-admin-secret':ADM},body:JSON.stringify({founderId:active.founderId,angelId:active.angelId,text})});
      setText('');
      const r=await fetch(`${API}/admin/conversation-messages?founderId=${active.founderId}&angelId=${active.angelId}`,{headers:{'x-admin-secret':ADM}});
      const d=await r.json();setMessages(d.messages||[]);
    }catch(_){}
    setSending(false);
  }

  return(
    <div style={{display:'grid',gridTemplateColumns:active?'280px 1fr':'1fr',gap:0,background:'#fff',border:'1px solid var(--bd)',borderRadius:10,overflow:'hidden',minHeight:500}}>
      {/* Conversation list */}
      <div style={{borderRight:active?'1px solid var(--bd)':'none'}}>
        <div style={{padding:'14px 16px',borderBottom:'1px solid var(--bd)',fontSize:13,fontWeight:700,display:'flex',alignItems:'center',justifyContent:'space-between'}}>
          All Conversations <span style={{fontSize:11,color:'var(--mu)',fontWeight:400}}>{convs.length} total</span>
        </div>
        {loading&&<div style={{padding:24,textAlign:'center',fontSize:13,color:'var(--mu)'}}>Loading...</div>}
        {!loading&&convs.length===0&&<div style={{padding:24,textAlign:'center',fontSize:13,color:'var(--mu)'}}>No conversations yet</div>}
        {convs.map((c,i)=>(
          <div key={i} onClick={()=>setActive(c)} style={{padding:'12px 16px',cursor:'pointer',borderBottom:'1px solid var(--s3)',background:active?.founderId===c.founderId&&active?.angelId===c.angelId?'#FFFBEB':'#fff',transition:'background .1s'}}>
            <div style={{fontSize:12,fontWeight:700,marginBottom:2,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{c.founder?.name||c.founder?.url||'Founder'} ↔ {c.angel?.name||'Angel'}</div>
            <div style={{fontSize:10,color:'var(--mu)',marginBottom:3}}>{c.founder?.category||''} · {c.count} messages</div>
            <div style={{fontSize:10,color:'var(--mu2)',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{c.lastMsg?.text?.slice(0,50)}</div>
          </div>
        ))}
      </div>

      {/* Chat view + admin send */}
      {active&&(
        <div style={{display:'flex',flexDirection:'column',height:'100%',minHeight:500}}>
          {/* Header */}
          <div style={{padding:'12px 16px',borderBottom:'1px solid var(--bd)',background:'var(--s2)',display:'flex',alignItems:'center',justifyContent:'space-between',gap:10,flexWrap:'wrap'}}>
            <div>
              <div style={{fontSize:13,fontWeight:700}}>{active.founder?.name||active.founder?.url} ↔ {active.angel?.name}</div>
              <div style={{fontSize:10,color:'var(--mu)'}}>Founder: {active.founder?.phone} · Angel: {active.angel?.phone||'no phone'}</div>
            </div>
            <button onClick={()=>setActive(null)} style={{background:'none',border:'none',color:'var(--mu)',fontSize:18,cursor:'pointer'}}>×</button>
          </div>

          {/* Messages */}
          <div style={{flex:1,overflowY:'auto',padding:'14px 16px',display:'flex',flexDirection:'column',gap:8,minHeight:200}}>
            {messages.length===0&&<div style={{textAlign:'center',padding:20,fontSize:12,color:'var(--mu)'}}>No messages yet</div>}
            {messages.map((m,i)=>{
              const isAngel=m.senderType==='angel';
              return(
                <div key={i} style={{display:'flex',flexDirection:'column',alignItems:isAngel?'flex-start':'flex-end'}}>
                  <div style={{fontSize:9,color:'var(--mu)',marginBottom:3,fontWeight:600}}>{isAngel?`👼 ${active.angel?.name||'Angel'}`:`🚀 ${active.founder?.name||'Founder'}`}</div>
                  <div style={{maxWidth:'75%',background:isAngel?'#EDE9FE':'#DBEAFE',padding:'9px 13px',borderRadius:isAngel?'12px 12px 12px 3px':'12px 12px 3px 12px',fontSize:13,lineHeight:1.55}}>
                    {m.text}
                    <div style={{fontSize:9,color:'#888',marginTop:4,textAlign:'right'}}>{new Date(m.createdAt).toLocaleTimeString([],{hour:'2-digit',minute:'2-digit'})}</div>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Admin send as */}
          <div style={{padding:'12px 16px',borderTop:'1px solid var(--bd)',background:'var(--s2)'}}>
            <div style={{fontSize:10,fontWeight:700,letterSpacing:'.08em',textTransform:'uppercase',color:'var(--mu)',marginBottom:8}}>Send as:</div>
            <div style={{display:'flex',gap:6,marginBottom:10}}>
              <button onClick={()=>setAsRole('angel')} style={{flex:1,padding:'7px 0',border:`1.5px solid ${asRole==='angel'?'#7C3AED':'var(--bd)'}`,borderRadius:'var(--radius)',fontSize:12,fontWeight:700,cursor:'pointer',background:asRole==='angel'?'#F5F3FF':'#fff',color:asRole==='angel'?'#7C3AED':'var(--mu)'}}>
                👼 Angel ({active.angel?.name?.split(' ')[0]||'Angel'})
              </button>
              <button onClick={()=>setAsRole('founder')} style={{flex:1,padding:'7px 0',border:`1.5px solid ${asRole==='founder'?'#2563EB':'var(--bd)'}`,borderRadius:'var(--radius)',fontSize:12,fontWeight:700,cursor:'pointer',background:asRole==='founder'?'#EFF6FF':'#fff',color:asRole==='founder'?'#2563EB':'var(--mu)'}}>
                🚀 Founder ({active.founder?.name?.split(' ')[0]||'Founder'})
              </button>
            </div>
            <div style={{display:'flex',gap:8}}>
              <input value={text} onChange={e=>setText(e.target.value)} onKeyDown={e=>e.key==='Enter'&&sendAs()} placeholder={`Message as ${asRole}...`} style={{flex:1,background:'#fff',border:'1.5px solid var(--bd)',padding:'9px 13px',borderRadius:'var(--radius)',outline:'none',fontSize:13,fontFamily:'inherit'}}/>
              <button onClick={sendAs} disabled={sending||!text.trim()} style={{background:'var(--ink)',color:'#fff',border:'none',padding:'9px 20px',borderRadius:'var(--radius)',fontSize:13,fontWeight:700,cursor:'pointer',opacity:text.trim()?1:.4}}>{sending?'...':'Send'}</button>
            </div>
            <div style={{fontSize:10,color:'var(--mu)',marginTop:6}}>⚠ The {asRole} will receive an SMS notification with this message.</div>
          </div>
        </div>
      )}
    </div>
  );
}

function AdminPendingAngels(){
  const[list,setList]=useState([]);const[loading,setLoading]=useState(true);
  const[acting,setActing]=useState(null);

  const load=()=>fetch(API+'/admin/angels/pending',{headers:{'x-admin-secret':ADM}})
    .then(r=>r.json()).then(d=>{setList(d.angels||[]);setLoading(false);}).catch(()=>setLoading(false));

  useEffect(()=>{load();},[]);

  async function approve(id){setActing(id);await fetch(`${API}/admin/angels/${id}/approve`,{method:'POST',headers:{'x-admin-secret':ADM}});setActing(null);load();}
  async function reject(id){setActing(id);await fetch(`${API}/admin/angels/${id}/reject`,{method:'POST',headers:{'x-admin-secret':ADM}});setActing(null);load();}

  return(
    <div className="adm-panel">
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:4}}>
        <div className="adm-panel-title" style={{marginBottom:0}}>Pending Investor Applications</div>
        <span style={{background:list.length>0?'#FEF2F2':'#F0FDF4',color:list.length>0?'#DC2626':'#065F46',fontSize:12,fontWeight:700,padding:'3px 10px',borderRadius:100}}>{list.length} pending</span>
      </div>
      <div style={{fontSize:12,color:'var(--mu)',marginBottom:20}}>Approve or reject each investor after reviewing their LinkedIn.</div>
      {loading&&<div style={{fontSize:13,color:'var(--mu)'}}>Loading...</div>}
      {!loading&&list.length===0&&<div style={{fontSize:13,color:'var(--g)',padding:'20px 0',textAlign:'center'}}>✓ No pending applications</div>}
      <div style={{display:'flex',flexDirection:'column',gap:10}}>
        {list.map(a=>(
          <div key={a._id} style={{background:'#fff',border:'1px solid var(--bd)',borderRadius:'var(--radius-lg)',padding:'14px 16px',display:'flex',alignItems:'flex-start',gap:14,flexWrap:'wrap'}}>
            <div style={{flex:1,minWidth:200}}>
              <div style={{fontSize:14,fontWeight:700,marginBottom:2}}>{a.name||'Unknown'}</div>
              <div style={{fontSize:12,color:'var(--mu)',marginBottom:4}}>{a.title||''}{a.firm?` · ${a.firm}`:''}</div>
              <div style={{display:'flex',gap:6,flexWrap:'wrap',marginBottom:6}}>
                <span style={{fontSize:11,background:'var(--s2)',border:'1px solid var(--bd)',padding:'2px 8px',borderRadius:100,color:'var(--ink2)',fontFamily:"'DM Mono',monospace"}}>{a.phone}</span>
                {a.checkSize&&<span style={{fontSize:11,background:'#FFFBEB',border:'1px solid #FDE68A',color:'#92400E',padding:'2px 8px',borderRadius:100,fontWeight:600}}>{a.checkSize}</span>}
              </div>
              {a.linkedin?(
                <a href={a.linkedin} target="_blank" rel="noreferrer" style={{fontSize:12,color:'#1D4ED8',display:'inline-flex',alignItems:'center',gap:4,fontWeight:600}}>
                  <span style={{background:'#1D4ED8',color:'#fff',fontSize:9,fontWeight:800,padding:'1px 5px',borderRadius:3}}>in</span>
                  View LinkedIn →
                </a>
              ):<span style={{fontSize:12,color:'var(--r)',fontWeight:600}}>⚠ No LinkedIn submitted</span>}
              {a.bio&&<div style={{fontSize:12,color:'var(--mu)',marginTop:6,lineHeight:1.5,fontStyle:'italic'}}>"{a.bio.slice(0,120)}"</div>}
            </div>
            <div style={{display:'flex',gap:8,flexShrink:0}}>
              <button onClick={()=>approve(a._id)} disabled={acting===a._id} style={{background:'#10B981',color:'#fff',border:'none',padding:'8px 18px',borderRadius:'var(--radius)',fontSize:13,fontWeight:700,cursor:'pointer',opacity:acting===a._id?.6:1}}>
                {acting===a._id?'...':'✓ Approve'}
              </button>
              <button onClick={()=>reject(a._id)} disabled={acting===a._id} style={{background:'#fff',color:'var(--r)',border:'1px solid var(--r)',padding:'8px 18px',borderRadius:'var(--radius)',fontSize:13,fontWeight:700,cursor:'pointer',opacity:acting===a._id?.6:1}}>
                Reject
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function AdminWaitlist(){
  const[list,setList]=useState([]);const[loading,setLoading]=useState(true);
  const[msg,setMsg]=useState('');const[sending,setSending]=useState(false);const[result,setResult]=useState(null);

  useEffect(()=>{
    fetch(API+'/admin/waitlist',{headers:{'x-admin-secret':ADM}})
      .then(r=>r.json()).then(d=>{setList(d.waitlist||[]);setLoading(false);}).catch(()=>setLoading(false));
  },[]);

  async function sendBulk(){
    if(!msg.trim()||list.length===0)return;
    setSending(true);setResult(null);
    try{
      const r=await fetch(API+'/admin/waitlist-sms',{method:'POST',headers:{'Content-Type':'application/json','x-admin-secret':ADM},body:JSON.stringify({message:msg})});
      const d=await r.json();
      setResult(d);
    }catch(e){setResult({error:e.message});}
    setSending(false);
  }

  return(
    <div className="adm-panel">
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:4}}>
        <div className="adm-panel-title" style={{marginBottom:0}}>Waitlist</div>
        <span style={{background:'#EDE9FE',color:'#5B21B6',fontSize:12,fontWeight:700,padding:'3px 10px',borderRadius:100}}>{list.length} people</span>
      </div>
      <div style={{fontSize:12,color:'var(--mu)',marginBottom:20}}>Users who joined when all spots were taken.</div>

      {/* Bulk SMS to waitlist */}
      <div style={{background:'var(--s2)',border:'1px solid var(--bd)',borderRadius:'var(--radius-lg)',padding:'16px 18px',marginBottom:20}}>
        <div style={{fontSize:13,fontWeight:700,marginBottom:10}}>📢 SMS All Waitlist ({list.length})</div>
        <textarea className="adm-sms-area" placeholder="e.g. Good news! A spot just opened up on VCInvest. List your startup free: vcinvest.pro" value={msg} onChange={e=>setMsg(e.target.value)} rows={3}/>
        <div style={{display:'flex',alignItems:'center',gap:12,flexWrap:'wrap'}}>
          <button className="adm-sms-send" onClick={sendBulk} disabled={sending||!msg.trim()||list.length===0}>
            {sending?'Sending...':`Send to ${list.length} people`}
          </button>
          {result?.sent!==undefined&&<span style={{fontSize:13,color:'var(--g)',fontWeight:700}}>✓ Sent to {result.sent}</span>}
          {result?.error&&<span style={{fontSize:13,color:'var(--r)'}}>Error: {result.error}</span>}
        </div>
        <div style={{fontSize:11,color:'var(--mu)',marginTop:8}}>{msg.length}/160 chars</div>
      </div>

      {loading&&<div style={{fontSize:13,color:'var(--mu)'}}>Loading...</div>}
      {!loading&&list.length===0&&<div style={{fontSize:13,color:'var(--mu)',padding:'20px 0',textAlign:'center'}}>No waitlist signups yet.</div>}
      <div style={{display:'flex',flexDirection:'column',gap:8}}>
        {list.map((w,i)=>(
          <div key={i} style={{background:'#fff',border:'1px solid var(--bd)',borderRadius:'var(--radius)',padding:'10px 14px',display:'flex',alignItems:'center',justifyContent:'space-between',gap:12}}>
            <div style={{fontSize:13,fontWeight:700,fontFamily:"'DM Mono',monospace"}}>{w.phone}</div>
            <div style={{display:'flex',gap:8,alignItems:'center',flexWrap:'wrap'}}>
              {w.source&&<span style={{fontSize:10,background:'#FEF3C7',color:'#92400E',padding:'2px 8px',borderRadius:100,fontWeight:700}}>📍 {w.source}</span>}
              {w.signupUrl&&<span style={{fontSize:10,color:'var(--mu)',maxWidth:160,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{w.signupUrl.replace('https://','')}</span>}
              <span style={{fontSize:11,color:'var(--mu)'}}>{new Date(w.createdAt).toLocaleDateString()}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

function AdminBulkSMS(){
  const[msg,setMsg]=useState('');const[loading,setLoading]=useState(false);const[result,setResult]=useState(null);
  const[richOnly,setRichOnly]=useState(false);

  // Country codes for high-income countries
  const RICH_CODES=['+1','+44','+61','+64','+353','+49','+33','+31','+46','+47','+45','+41','+43','+32','+358','+354','+352','+371','+370','+372','+421','+420','+386','+356','+357','+377','+423','+376','+39','+34','+351','+32','+65','+81','+82','+852','+972','+971','+974','+973','+965','+968','+966'];

  async function send(){
    if(!msg.trim())return;setLoading(true);setResult(null);
    try{
      const r=await fetch(API+'/admin/bulk-sms',{
        method:'POST',
        headers:{'Content-Type':'application/json','x-admin-secret':ADM},
        body:JSON.stringify({message:msg,richOnly,richCodes:RICH_CODES})
      });
      setResult(await r.json());
    }catch(e){setResult({error:e.message})}
    setLoading(false);
  }

  return(
    <div className="adm-panel">
      <div className="adm-panel-title">Bulk SMS</div>
      <div style={{fontSize:12,color:'var(--mu)',marginBottom:16,lineHeight:1.6}}>Sends an SMS to verified founders who submitted their phone number.</div>

      {/* Filter toggle */}
      <div style={{display:'flex',gap:8,marginBottom:16}}>
        <button onClick={()=>setRichOnly(false)} style={{flex:1,padding:'9px 0',border:`1.5px solid ${!richOnly?'var(--ink)':'var(--bd)'}`,borderRadius:'var(--radius)',fontSize:13,fontWeight:700,cursor:'pointer',background:!richOnly?'var(--ink)':'#fff',color:!richOnly?'#fff':'var(--mu)',transition:'all .15s'}}>
          🌍 All Countries
        </button>
        <button onClick={()=>setRichOnly(true)} style={{flex:1,padding:'9px 0',border:`1.5px solid ${richOnly?'#F59E0B':'var(--bd)'}`,borderRadius:'var(--radius)',fontSize:13,fontWeight:700,cursor:'pointer',background:richOnly?'#FFFBEB':'#fff',color:richOnly?'#92400E':'var(--mu)',transition:'all .15s'}}>
          💰 Rich Countries Only
        </button>
      </div>

      {richOnly&&(
        <div style={{background:'#FFFBEB',border:'1px solid #FDE68A',borderRadius:'var(--radius)',padding:'10px 14px',marginBottom:14,fontSize:12,color:'#92400E',lineHeight:1.6}}>
          Filters to: 🇺🇸 US · 🇬🇧 UK · 🇨🇦 Canada · 🇦🇺 Australia · 🇩🇪 Germany · 🇸🇬 Singapore · 🇯🇵 Japan · 🇦🇪 UAE · 🇮🇱 Israel · 🇰🇷 Korea · and 30+ more high-income countries
        </div>
      )}

      <textarea className="adm-sms-area" placeholder="Type your message here..." value={msg} onChange={e=>setMsg(e.target.value)}/>
      <div style={{display:'flex',alignItems:'center',gap:12,flexWrap:'wrap'}}>
        <button className="adm-sms-send" onClick={send} disabled={loading||!msg.trim()}>
          {loading?'Sending...':`Send${richOnly?' to Rich Countries':' to All Founders'}`}
        </button>
        {result&&!result.error&&<span style={{fontSize:13,color:'var(--g)',fontWeight:700}}>✓ Sent to {result.sent} founders</span>}
        {result?.error&&<span style={{fontSize:13,color:'var(--r)'}}>Error: {result.error}</span>}
      </div>
      <div style={{fontSize:11,color:'var(--mu)',marginTop:10}}>{msg.length}/160 chars{msg.length>160&&<span style={{color:'var(--r)'}}> (multiple segments)</span>}</div>
    </div>
  );
}

function AdminApp(){
  const[auth,setAuth]=useState(()=>sessionStorage.getItem('wi_admin')==='1');
  const[sec,setSec]=useState('');const[err,setErr]=useState('');
  const[tab,setTab]=useState('overview');const[days,setDays]=useState(30);
  const[data,setData]=useState(null);const[loading,setLoading]=useState(false);const[last,setLast]=useState(null);
  const load=useCallback(async()=>{
    if(!auth)return;setLoading(true);
    try{const r=await fetch(`${API}/admin/stats?days=${days}`,{headers:{'x-admin-secret':ADM}});if(r.status===401){setAuth(false);sessionStorage.removeItem('wi_admin');return}setData(await r.json());setLast(new Date())}
    catch(e){console.error(e)}finally{setLoading(false)}
  },[auth,days]);
  useEffect(()=>{load()},[load]);
  useEffect(()=>{if(!auth)return;const t=setInterval(load,60000);return()=>clearInterval(t)},[auth,load]);
  function login(){if(sec===ADM){sessionStorage.setItem('wi_admin','1');setAuth(true)}else setErr('Wrong secret key')}
  if(!auth)return(
    <div className="adm-login-wrap">
      <div className="adm-login-box">
        <div className="adm-login-logo">VC<em>Invest</em></div>
        <div className="adm-login-sub">Admin Dashboard</div>
        <input className="inp" type="password" placeholder="Admin secret key" value={sec} onChange={e=>setSec(e.target.value)} onKeyDown={e=>e.key==='Enter'&&login()} autoFocus style={{marginBottom:12}}/>
        <button className="btn-primary" style={{width:'100%'}} onClick={login}>Enter</button>
        {err&&<div style={{fontSize:12,color:'var(--r)',marginTop:9}}>{err}</div>}
      </div>
    </div>
  );
  const t=data?.totals||{};
  const NAV=[['overview','Overview'],['traffic','Traffic'],['searches','Searches'],['revenue','Revenue'],['feed','Live Feed'],['angels','Angels'],['pending','⏳ Pending'],['products','Products'],['sms','Bulk SMS'],['waitlist','📋 Waitlist'],['chats','💬 Chats']];
  return(
    <div className="adm-layout">
      <aside className="adm-sidebar">
        <div className="adm-logo">VC<em>Invest</em></div>
        <div className="adm-nav-section">Menu</div>
        {NAV.map(([id,lb])=><div key={id} className={`adm-nav-item${tab===id?' on':''}`} onClick={()=>setTab(id)}>{lb}</div>)}
        <div className="adm-period"><select value={days} onChange={e=>setDays(Number(e.target.value))}>{[7,14,30,60,90].map(d=><option key={d} value={d}>Last {d} days</option>)}</select></div>
      </aside>
      <main className="adm-main">
        <div className="adm-header">
          <div><div className="adm-title">{{overview:'Overview',traffic:'Traffic',searches:'Searches',revenue:'Revenue',feed:'Live Feed',angels:'Angels',products:'Products',sms:'Bulk SMS'}[tab]}</div><div className="adm-subtitle">Last {days} days{last&&` · Updated ${ago(last)} ago`}</div></div>
          <button className="adm-refresh" onClick={load} disabled={loading}>{loading?'...':'Refresh'}</button>
        </div>
        {tab==='angels'&&<AdminAngels/>}
        {tab==='products'&&<AdminProducts/>}
        {tab==='sms'&&<AdminBulkSMS/>}
        {tab==='waitlist'&&<AdminWaitlist/>}
        {tab==='pending'&&<AdminPendingAngels/>}
        {tab==='chats'&&<AdminChats/>}
        {loading&&!data&&<div className="adm-loading"><div className="adm-spinner"/>Loading...</div>}
        {data&&<>
          {tab==='overview'&&<>
            <div className="adm-stat-grid">
              {[['eye','pageview',af(t.pageviews),'Page Views'],['user','pageview',af(t.uniqueVisitors),'Visitors'],['search','search',af(t.searches),'Searches'],['share','share',af(t.shares),'Shares'],['mail','email_capture',af(t.emailCaptures),'Emails'],['write','outreach_generated',af(t.outreachGenerated),'Drafts'],['bag','sale',af(t.sales),'Sales'],['money','sale',am(t.revenue),'Revenue'],['inbox','email_capture',af(t.subscribers),'Subscribers']].map(([ic,type,v,l])=>(
                <div key={l} className="adm-stat" style={{'--acc':ATC[type]}}><div className="adm-stat-ic">{ic}</div><div className="adm-stat-v">{v}</div><div className="adm-stat-l">{l}</div></div>
              ))}
            </div>
            <div className="adm-chart-wrap"><div className="adm-chart-title">Daily Activity</div><ABar data={data.chartData}/></div>
            <div className="adm-2col"><ARank title="Top Referrers" items={data.topReferrers} lk="source" ck="count" color={ATC.pageview}/><ARank title="Top VC Searches" items={data.topVcSearched} lk="vc" ck="count" color={ATC.search}/></div>
          </>}
          {tab==='traffic'&&<>
            <div className="adm-stat-grid">
              <div className="adm-stat" style={{'--acc':ATC.pageview}}><div className="adm-stat-ic">eye</div><div className="adm-stat-v">{af(t.pageviews)}</div><div className="adm-stat-l">Page Views</div></div>
              <div className="adm-stat" style={{'--acc':ATC.pageview}}><div className="adm-stat-ic">user</div><div className="adm-stat-v">{af(t.uniqueVisitors)}</div><div className="adm-stat-l">Visitors</div></div>
              <div className="adm-stat" style={{'--acc':ATC.share}}><div className="adm-stat-ic">share</div><div className="adm-stat-v">{af(t.shares)}</div><div className="adm-stat-l">Shares</div></div>
            </div>
            <div className="adm-chart-wrap"><div className="adm-chart-title">Traffic</div><ABar data={data.chartData}/></div>
            <div className="adm-2col"><ARank title="Referrers" items={data.topReferrers} lk="source" ck="count" color={ATC.pageview}/><ARank title="UTM Sources" items={data.topUtmSources} lk="source" ck="count" color={ATC.share}/></div>
          </>}
          {tab==='searches'&&<>
            <div className="adm-stat-grid">
              <div className="adm-stat" style={{'--acc':ATC.search}}><div className="adm-stat-ic">search</div><div className="adm-stat-v">{af(t.searches)}</div><div className="adm-stat-l">Searches</div></div>
              <div className="adm-stat" style={{'--acc':ATC.outreach_generated}}><div className="adm-stat-ic">mail</div><div className="adm-stat-v">{af(t.outreachGenerated)}</div><div className="adm-stat-l">Emails Drafted</div></div>
              <div className="adm-stat" style={{'--acc':ATC.share}}><div className="adm-stat-ic">share</div><div className="adm-stat-v">{af(t.shares)}</div><div className="adm-stat-l">Share Unlocks</div></div>
            </div>
            <ARank title="Most Searched VC Firms" items={data.topVcSearched} lk="vc" ck="count" color={ATC.search}/>
          </>}
          {tab==='revenue'&&<>
            <div className="adm-stat-grid">
              <div className="adm-stat" style={{'--acc':ATC.sale}}><div className="adm-stat-ic">money</div><div className="adm-stat-v">{am(t.revenue)}</div><div className="adm-stat-l">Revenue</div></div>
              <div className="adm-stat" style={{'--acc':ATC.sale}}><div className="adm-stat-ic">bag</div><div className="adm-stat-v">{af(t.sales)}</div><div className="adm-stat-l">Transactions</div></div>
              <div className="adm-stat" style={{'--acc':ATC.sale}}><div className="adm-stat-ic">avg</div><div className="adm-stat-v">{t.sales>0?am(t.revenue/t.sales):'$0'}</div><div className="adm-stat-l">Avg Sale</div></div>
              <div className="adm-stat" style={{'--acc':ATC.email_capture}}><div className="adm-stat-ic">mail</div><div className="adm-stat-v">{af(t.emailCaptures)}</div><div className="adm-stat-l">Emails</div></div>
              <div className="adm-stat" style={{'--acc':ATC.email_capture}}><div className="adm-stat-ic">inbox</div><div className="adm-stat-v">{af(t.subscribers)}</div><div className="adm-stat-l">Subscribers</div></div>
            </div>
            <div className="adm-2col">
              <div className="adm-panel"><div className="adm-panel-title">Summary</div>{[['Revenue',am(t.revenue)],['Transactions',t.sales],['Avg Sale',t.sales>0?am(t.revenue/t.sales):'$0'],['Emails',t.emailCaptures],['Subscribers',t.subscribers]].map(([l,v])=><div key={l} className="adm-rank-row"><span className="adm-rank-lbl">{l}</span><span style={{fontFamily:'DM Mono,monospace',fontSize:13,fontWeight:700,color:ATC.sale}}>{v}</span></div>)}</div>
              <ARank title="Sales by UTM" items={data.topUtmSources} lk="source" ck="count" color={ATC.sale}/>
            </div>
          </>}
          {tab==='feed'&&<>
            <div className="adm-stat-grid" style={{marginBottom:14}}>{Object.entries(ATC).map(([type,color])=><div key={type} className="adm-stat" style={{'--acc':color}}><div className="adm-stat-ic">{ATI[type]}</div><div className="adm-stat-v">{af((data.recentEvents||[]).filter(e=>e.type===type).length)}</div><div className="adm-stat-l">{ATL[type]}</div></div>)}</div>
            <div className="adm-feed-wrap"><div className="adm-feed-hdr">Live Feed</div>{(!data.recentEvents?.length)&&<div className="adm-empty">No activity yet</div>}{(data.recentEvents||[]).map((e,i)=><AFeedRow key={i} e={e}/>)}</div>
          </>}
        </>}
      </main>
    </div>
  );
}

// ─── MAIN APP ─────────────────────────────────────────────────────────────────
function MainApp(){
  const[page,setPage]=useState('landing');
  const[form,setForm]=useState({highSchool:'',college:'',companies:'',hometown:''});
  const[vcFirm,setVcFirm]=useState('');
  const[loading,setLoading]=useState(false);
  const[results,setResults]=useState(null);
  const[status,setStatus]=useState('');
  const[err,setErr]=useState('');
  const[credits,setCredits]=useState(1);
  const[hasShared,setHasShared]=useState(()=>gc('wi_sh')==='1');
  const[showEC,setShowEC]=useState(false);
  const[showPay,setShowPay]=useState(false);
  const[showProduct,setShowProduct]=useState(false);
  const[outreachF,setOutreachF]=useState(null);
  const[noCredits,setNoCredits]=useState(false);
  const resRef=useRef(null);
  const ecTimer=useRef(null);

  useEffect(()=>{
    fetch(API+'/status').then(r=>r.json()).then(d=>{if(d.hasShared||gc('wi_sh')==='1')setHasShared(true);if(typeof d.credits==='number')setCredits(d.credits)}).catch(()=>{});
    fetch(API+'/pageview',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({path:window.location.pathname,referrer:document.referrer})}).catch(()=>{});
  },[]);

  useEffect(()=>{
    if(page==='tool'&&!gc('wi_em')){ecTimer.current=setTimeout(()=>setShowEC(true),10000)}
    return()=>clearTimeout(ecTimer.current);
  },[page]);

  const setF=(k,v)=>setForm(f=>({...f,[k]:v}));
  const canSearch=vcFirm&&(form.highSchool||form.college||form.companies||form.hometown);

  const[searchStep,setSearchStep]=useState(-1);
  const[foundTicker,setFoundTicker]=useState(0);

  async function search(){
    setErr('');setResults(null);setNoCredits(false);setLoading(true);setSearchStep(0);setFoundTicker(0);
    // Animate steps while real API runs
    const stepTimings=[0,1400,3200,5500,8000];
    stepTimings.forEach((t,i)=>setTimeout(()=>setSearchStep(i),t));
    // Ticker counting up
    let tick=0;
    const ticker=setInterval(()=>{tick+=Math.floor(Math.random()*4)+1;setFoundTicker(tick)},180);
    try{
      const body={highSchool:form.highSchool,college:form.college,companies:form.companies.split(',').map(s=>s.trim()).filter(Boolean),hometown:form.hometown,vcFirm};
      const res=await fetch(API+'/search',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});
      const data=await res.json();
      clearInterval(ticker);
      if(res.status===402){setNoCredits(true);setErr('No credits remaining.');setStatus('');setLoading(false);setSearchStep(-1);return}
      if(!res.ok)throw new Error(data.error||'Search failed');
      sc('wi_s','1',30);
      if(data.hasShared){sc('wi_sh','1',30);setHasShared(true)}
      if(typeof data.credits==='number')setCredits(data.credits);
      setSearchStep(5);
      await new Promise(r=>setTimeout(r,600));
      setResults(data.results);setStatus('');setSearchStep(-1);
      setTimeout(()=>resRef.current?.scrollIntoView({behavior:'smooth',block:'start'}),200);
    }catch(e){clearInterval(ticker);setErr(e.message);setStatus('');setSearchStep(-1)}
    finally{setLoading(false)}
  }

  function handlePaySuccess(){setShowPay(false);setNoCredits(false);fetch(API+'/add-credits',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({})}).then(r=>r.json()).then(d=>{if(typeof d.credits==='number')setCredits(d.credits)})}

  function buildGroups(){
    if(!results)return{groups:[],fallback:[]};
    const groups=[];
    if(form.highSchool&&results.highSchool?.length)groups.push({label:'High School',value:form.highSchool,founders:results.highSchool,ci:0});
    if(form.college&&results.college?.length)groups.push({label:'College',value:form.college,founders:results.college,ci:1});
    if(form.hometown&&results.hometown?.length)groups.push({label:'Hometown',value:form.hometown,founders:results.hometown,ci:2});
    form.companies.split(',').map(s=>s.trim()).filter(Boolean).forEach((co,i)=>{if(results.companies?.[co]?.length)groups.push({label:'Company',value:co,founders:results.companies[co],ci:3+i})});
    return{groups,fallback:results.fallback||[]};
  }

  const{groups,fallback}=buildGroups();
  const allF=groups.flatMap(g=>g.founders.map(f=>({...f,_ci:g.ci})));
  const shown=hasShared?allF:allF.slice(0,FREE);
  const hidden=allF.length-shown.length;
  const isFallback=fallback.length>0&&allF.length===0;

  if(page==='landing')return(
    <>
      {showProduct&&<ProductModal onClose={()=>setShowProduct(false)}/>}
      <nav className="hp-nav">
        <div style={{fontSize:18,fontWeight:800,letterSpacing:'-.5px',cursor:'pointer',color:'#0f0f0f'}} onClick={()=>setPage('landing')}>VC<span style={{color:'#F59E0B'}}>Invest</span></div>
        <div className="hp-nav-links">
          <a className="hp-nav-link" href="/invest">Investors</a>
          <a href="/dashboard" style={{background:'#fff',color:'#0f0f0f',border:'1.5px solid #E5E7EB',padding:'8px 18px',fontSize:13,fontWeight:600,borderRadius:8,textDecoration:'none',transition:'border-color .15s'}} onMouseEnter={e=>e.currentTarget.style.borderColor='#0f0f0f'} onMouseLeave={e=>e.currentTarget.style.borderColor='#E5E7EB'}>Log In</a>
          <button className="hp-nav-cta" onClick={()=>setShowProduct(true)}>List My Startup</button>
        </div>
      </nav>
      <AngelSection onList={()=>setShowProduct(true)}/>
      <ProductShowcase onList={()=>setShowProduct(true)}/>
      <footer className="hp-footer">
        <div className="hp-footer-inner">
          <div style={{display:'grid',gridTemplateColumns:'2fr 1fr',gap:40,marginBottom:40}}>
            <div>
              <div style={{fontSize:18,fontWeight:800,letterSpacing:'-.5px',color:'#0f0f0f',marginBottom:10}}>VC<span style={{color:'#F59E0B'}}>Invest</span></div>
              <div style={{fontSize:13,color:'#9CA3AF',lineHeight:1.7,maxWidth:300}}>The easiest way for founders to get in front of 500+ verified angel investors. Free to list.</div>
            </div>
            <div>
              <div className="hp-footer-col-title">Platform</div>
              <button onClick={()=>setShowProduct(true)} className="hp-footer-link" style={{background:'none',border:'none',textAlign:'left',cursor:'pointer',padding:0}}>List My Startup</button>
              <a className="hp-footer-link" href="/dashboard">Founder Dashboard</a>
              <a className="hp-footer-link" href="/invest">Investor Portal</a>
            </div>
          </div>
          <div className="hp-footer-bottom">
            <div style={{fontSize:12,color:'#D1D5DB'}}>© 2025 VCInvest. All rights reserved.</div>
            <div className="hp-footer-badges">
              {['500+ Angels','Weekly Newsletter','Free to List','Direct Messaging'].map(b=><div key={b} className="hp-footer-badge">{b}</div>)}
            </div>
          </div>
        </div>
      </footer>
    </>
  );

  return(
    <>
      {showEC&&<EmailCapture onCapture={em=>{setShowEC(false);sc('wi_em',em,365)}} onDismiss={()=>setShowEC(false)}/>}
      {outreachF&&<OutreachModal founder={outreachF} onClose={()=>setOutreachF(null)}/>}
      <Pay username="VCInvest Pro - 20 Searches" selectedPrice={9} isOpen={showPay} onClose={s=>{setShowPay(false);if(s==='success')handlePaySuccess()}} onSuccess={handlePaySuccess}/>
      <nav className="nav">
        <div className="nav-logo" onClick={()=>setPage('landing')}>VC<em>Invest</em></div>
        <div className="nav-actions">
          <div className="credits-badge">
            <span className="credits-n">{credits}</span>
            <span className="credits-lbl">credits</span>
            <button className="credits-buy" onClick={()=>setShowPay(true)}>+ Buy 20</button>
          </div>
        </div>
      </nav>
      <div className="tool-wrap">
        <div className="tool-topbar"><button className="back-btn" onClick={()=>setPage('landing')}>Back</button><div className="tool-title">WarmIntro Finder</div></div>
        <div style={{marginBottom:28}}>
          <div className="sec-head"><span className="sec-num">01</span><span className="sec-ttl">Your Background</span></div>
          <div className="sdd-grid">
            <SearchableDropdown label="High School" placeholder="Select or type..." options={SCHOOLS} value={form.highSchool} onChange={v=>setF('highSchool',v)}/>
            <SearchableDropdown label="College / University" placeholder="Select or type..." options={COLLEGES} value={form.college} onChange={v=>setF('college',v)}/>
            <SearchableDropdown label="Previous Company" placeholder="Select or type..." options={COMPANIES} value={form.companies} onChange={v=>setF('companies',v)}/>
            <SearchableDropdown label="Hometown" placeholder="Select or type..." options={HOMETOWNS} value={form.hometown} onChange={v=>setF('hometown',v)}/>
          </div>
        </div>
        <VCGrid selected={vcFirm} onSelect={setVcFirm} onUpgrade={()=>setShowPay(true)}/>
        <div className="search-bar">
          <div>
            <div className="search-meta">{vcFirm?<>Searching <strong>{vcFirm}</strong> portfolio</>:'Select a VC firm to continue'}</div>
            {status&&<div className="status-txt">{status}</div>}
            {err&&!noCredits&&<div className="error-txt">{err}</div>}
          </div>
          <button className="btn-primary" onClick={search} disabled={!canSearch||loading}>{loading?'Searching...':'Find Warm Intros'}</button>
        </div>
        {noCredits&&<div className="no-creds"><div><div className="no-creds-title">Out of credits</div><div className="no-creds-sub">Buy 20 search credits for $9</div></div><button className="btn-primary" style={{background:'var(--r)'}} onClick={()=>setShowPay(true)}>Buy 20 Credits - $9</button></div>}
        {loading&&searchStep>=0&&(()=>{
          const categories=[];
          if(form.highSchool)categories.push({ic:'🎓',label:'High School',desc:`Scanning ${form.highSchool} alumni in ${vcFirm} portfolio`});
          if(form.college)categories.push({ic:'🏛️',label:'College',desc:`Finding ${form.college} founders backed by ${vcFirm}`});
          if(form.companies)categories.push({ic:'🏢',label:'Company',desc:`Searching ${form.companies} alumni who got ${vcFirm} funding`});
          if(form.hometown)categories.push({ic:'📍',label:'Hometown',desc:`Matching ${form.hometown} founders in ${vcFirm} network`});
          const allSteps=[
            {ic:'🔍',title:'Scanning VC portfolio',desc:`Looking up ${vcFirm} funded companies and founders`},
            ...categories,
            {ic:'✉️',title:'Finding contact info',desc:'Generating best-guess email addresses for each founder'},
            {ic:'📊',title:'Ranking connections',desc:'Sorting by connection strength and relevance'},
          ];
          const pct=Math.min(Math.round((searchStep/Math.max(allSteps.length-1,1))*100),95);
          return(
            <div style={{marginTop:24}}>
              <div className="search-loading">
                <div className="sl-title">Finding your warm intros...</div>
                <div className="sl-sub">Scanning {vcFirm} portfolio for founders who share your background. This takes 15–30 seconds - real data takes time.</div>
                <div className="sl-bar-wrap"><div className="sl-bar" style={{width:`${pct}%`}}/></div>
                <div className="sl-bar-label"><span>{pct}% complete</span><span style={{color:'var(--g)',fontWeight:700}}>{foundTicker} records scanned</span></div>
                <div className="sl-steps" style={{marginTop:20}}>
                  {allSteps.map((s,i)=>{
                    const state=searchStep>i?'done':searchStep===i?'active':'';
                    return(
                      <div key={i} className={`sl-step${state?' '+state:''}`}>
                        <div className="sl-step-ic">{state==='done'?'✓':s.ic}</div>
                        <div className="sl-step-body">
                          <div className="sl-step-title">{s.title}</div>
                          <div className="sl-step-desc">{s.desc}</div>
                        </div>
                        <div className="sl-step-check">✓</div>
                      </div>
                    );
                  })}
                </div>
              </div>
              {[1,2].map(i=><div key={i} className="skel" style={{height:80}}/>)}
            </div>
          );
        })()}
        {!loading&&results&&<div ref={resRef}>
          <div className="res-header"><div className="res-h2">{isFallback?`${vcFirm} Founders`:'Your Connections'}</div><div className="res-count">{isFallback?'No direct match - showing portfolio founders':`${allF.length} founders · showing ${shown.length}`}</div></div>
          {isFallback&&<>{fallback.map((f,i)=><FounderCard key={i} founder={f} ci={i%CLR.length} onOutreach={setOutreachF}/>)}</>}
          {!isFallback&&(()=>{let count=0;return groups.map((g,gi)=>{const col=CLR[g.ci%CLR.length];const toShow=[];for(const f of g.founders){if(count>=FREE&&!hasShared)break;toShow.push(f);count++}if(!toShow.length)return null;return(<div key={gi}><div className="group-label"><span className="group-pill" style={{background:col.bg,color:col.text}}>{g.label}</span><span className="group-val">{g.value}</span><span className="group-count">{g.founders.length} found</span></div>{toShow.map((f,fi)=><FounderCard key={fi} founder={f} ci={g.ci} onOutreach={setOutreachF}/>)}</div>);})})()}
          {!isFallback&&!hasShared&&hidden>0&&<><div className="share-blur-wrap">{allF.slice(FREE,FREE+2).map((f,i)=><FounderCard key={i} founder={f} ci={i} onOutreach={()=>{}}/>)}</div><ShareWall onUnlock={()=>{setHasShared(true);sc('wi_sh','1',30)}} hiddenCount={hidden}/></>}
        </div>}
      </div>
    </>
  );
}

// ─── CHAT WINDOW ──────────────────────────────────────────────────────────────
function ChatWindow({messages,onSend,meType,loading}){
  const[text,setText]=useState('');const bottomRef=useRef(null);
  useEffect(()=>bottomRef.current?.scrollIntoView({behavior:'smooth'}),[messages]);
  function send(){if(!text.trim())return;onSend(text);setText('');}
  return(
    <div style={{display:'flex',flexDirection:'column',height:'100%'}}>
      <div style={{flex:1,overflowY:'auto',padding:'16px 20px',display:'flex',flexDirection:'column',gap:10}}>
        {loading&&<div style={{textAlign:'center',padding:20,fontSize:13,color:'var(--mu)'}}>Loading...</div>}
        {!loading&&messages.length===0&&<div style={{textAlign:'center',padding:32,fontSize:13,color:'var(--mu)'}}>No messages yet. Start the conversation!</div>}
        {messages.map((m,i)=>{const isMe=m.senderType===meType;return(
          <div key={i} style={{display:'flex',justifyContent:isMe?'flex-end':'flex-start'}}>
            <div style={{maxWidth:'72%',background:isMe?'var(--ink)':'#fff',color:isMe?'#fff':'var(--ink)',padding:'10px 14px',borderRadius:isMe?'16px 16px 4px 16px':'16px 16px 16px 4px',fontSize:13,lineHeight:1.6,boxShadow:'0 1px 3px rgba(0,0,0,.08)',border:isMe?'none':'1px solid var(--bd)'}}>
              <div>{m.text}</div>
              <div style={{fontSize:10,opacity:.6,marginTop:4,textAlign:isMe?'right':'left'}}>{new Date(m.createdAt).toLocaleTimeString([],{hour:'2-digit',minute:'2-digit'})}</div>
            </div>
          </div>
        );})}
        <div ref={bottomRef}/>
      </div>
      <div style={{padding:'12px 16px',borderTop:'1px solid var(--bd)',display:'flex',gap:8,background:'#fff'}}>
        <input value={text} onChange={e=>setText(e.target.value)} onKeyDown={e=>e.key==='Enter'&&!e.shiftKey&&(e.preventDefault(),send())} placeholder="Type a message..." style={{flex:1,background:'var(--s2)',border:'1.5px solid var(--bd)',padding:'10px 14px',borderRadius:24,outline:'none',fontSize:14,fontFamily:'inherit'}} />
        <button onClick={send} disabled={!text.trim()} style={{background:'var(--ink)',color:'#fff',border:'none',width:42,height:42,borderRadius:'50%',fontSize:16,cursor:'pointer',flexShrink:0,opacity:text.trim()?1:.4}}>→</button>
      </div>
    </div>
  );
}

// ─── FOUNDER DASHBOARD ────────────────────────────────────────────────────────
// ── InterestedAngels - shown on profile tab, locked for free users ───────────
function InterestedAngels({token,msgCredits,onUpgrade}){
  const[bookmarks,setBookmarks]=useState([]);
  const[loaded,setLoaded]=useState(false);
  const isPaid=msgCredits>0;

  useEffect(()=>{
    if(!token||!isPaid)return;
    fetch(API+'/founder/bookmarks',{headers:{'x-founder-token':token}})
      .then(r=>r.json()).then(d=>{setBookmarks(d.bookmarks||[]);setLoaded(true);}).catch(()=>setLoaded(true));
  },[token,isPaid]);

  // Fake names shown blurred when not paid
  const FAKE_ANGELS=[
    {name:'Marcus Chen',title:'Partner, Gradient Ventures'},
    {name:'Priya Nair',title:'Angel Investor'},
    {name:'Jordan Blake',title:'GP, Hustle Fund'},
    {name:'Aisha Mohammed',title:'Principal, Precursor VC'},
  ];

  return(
    <div style={{marginTop:20,background:'#fff',border:'1px solid #E5E7EB',borderRadius:16,padding:24,position:'relative',overflow:'hidden'}}>
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:16}}>
        <div>
          <div style={{fontSize:15,fontWeight:800,marginBottom:2}}>🔖 Angels Who Shortlisted You</div>
          <div style={{fontSize:12,color:'#9CA3AF'}}>{isPaid?(loaded?`${bookmarks.length} investor${bookmarks.length!==1?'s':''} saved your startup`:'Loading...'):'Unlock to see which angels bookmarked your startup'}</div>
        </div>
        {isPaid&&bookmarks.length>0&&<div style={{background:'#F0FDF4',border:'1px solid #A7F3D0',color:'#065F46',fontSize:12,fontWeight:700,padding:'4px 12px',borderRadius:100}}>{bookmarks.length} interested</div>}
      </div>

      {/* Locked state (free) users */}
      {!isPaid&&(
        <>
          {/* Blurred fake angel rows */}
          <div style={{display:'flex',flexDirection:'column',gap:8,filter:'blur(5px)',userSelect:'none',pointerEvents:'none',marginBottom:16}}>
            {FAKE_ANGELS.map((a,i)=>(
              <div key={i} style={{display:'flex',alignItems:'center',gap:12,padding:'10px 14px',background:'#F9FAFB',border:'1px solid #E5E7EB',borderRadius:10}}>
                <div style={{width:36,height:36,borderRadius:8,background:'linear-gradient(135deg,#EEF2FF,#E0E7FF)',color:'#4338CA',fontSize:12,fontWeight:800,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                  {a.name.split(' ').map(w=>w[0]).slice(0,2).join('')}
                </div>
                <div>
                  <div style={{fontSize:13,fontWeight:700}}>{a.name}</div>
                  <div style={{fontSize:11,color:'#9CA3AF'}}>{a.title}</div>
                </div>
                <div style={{marginLeft:'auto',fontSize:11,color:'#9CA3AF'}}>2h ago</div>
              </div>
            ))}
          </div>
          {/* Lock overlay */}
          <div style={{position:'absolute',inset:0,display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',background:'rgba(255,255,255,.7)',backdropFilter:'blur(2px)'}}>
            <div style={{background:'#fff',border:'1.5px solid #E5E7EB',borderRadius:16,padding:'24px 28px',maxWidth:320,width:'100%',textAlign:'center',boxShadow:'0 8px 32px rgba(0,0,0,.1)'}}>
              <div style={{fontSize:28,marginBottom:8}}>🔒</div>
              <div style={{fontSize:15,fontWeight:800,marginBottom:6}}>See Who Bookmarked You</div>
              <div style={{fontSize:12,color:'#6B7280',lineHeight:1.6,marginBottom:16}}>Angels have been shortlisting your startup. Get credits to see who and message them back.</div>
              <button onClick={onUpgrade} style={{width:'100%',background:'#0f0f0f',color:'#fff',border:'none',padding:'12px 0',fontSize:13,fontWeight:700,borderRadius:9,cursor:'pointer'}}>
                Unlock - View Plans →
              </button>
            </div>
          </div>
        </>
      )}

      {/* Paid state - real data */}
      {isPaid&&loaded&&bookmarks.length===0&&(
        <div style={{padding:'24px 0',textAlign:'center',color:'#9CA3AF',fontSize:13}}>No bookmarks yet - angels who save your startup will appear here.</div>
      )}
      {isPaid&&loaded&&bookmarks.length>0&&(
        <div style={{display:'flex',flexDirection:'column',gap:8}}>
          {bookmarks.map((b,i)=>(
            <div key={i} style={{display:'flex',alignItems:'center',gap:12,padding:'10px 14px',background:'#F9FAFB',border:'1px solid #E5E7EB',borderRadius:10}}>
              <div style={{width:36,height:36,borderRadius:8,background:'linear-gradient(135deg,#EEF2FF,#E0E7FF)',color:'#4338CA',fontSize:12,fontWeight:800,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                {(b.angel?.name||'A').split(' ').map(w=>w[0]).slice(0,2).join('')}
              </div>
              <div style={{flex:1}}>
                <div style={{fontSize:13,fontWeight:700}}>{b.angel?.name||'Angel Investor'}</div>
                <div style={{fontSize:11,color:'#9CA3AF'}}>{b.angel?.title||''}</div>
              </div>
              <div style={{fontSize:11,color:'#9CA3AF',flexShrink:0}}>{new Date(b.createdAt).toLocaleDateString()}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function FounderDashboard(){
  const TOTAL_ANGELS=500; // hardcoded display total
  const TIERS=[
    {id:'starter',price:30,credits:1000,angelAccess:120,label:'Starter',refund:false},
    {id:'growth',price:90,credits:3000,angelAccess:720,label:'Growth',popular:true,refund:false},
    {id:'all-access',price:120,credits:10000,angelAccess:1000,label:'All Access',refund:true},
  ];

  const[token,setToken]=useState(()=>localStorage.getItem('wi_founder_token'));
  const[founder,setFounder]=useState(null);
  const[tab,setTab]=useState('angels'); // angels | inbox | profile
  const[angels,setAngels]=useState([]);const[angelQ,setAngelQ]=useState('');const[angelShowAll,setAngelShowAll]=useState(false);
  const[chats,setChats]=useState([]);const[activeAngel,setActiveAngel]=useState(null);
  const[messages,setMessages]=useState([]);const[msgLoading,setMsgLoading]=useState(false);
  const[editing,setEditing]=useState(false);const[editForm,setEditForm]=useState({});const[saving,setSaving]=useState(false);
  const[phone,setPhone]=useState('');const[cc,setCc]=useState('+1');const[otp,setOtp]=useState('');
  const[loginStep,setLoginStep]=useState(1);const[ll,setLl]=useState(false);const[le,setLe]=useState('');
  const[msgCredits,setMsgCredits]=useState(()=>parseInt(localStorage.getItem('wi_msg_credits')||'0'));
  const[angelAccess,setAngelAccess]=useState(()=>parseInt(localStorage.getItem('wi_angel_access')||'30'));
  const[showBuyCredits,setShowBuyCredits]=useState(false);const[showStripe,setShowStripe]=useState(false);
  const[selectedTier,setSelectedTier]=useState(null);
  // Track if this is the very first dashboard visit - don't show fake "pending messages" until they've returned at least once
  const[isFirstVisit]=useState(()=>{
    const seen=localStorage.getItem('wi_dashboard_seen');
    if(!seen){localStorage.setItem('wi_dashboard_seen',String(Date.now()));return true;}
    return false;
  });

  const CCS=['+1','+44','+91','+61','+49','+33','+55','+65','+971','+81','+82','+86'];

  // Load founder
  useEffect(()=>{
    if(!token)return;
    const ctrl=new AbortController();
    const t=setTimeout(()=>{ctrl.abort();localStorage.removeItem('wi_founder_token');setToken(null);},8000);
    fetch(API+'/founder/me',{headers:{'x-founder-token':token},signal:ctrl.signal})
      .then(r=>{clearTimeout(t);if(r.status===401){localStorage.removeItem('wi_founder_token');setToken(null);return null;}return r.json();})
      .then(d=>{if(d?.founder){setFounder(d.founder);setEditForm(d.founder);if(typeof d.founder.msgCredits==='number'){setMsgCredits(d.founder.msgCredits);localStorage.setItem('wi_msg_credits',String(d.founder.msgCredits));}if(typeof d.founder.angelAccess==='number'){setAngelAccess(d.founder.angelAccess);localStorage.setItem('wi_angel_access',String(d.founder.angelAccess));}}else if(d){localStorage.removeItem('wi_founder_token');setToken(null);}})
      .catch(e=>{clearTimeout(t);if(e.name!=='AbortError'){localStorage.removeItem('wi_founder_token');setToken(null);}});
    return()=>{clearTimeout(t);ctrl.abort();};
  },[token]);

  // Load angels list
  useEffect(()=>{
    if(!token)return;
    const q=angelQ?`?q=${encodeURIComponent(angelQ)}`:'';
    fetch(`${API}/founder/angels${q}`,{headers:{'x-founder-token':token}})
      .then(r=>r.json()).then(d=>{
        setAngels(d.angels||[]);
        // Store total so we can show locked cards
        if(typeof d.total==='number')localStorage.setItem('wi_angel_total',String(d.total));
        if(typeof d.isPaid==='boolean')localStorage.setItem('wi_is_paid',String(d.isPaid));
      }).catch(()=>{});
  },[token,angelQ]);

  // Load chats
  useEffect(()=>{
    if(!token||tab!=='inbox')return;
    fetch(API+'/founder/chats',{headers:{'x-founder-token':token}}).then(r=>r.json()).then(d=>setChats(d.chats||[])).catch(()=>{});
  },[token,tab]);

  // Poll messages
  useEffect(()=>{
    if(!activeAngel)return;
    const load=()=>fetch(`${API}/founder/messages/${activeAngel._id}`,{headers:{'x-founder-token':token}}).then(r=>r.json()).then(d=>{setMessages(d.messages||[]);setMsgLoading(false);}).catch(()=>{});
    setMsgLoading(true);load();const iv=setInterval(load,3000);return()=>clearInterval(iv);
  },[activeAngel,token]);

  async function sendMsg(text){
    if(msgCredits<=0){setShowBuyCredits(true);return;}
    try{
      await fetch(`${API}/founder/messages/${activeAngel._id}`,{method:'POST',headers:{'Content-Type':'application/json','x-founder-token':token},body:JSON.stringify({text})});
      const n=msgCredits-1;setMsgCredits(n);localStorage.setItem('wi_msg_credits',String(n));
      if(n===0)setTimeout(()=>setShowBuyCredits(true),400);
      fetch(`${API}/founder/messages/${activeAngel._id}`,{headers:{'x-founder-token':token}}).then(r=>r.json()).then(d=>setMessages(d.messages||[]));
    }catch(_){}
  }

  async function saveProfile(){setSaving(true);try{const r=await fetch(API+'/founder/me',{method:'PUT',headers:{'Content-Type':'application/json','x-founder-token':token},body:JSON.stringify(editForm)});const d=await r.json();setFounder(d.founder);setEditForm(d.founder);setEditing(false);}catch(_){}setSaving(false);}

  function handleCreditsPurchase(s){
    if(s!=='success'||!selectedTier)return;
    const newCredits=msgCredits+selectedTier.credits;
    const newAccess=Math.max(angelAccess,selectedTier.angelAccess);
    setMsgCredits(newCredits);localStorage.setItem('wi_msg_credits',String(newCredits));
    setAngelAccess(newAccess);localStorage.setItem('wi_angel_access',String(newAccess));
    setShowBuyCredits(false);setSelectedTier(null);
    fetch(API+'/founder/add-credits',{method:'POST',headers:{'Content-Type':'application/json','x-founder-token':token},body:JSON.stringify({credits:selectedTier.credits,angelAccess:selectedTier.angelAccess,tier:selectedTier.id,price:selectedTier.price})}).catch(()=>{});
  }

  async function safePost(url,body){const r=await fetch(url,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});const t=await r.text();if(t.trim().startsWith('<'))throw new Error('Server not reachable');let d;try{d=JSON.parse(t)}catch(_){throw new Error('Unexpected response');}if(!r.ok)throw new Error(d.error||'Failed');return d;}

  async function sendLoginOtp(){if(phone.length<5){setLe('Enter a valid phone number');return;}setLl(true);setLe('');try{await safePost(API+'/founder/login',{phone:cc+phone.replace(/^0+/,'')});setLoginStep(2);}catch(e){setLe(e.message);}setLl(false);}
  async function verifyLoginOtp(){setLl(true);setLe('');try{const d=await safePost(API+'/founder/login-verify',{phone:cc+phone.replace(/^0+/,''),otp});localStorage.setItem('wi_founder_token',d.token);setToken(d.token);}catch(e){setLe(e.message);}setLl(false);}

  const unread=chats.reduce((s,c)=>s+c.unread,0);

  // ── LOGIN SCREEN ──────────────────────────────────────────────────────────
  if(!token)return(
    <div style={{minHeight:'100vh',background:'#FAFAFA',fontFamily:"'Inter',sans-serif",display:'flex',flexDirection:'column'}}>
      <div style={{background:'#fff',borderBottom:'1px solid #F3F4F6',padding:'0 24px',height:60,display:'flex',alignItems:'center',justifyContent:'space-between'}}>
        <a href="/" style={{fontSize:17,fontWeight:800,letterSpacing:'-.5px',color:'#0f0f0f',textDecoration:'none'}}>VC<span style={{color:'#F59E0B'}}>Invest</span></a>
        <a href="/invest" style={{fontSize:13,color:'#6B7280',textDecoration:'none'}}>I am an investor →</a>
      </div>
      <div style={{flex:1,display:'flex',alignItems:'center',justifyContent:'center',padding:20}}>
        <div style={{background:'#fff',border:'1px solid #E5E7EB',borderRadius:20,padding:'40px 36px',maxWidth:400,width:'100%',boxShadow:'0 4px 24px rgba(0,0,0,.06)'}}>
          {loginStep===1?<>
            <div style={{textAlign:'center',marginBottom:28}}>
              <div style={{width:52,height:52,borderRadius:14,background:'linear-gradient(135deg,#F59E0B,#EF4444)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:24,margin:'0 auto 14px'}}>🚀</div>
              <div style={{fontSize:22,fontWeight:800,letterSpacing:'-.5px',marginBottom:6}}>Founder Dashboard</div>
              <div style={{fontSize:14,color:'#6B7280',lineHeight:1.6}}>Enter the phone number you used to sign up. We will send you a login code.</div>
            </div>
            {le&&<div style={{background:'#FEF2F2',border:'1px solid #FECACA',color:'#DC2626',fontSize:13,padding:'10px 14px',borderRadius:10,marginBottom:16}}>⚠ {le}</div>}
            <div style={{marginBottom:6,fontSize:12,fontWeight:600,color:'#6B7280',textTransform:'uppercase',letterSpacing:'.06em'}}>Your phone number</div>
            <div style={{display:'flex',gap:8,marginBottom:20}}>
              <select value={cc} onChange={e=>setCc(e.target.value)} style={{background:'#F9FAFB',border:'1.5px solid #E5E7EB',fontSize:14,fontWeight:600,padding:'0 10px',borderRadius:10,outline:'none',height:48,minWidth:80,cursor:'pointer'}}>
                {CCS.map(c=><option key={c} value={c}>{c}</option>)}
              </select>
              <input style={{flex:1,background:'#F9FAFB',border:'1.5px solid #E5E7EB',padding:'12px 14px',borderRadius:10,outline:'none',fontSize:15,fontFamily:'inherit',transition:'border-color .15s'}} type="tel" placeholder="555 000 0000" value={phone} onChange={e=>setPhone(e.target.value)} autoFocus onFocus={e=>e.target.style.borderColor='#F59E0B'} onBlur={e=>e.target.style.borderColor='#E5E7EB'}/>
            </div>
            <button onClick={sendLoginOtp} disabled={ll||phone.length<5} style={{width:'100%',background:'#0f0f0f',color:'#fff',border:'none',padding:'14px 0',fontSize:15,fontWeight:700,borderRadius:10,cursor:'pointer',opacity:ll?'.6':'1'}}>
              {ll?'Sending code...':'Send Login Code →'}
            </button>
            <div style={{textAlign:'center',marginTop:18,fontSize:13,color:'#9CA3AF'}}>
              Don't have an account? <a href="/" style={{color:'#0f0f0f',fontWeight:700,textDecoration:'none'}}>List your startup →</a>
            </div>
          </>:<>
            <div style={{textAlign:'center',marginBottom:24}}>
              <div style={{fontSize:36,marginBottom:10}}>📱</div>
              <div style={{fontSize:20,fontWeight:800,marginBottom:6}}>Check your texts</div>
              <div style={{fontSize:14,color:'#6B7280'}}>Code sent to <strong style={{color:'#0f0f0f'}}>{cc}{phone}</strong></div>
            </div>
            {le&&<div style={{background:'#FEF2F2',border:'1px solid #FECACA',color:'#DC2626',fontSize:13,padding:'10px 14px',borderRadius:10,marginBottom:16}}>⚠ {le}</div>}
            <input
              style={{width:'100%',background:'#F9FAFB',border:'2px solid #E5E7EB',fontFamily:"'DM Mono',monospace",fontSize:32,letterSpacing:'.5em',padding:'14px 0',textAlign:'center',outline:'none',borderRadius:10,marginBottom:16,transition:'border-color .15s',boxSizing:'border-box'}}
              placeholder="000000" maxLength={6} value={otp} onChange={e=>setOtp(e.target.value.replace(/[^0-9]/g,''))} autoFocus
              onFocus={e=>e.target.style.borderColor='#F59E0B'} onBlur={e=>e.target.style.borderColor='#E5E7EB'}
            />
            <button onClick={verifyLoginOtp} disabled={ll||otp.length!==6} style={{width:'100%',background:'#0f0f0f',color:'#fff',border:'none',padding:'14px 0',fontSize:15,fontWeight:700,borderRadius:10,cursor:'pointer',marginBottom:12,opacity:ll||otp.length!==6?'.5':'1'}}>
              {ll?'Verifying...':'Log In →'}
            </button>
            <div style={{display:'flex',gap:12,justifyContent:'center'}}>
              <button onClick={()=>setLoginStep(1)} style={{background:'none',border:'none',fontSize:13,color:'#9CA3AF',cursor:'pointer',textDecoration:'underline'}}>← Change number</button>
              <button onClick={sendLoginOtp} style={{background:'none',border:'none',fontSize:13,color:'#9CA3AF',cursor:'pointer',textDecoration:'underline'}}>Resend code</button>
            </div>
          </>}
        </div>
      </div>
    </div>
  );

  if(!founder)return(
    <div style={{minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center',background:'#FAFAFA',fontFamily:"'Inter',sans-serif"}}>
      <div style={{textAlign:'center'}}>
        <div style={{width:36,height:36,border:'3px solid #E5E7EB',borderTopColor:'#F59E0B',borderRadius:'50%',animation:'spin .6s linear infinite',margin:'0 auto 16px'}}/>
        <div style={{fontSize:14,color:'#9CA3AF'}}>Loading dashboard...</div>
      </div>
    </div>
  );

  return(
    <div style={{minHeight:'100vh',background:'#FAFAFA',fontFamily:"'Inter',sans-serif"}}>
      {/* Topbar */}
      <div className="dash-topbar" style={{background:'#fff',borderBottom:'1px solid #F3F4F6',display:'flex',alignItems:'center',justifyContent:'space-between'}}>
        <a href="/" style={{fontSize:17,fontWeight:800,letterSpacing:'-.5px',color:'#0f0f0f',textDecoration:'none'}}>VC<span style={{color:'#F59E0B'}}>Invest</span></a>
        <div style={{display:'flex',alignItems:'center',gap:10}}>
          {/* Credits badge */}
          <div className="credits-badge" style={{display:'flex',alignItems:'center',gap:6,background:'#FFFBEB',border:'1px solid #FDE68A',padding:'5px 12px',borderRadius:8,cursor:'pointer'}} onClick={()=>setShowBuyCredits(true)}>
            <span style={{fontSize:15,fontWeight:800,color:'#92400E',fontFamily:"'DM Mono',monospace"}}>{msgCredits.toLocaleString()}</span>
            <span className="credits-badge-label" style={{fontSize:10,color:'#92400E',fontWeight:700,textTransform:'uppercase',letterSpacing:'.06em'}}>credits</span>
            {msgCredits===0&&<span style={{background:'#DC2626',color:'#fff',fontSize:10,fontWeight:700,padding:'1px 6px',borderRadius:4,marginLeft:2}}>Buy</span>}
          </div>
          <button onClick={()=>{localStorage.removeItem('wi_founder_token');setToken(null);}} style={{background:'none',border:'1px solid #E5E7EB',color:'#9CA3AF',padding:'6px 14px',borderRadius:8,fontSize:12,cursor:'pointer'}}>Logout</button>
        </div>
      </div>

      {/* Nav tabs */}
      <div className="dash-tabs">
        {[['angels','👼 Angels'],['inbox',`📥 Inbox${unread>0?' ('+unread+')':''}`],['profile','⚙️ Profile']].map(([t,l])=>(
          <button key={t} onClick={()=>setTab(t)} className={`dash-tab${tab===t?' active':''}`}>
            {l}
          </button>
        ))}
      </div>

      <div className="dash-content">

        {/* ── BROWSE ANGELS ── */}
        {tab==='angels'&&(()=>{
          const isPaid=msgCredits>0;
          const totalAngels=parseInt(localStorage.getItem('wi_angel_total')||'400');
          const lockedCount=isPaid?Math.max(0,totalAngels-angels.length):Math.max(0,totalAngels-5);
          return(
          <>
          <div style={{marginBottom:20,display:'flex',alignItems:'center',justifyContent:'space-between',flexWrap:'wrap',gap:12}}>
            <div>
              <div style={{fontSize:20,fontWeight:800,letterSpacing:'-.5px',marginBottom:4}}>Angel Investors</div>
              <div style={{fontSize:13,color:'#6B7280'}}>{isPaid?`${angels.length} investors unlocked`:`Showing ${angels.length} of ${TOTAL_ANGELS.toLocaleString()} investors - upgrade to unlock all`}</div>
            </div>
            {!isPaid&&(
              <div style={{background:'#FEF2F2',border:'1px solid #FECACA',borderRadius:10,padding:'10px 16px',display:'flex',alignItems:'center',gap:10}}>
                <span style={{fontSize:13,color:'#DC2626',fontWeight:600}}>🔒 Upgrade to message and unlock all investors</span>
                <button onClick={()=>setShowBuyCredits(true)} style={{background:'#DC2626',color:'#fff',border:'none',padding:'6px 14px',borderRadius:7,fontSize:12,fontWeight:700,cursor:'pointer'}}>Upgrade</button>
              </div>
            )}
          </div>
          <input value={angelQ} onChange={e=>setAngelQ(e.target.value)} placeholder="Search by name, firm, or focus area..." style={{width:'100%',background:'#fff',border:'1.5px solid #E5E7EB',padding:'11px 16px',borderRadius:10,outline:'none',fontSize:14,fontFamily:'inherit',marginBottom:20,boxSizing:'border-box',transition:'border-color .15s'}} onFocus={e=>e.target.style.borderColor='#F59E0B'} onBlur={e=>e.target.style.borderColor='#E5E7EB'}/>
          <div className="angel-grid">
            {angels.map(a=>(
              <div key={a._id} style={{background:'#fff',border:`1.5px solid ${activeAngel?._id===a._id?'#F59E0B':'#E5E7EB'}`,borderRadius:14,padding:'18px 18px 14px',cursor:'pointer',transition:'all .15s',boxShadow:activeAngel?._id===a._id?'0 0 0 3px rgba(245,158,11,.15)':'none'}} onClick={()=>{setActiveAngel(a);if(!isPaid){setShowBuyCredits(true);}}}>
                <div style={{display:'flex',alignItems:'flex-start',gap:12}}>
                  <div style={{width:42,height:42,borderRadius:10,background:'linear-gradient(135deg,#EEF2FF,#E0E7FF)',color:'#4338CA',fontSize:14,fontWeight:800,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                    {(a.name||'?').split(' ').map(w=>w[0]).slice(0,2).join('')}
                  </div>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{fontSize:14,fontWeight:700,color:'#0f0f0f',marginBottom:2}}>{a.name}</div>
                    <div style={{fontSize:11,color:'#9CA3AF',lineHeight:1.4,marginBottom:6}}>{a.title}</div>
                    {a.notable&&<div style={{fontSize:11,color:'#6B7280',lineHeight:1.4,overflow:'hidden',display:'-webkit-box',WebkitLineClamp:2,WebkitBoxOrient:'vertical'}}>{a.notable}</div>}
                  </div>
                </div>
                <button onClick={e=>{e.stopPropagation();if(!isPaid){setShowBuyCredits(true);}else{setActiveAngel(a);setTab('inbox');}}} style={{marginTop:14,width:'100%',background:isPaid?'#0f0f0f':'#F3F4F6',color:isPaid?'#fff':'#9CA3AF',border:'none',padding:'9px 0',fontSize:12,fontWeight:700,borderRadius:8,cursor:'pointer'}}>
                  {isPaid?'Send Message →':'🔒 Upgrade to Message'}
                </button>
              </div>
            ))}
            {/* Locked placeholder cards - no real data, server never sent it */}
            {!isPaid&&Array.from({length:Math.min(lockedCount,12)}).map((_,i)=>(
              <div key={`lk-${i}`} onClick={()=>setShowBuyCredits(true)} style={{background:'#F9FAFB',border:'1.5px dashed #E5E7EB',borderRadius:14,padding:'18px 18px 14px',cursor:'pointer',transition:'border-color .15s'}} onMouseEnter={e=>e.currentTarget.style.borderColor='#F59E0B'} onMouseLeave={e=>e.currentTarget.style.borderColor='#E5E7EB'}>
                <div style={{display:'flex',alignItems:'flex-start',gap:12,marginBottom:14}}>
                  <div style={{width:42,height:42,borderRadius:10,background:'#E5E7EB',flexShrink:0}}/>
                  <div style={{flex:1}}>
                    <div style={{height:14,background:'#E5E7EB',borderRadius:4,marginBottom:8,width:'65%'}}/>
                    <div style={{height:10,background:'#F3F4F6',borderRadius:4,marginBottom:5,width:'80%'}}/>
                    <div style={{height:10,background:'#F3F4F6',borderRadius:4,width:'55%'}}/>
                  </div>
                </div>
                <div style={{height:10,background:'#F3F4F6',borderRadius:4,marginBottom:5,width:'90%'}}/>
                <div style={{height:10,background:'#F3F4F6',borderRadius:4,width:'70%',marginBottom:14}}/>
                <div style={{width:'100%',background:'#fff',color:'#9CA3AF',border:'1.5px solid #E5E7EB',padding:'9px 0',fontSize:12,fontWeight:700,borderRadius:8,textAlign:'center'}}>
                  🔒 Upgrade to Unlock
                </div>
              </div>
            ))}
          </div>
          {!isPaid&&lockedCount>12&&(
            <div style={{textAlign:'center',marginTop:20}}>
              <button onClick={()=>setShowBuyCredits(true)} style={{background:'#fff',color:'#0f0f0f',border:'1.5px solid #E5E7EB',padding:'12px 28px',fontSize:14,fontWeight:700,borderRadius:10,cursor:'pointer'}}>
                Upgrade to Unlock All Angels →
              </button>
            </div>
          )}
          {isPaid&&angels.length<totalAngels&&(
            <div style={{textAlign:'center',marginTop:24}}>
              <button onClick={()=>setShowBuyCredits(true)} style={{background:'#fff',color:'#0f0f0f',border:'1.5px solid #E5E7EB',padding:'12px 28px',fontSize:14,fontWeight:700,borderRadius:10,cursor:'pointer'}}>
                🔒 Unlock More Angels - Upgrade Plan
              </button>
              <div style={{fontSize:12,color:'#9CA3AF',marginTop:10}}>You have access to {angelAccess} of {TOTAL_ANGELS.toLocaleString()} angels.</div>
            </div>
          )}
          </>
          );
        })()}

        {/* ── INBOX ── */}
        {tab==='inbox'&&(()=>{
          const noCredits=msgCredits===0;
          const FAKE=[
            {name:'Jake Zeller',title:'Syndicate Lead, AngelList',av:'JZ',avBg:'#EEF2FF',avC:'#4338CA',time:'2m ago',unread:2,preview:'Hey! I looked at your startup and loved the traction. Would love to chat this week -',messages:[
              {senderType:'angel',text:'Hey! I came across your listing in the VCInvest newsletter.',createdAt:new Date(Date.now()-8*60000)},
              {senderType:'angel',text:'Your traction numbers look really solid for this stage. Would love to hop on a quick call this week.',createdAt:new Date(Date.now()-7*60000)},
            ]},
            {name:'Nik Milanovic',title:'Founder, This Week in Fintech',av:'NM',avBg:'#F0FDF4',avC:'#15803D',time:'14m ago',unread:1,preview:'Interesting space. We just deployed into a similar company last month. Can we',messages:[
              {senderType:'angel',text:'Interesting space. We deployed into a similar company last month.',createdAt:new Date(Date.now()-14*60000)},
              {senderType:'angel',text:'Can we schedule 15 minutes? I have a few quick questions about your go-to-market.',createdAt:new Date(Date.now()-13*60000)},
            ]},
            {name:'Elizabeth Yin',title:'Partner, Hustle Fund',av:'EY',avBg:'#FDF4FF',avC:'#7E22CE',time:'1h ago',unread:3,preview:'We write $25K-$75K checks at pre-seed. Your category is exactly where we',messages:[
              {senderType:'angel',text:'We write $25K–$75K checks at pre-seed.',createdAt:new Date(Date.now()-60*60000)},
              {senderType:'angel',text:'Your category is exactly where we are focused right now.',createdAt:new Date(Date.now()-59*60000)},
              {senderType:'angel',text:'Would love to see your deck if you have one.',createdAt:new Date(Date.now()-55*60000)},
            ]},
            {name:'Ash Rust',title:'Partner, Sterling Road',av:'AR',avBg:'#FFFBEB',avC:'#B45309',time:'3h ago',unread:1,preview:'Quick question - are you open to a $50K check from a solo GP? We move fast',messages:[
              {senderType:'angel',text:'Quick question - are you open to a $50K check from a solo GP?',createdAt:new Date(Date.now()-3*3600000)},
              {senderType:'angel',text:'We move fast and I can give you a decision in 48 hours.',createdAt:new Date(Date.now()-3*3600000+2*60000)},
            ]},
            {name:'Trace Cohen',title:'Partner, Launch House',av:'TC',avBg:'#FFF1F2',avC:'#BE123C',time:'5h ago',unread:2,preview:"Saw your listing in Monday's newsletter. The vision section really stood out.",messages:[
              {senderType:'angel',text:"Saw your listing in Monday's newsletter.",createdAt:new Date(Date.now()-5*3600000)},
              {senderType:'angel',text:'The vision section really stood out. Are you raising a priced round or a SAFE?',createdAt:new Date(Date.now()-5*3600000+5*60000)},
            ]},
            {name:'Brett Calhoun',title:'Partner, Redbud VC',av:'BC',avBg:'#F0F9FF',avC:'#0369A1',time:'Yesterday',unread:1,preview:'Love what you are building. We back B2B SaaS at pre-seed across the Midwest',messages:[
              {senderType:'angel',text:'Love what you are building.',createdAt:new Date(Date.now()-24*3600000)},
              {senderType:'angel',text:'We back B2B SaaS at pre-seed. Let me know if you want to connect.',createdAt:new Date(Date.now()-24*3600000+3*60000)},
            ]},
          ];
          const displayChats=chats.length>0?chats:[];
          const showFakeActivity=noCredits; // blur inbox when no credits — fake count/avatars removed
          const totalUnread=chats.reduce((s,c)=>s+c.unread,0);

          return(
            <div style={{position:'relative',minHeight:580}}>
              {/* ── BLUR OVERLAY - only shows after they've returned at least once ── */}
              {showFakeActivity&&(
                <div style={{position:'absolute',inset:0,zIndex:20,display:'flex',alignItems:'center',justifyContent:'center',padding:'20px 16px'}}>
                  <div style={{background:'#fff',border:'1.5px solid #E5E7EB',borderRadius:20,padding:'32px 28px',maxWidth:400,width:'100%',boxShadow:'0 24px 64px rgba(0,0,0,.14)',textAlign:'center'}}>
                    <div style={{fontSize:36,marginBottom:12}}>🔒</div>
                    <div style={{fontSize:22,fontWeight:800,letterSpacing:'-.5px',marginBottom:8}}>Unlock Your Inbox</div>
                    <div style={{fontSize:14,color:'#6B7280',lineHeight:1.7,marginBottom:22}}>Angel investors have reached out about your startup. Get credits to read and reply.</div>
                    {/* Package teaser - opens full tier picker */}
                    <div style={{background:'linear-gradient(135deg,#FFFBEB,#FEF3C7)',border:'2px solid #FDE68A',borderRadius:14,padding:'16px 18px',marginBottom:20,textAlign:'left'}}>
                      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:10}}>
                        <div style={{fontSize:16,fontWeight:800}}>Plans from $30</div>
                        <div style={{fontSize:11,color:'#92400E',fontWeight:700,background:'#FDE68A',padding:'3px 9px',borderRadius:100}}>3 OPTIONS</div>
                      </div>
                      {['1 credit = 1 message sent or replied','Credits never expire, use anytime','Higher tiers unlock more angel investors','Each reply increases your close rate 3x'].map(b=>(
                        <div key={b} style={{fontSize:12,color:'#92400E',display:'flex',alignItems:'center',gap:7,marginBottom:5}}>
                          <span style={{color:'#F59E0B',fontWeight:800,fontSize:13}}>✓</span>{b}
                        </div>
                      ))}
                    </div>
                    <button onClick={()=>setShowBuyCredits(true)} style={{width:'100%',background:'#0f0f0f',color:'#fff',border:'none',padding:'15px 0',fontSize:15,fontWeight:700,borderRadius:11,cursor:'pointer',marginBottom:8,letterSpacing:'-.2px'}}>
                      Unlock Inbox - View Plans →
                    </button>
                    <div style={{fontSize:11,color:'#9CA3AF'}}>Stripe · Instant · Credits never expire</div>
                  </div>
                </div>
              )}

              {/* ── INBOX CONTENT (blurred only when showing fake activity) ── */}
              <div style={{filter:showFakeActivity?'blur(6px)':'none',pointerEvents:showFakeActivity?'none':'auto',transition:'filter .3s',userSelect:showFakeActivity?'none':'auto'}}>
                <div className="inbox-wrap">
                  {/* Left: chat list */}
                  <div className="inbox-list-col" style={{borderRight:'1px solid #F3F4F6',display:'flex',flexDirection:'column'}}>
                    <div style={{padding:'16px 18px',borderBottom:'1px solid #F3F4F6',display:'flex',alignItems:'center',justifyContent:'space-between'}}>
                      <span style={{fontSize:14,fontWeight:700}}>Inbox</span>
                      {totalUnread>0&&<span style={{background:'#DC2626',color:'#fff',borderRadius:100,fontSize:11,fontWeight:800,padding:'2px 9px'}}>{totalUnread}</span>}
                    </div>
                    <div style={{flex:1,overflowY:'auto'}}>
                      {/* Real chats always shown if they exist */}
                      {displayChats.map(c=>(
                        <div key={c.angelId} onClick={()=>setActiveAngel({_id:c.angelId,...c.angel})} style={{padding:'14px 18px',borderBottom:'1px solid #F9FAFB',cursor:'pointer',background:activeAngel?._id===c.angelId?'#FFFBEB':'#fff',transition:'background .1s'}}>
                          <div style={{display:'flex',alignItems:'center',gap:10}}>
                            <div style={{width:38,height:38,borderRadius:10,background:'linear-gradient(135deg,#EEF2FF,#E0E7FF)',color:'#4338CA',fontSize:12,fontWeight:800,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>{(c.angel?.name||'A').split(' ').map(w=>w[0]).slice(0,2).join('')}</div>
                            <div style={{flex:1,minWidth:0}}>
                              <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',gap:6,marginBottom:3}}>
                                <div style={{fontSize:13,fontWeight:700,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{c.angel?.name||'Angel Investor'}</div>
                              </div>
                              <div style={{fontSize:11,color:'#6B7280',lineHeight:1.4,display:'flex',alignItems:'center',justifyContent:'space-between',gap:6}}>
                                <span style={{overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',flex:1}}>{c.lastMsg?.text?.slice(0,50)}</span>
                                {c.unread>0&&<span style={{background:'#DC2626',color:'#fff',borderRadius:100,fontSize:9,fontWeight:800,padding:'1px 6px',flexShrink:0,minWidth:16,textAlign:'center'}}>{c.unread}</span>}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                      {/* Fake rows - only after they've returned at least once */}
                      {showFakeActivity&&FAKE.map((f,i)=>{
                        const realChat=displayChats.find(c=>c.angel?.name===f.name);
                        return(
                          <div key={i} onClick={()=>realChat&&setActiveAngel({_id:realChat.angelId,...realChat.angel})} style={{padding:'14px 18px',borderBottom:'1px solid #F9FAFB',cursor:realChat?'pointer':'default',background:activeAngel?.name===f.name?'#FFFBEB':'#fff',transition:'background .1s'}}>
                            <div style={{display:'flex',alignItems:'center',gap:10}}>
                              <div style={{width:38,height:38,borderRadius:10,background:f.avBg,color:f.avC,fontSize:12,fontWeight:800,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>{f.av}</div>
                              <div style={{flex:1,minWidth:0}}>
                                <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',gap:6,marginBottom:3}}>
                                  <div style={{fontSize:13,fontWeight:700,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{f.name}</div>
                                  <div style={{fontSize:10,color:'#9CA3AF',flexShrink:0}}>{f.time}</div>
                                </div>
                                <div style={{fontSize:11,color:'#6B7280',lineHeight:1.4,display:'flex',alignItems:'center',justifyContent:'space-between',gap:6}}>
                                  <span style={{overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',flex:1}}>{f.preview}</span>
                                  {f.unread>0&&<span style={{background:'#DC2626',color:'#fff',borderRadius:100,fontSize:9,fontWeight:800,padding:'1px 6px',flexShrink:0,minWidth:16,textAlign:'center'}}>{f.unread}</span>}
                                </div>
                                <div style={{fontSize:10,color:'#9CA3AF',marginTop:3}}>{f.title}</div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                      {/* Clean empty state on first visit */}
                      {!showFakeActivity&&displayChats.length===0&&(
                        <div style={{padding:'40px 24px',textAlign:'center'}}>
                          <div style={{fontSize:32,marginBottom:12}}>📭</div>
                          <div style={{fontSize:13,fontWeight:700,color:'#374151',marginBottom:6}}>No messages yet</div>
                          <div style={{fontSize:12,color:'#9CA3AF',lineHeight:1.6}}>Angels will appear here once they message you. Check back soon, or message one yourself to start a conversation.</div>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Right: chat window */}
                  {showFakeActivity?(
                    /* Show a fake open chat */
                    <div style={{display:'flex',flexDirection:'column'}}>
                      <div style={{padding:'14px 20px',borderBottom:'1px solid #F3F4F6',display:'flex',alignItems:'center',gap:10}}>
                        <div style={{width:36,height:36,borderRadius:10,background:FAKE[0].avBg,color:FAKE[0].avC,fontSize:12,fontWeight:800,display:'flex',alignItems:'center',justifyContent:'center'}}>{FAKE[0].av}</div>
                        <div><div style={{fontSize:14,fontWeight:700}}>{FAKE[0].name}</div><div style={{fontSize:11,color:'#9CA3AF'}}>{FAKE[0].title}</div></div>
                      </div>
                      <div style={{flex:1,padding:'20px',display:'flex',flexDirection:'column',gap:12}}>
                        {FAKE[0].messages.map((m,i)=>(
                          <div key={i} style={{display:'flex',justifyContent:'flex-start'}}>
                            <div style={{maxWidth:'72%',background:'#F3F4F6',padding:'11px 14px',borderRadius:'14px 14px 14px 4px',fontSize:13,lineHeight:1.6,color:'#0f0f0f'}}>
                              {m.text}
                            </div>
                          </div>
                        ))}
                      </div>
                      <div style={{padding:'12px 16px',borderTop:'1px solid #F3F4F6',display:'flex',gap:8}}>
                        <div style={{flex:1,background:'#F9FAFB',border:'1.5px solid #E5E7EB',padding:'10px 14px',borderRadius:24,fontSize:13,color:'#9CA3AF'}}>Reply to {FAKE[0].name.split(' ')[0]}...</div>
                        <div style={{width:40,height:40,borderRadius:'50%',background:'#E5E7EB',display:'flex',alignItems:'center',justifyContent:'center',fontSize:16,color:'#9CA3AF'}}>→</div>
                      </div>
                    </div>
                  ):activeAngel?(
                    <div className="inbox-chat-col active" style={{display:'flex',flexDirection:'column'}}>
                      <div style={{padding:'14px 18px',borderBottom:'1px solid #F3F4F6',display:'flex',alignItems:'center',gap:10}}>
                        <button className="inbox-back-btn" onClick={()=>setActiveAngel(null)} style={{display:'none',alignItems:'center',gap:6,background:'none',border:'none',fontSize:14,fontWeight:600,cursor:'pointer',padding:'0 4px 0 0',color:'#0f0f0f'}}>← Back</button>
                        <div style={{width:34,height:34,borderRadius:'50%',background:'linear-gradient(135deg,#EEF2FF,#E0E7FF)',color:'#4338CA',fontSize:12,fontWeight:800,display:'flex',alignItems:'center',justifyContent:'center'}}>{(activeAngel.name||'A').split(' ').map(w=>w[0]).slice(0,2).join('')}</div>
                        <div><div style={{fontSize:14,fontWeight:700}}>{activeAngel.name}</div><div style={{fontSize:11,color:'#9CA3AF'}}>{activeAngel.title||'Angel Investor'}</div></div>
                        <button onClick={()=>setActiveAngel(null)} style={{marginLeft:'auto',background:'none',border:'none',color:'#9CA3AF',fontSize:20,cursor:'pointer',lineHeight:1,display:'none'}} className="inbox-close-x">×</button>
                      </div>
                      {msgCredits<=50&&msgCredits>0&&(
                        <div style={{padding:'8px 16px',background:'#FFFBEB',borderBottom:'1px solid #FDE68A',fontSize:12,color:'#92400E',display:'flex',alignItems:'center',justifyContent:'space-between'}}>
                          <span>⚠ Only {msgCredits} credits remaining</span>
                          <button onClick={()=>setShowBuyCredits(true)} style={{background:'none',border:'none',color:'#92400E',fontSize:12,fontWeight:700,textDecoration:'underline',cursor:'pointer'}}>Top up →</button>
                        </div>
                      )}
                      <div style={{flex:1}}><ChatWindow messages={messages} onSend={sendMsg} meType="founder" loading={msgLoading}/></div>
                    </div>
                  ):(
                    <div style={{flex:1,display:'flex',alignItems:'center',justifyContent:'center',flexDirection:'column',gap:12,color:'#9CA3AF'}}>
                      <div style={{fontSize:36}}>💬</div>
                      <div style={{fontSize:14,fontWeight:600}}>Select a conversation</div>
                      <div style={{fontSize:13}}>or <button onClick={()=>setTab('angels')} style={{background:'none',border:'none',color:'#F59E0B',fontWeight:700,cursor:'pointer',fontSize:13}}>browse angels to start one</button></div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        })()}

        {/* ── PROFILE ── */}
        {tab==='profile'&&<>
          <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:20}}>
            <div style={{fontSize:20,fontWeight:800,letterSpacing:'-.5px'}}>My Listing</div>
            <button onClick={()=>setEditing(e=>!e)} style={{background:editing?'#F9FAFB':'#0f0f0f',color:editing?'#0f0f0f':'#fff',border:'1px solid #E5E7EB',padding:'8px 18px',borderRadius:8,fontSize:13,fontWeight:600,cursor:'pointer'}}>
              {editing?'Cancel':'Edit Listing'}
            </button>
          </div>
          <div style={{background:'#fff',border:'1px solid #E5E7EB',borderRadius:16,padding:28}}>
            {editing?<>
              {[['name','Your Name'],['email','Email'],['url','Product URL'],['description','Description'],['category','Category'],['funding','Funding target'],['checkSize','Check size per angel']].map(([k,lbl])=>(
                <div key={k} style={{marginBottom:14}}>
                  <label style={{display:'block',fontSize:11,fontWeight:700,letterSpacing:'.06em',textTransform:'uppercase',color:'#9CA3AF',marginBottom:5}}>{lbl}</label>
                  {['description','vision','traction'].includes(k)
                    ?<textarea value={editForm[k]||''} onChange={e=>setEditForm(f=>({...f,[k]:e.target.value}))} rows={3} style={{width:'100%',background:'#F9FAFB',border:'1.5px solid #E5E7EB',padding:'10px 13px',borderRadius:8,outline:'none',fontSize:13,fontFamily:'inherit',resize:'none',lineHeight:1.6,boxSizing:'border-box'}}/>
                    :<input value={editForm[k]||''} onChange={e=>setEditForm(f=>({...f,[k]:e.target.value}))} style={{width:'100%',background:'#F9FAFB',border:'1.5px solid #E5E7EB',padding:'10px 13px',borderRadius:8,outline:'none',fontSize:13,fontFamily:'inherit',boxSizing:'border-box'}}/>
                  }
                </div>
              ))}
              <button onClick={saveProfile} disabled={saving} style={{background:'#0f0f0f',color:'#fff',border:'none',padding:'12px 28px',borderRadius:8,fontSize:14,fontWeight:700,cursor:'pointer'}}>{saving?'Saving...':'Save Changes'}</button>
            </>:<>
              <div style={{display:'flex',alignItems:'flex-start',gap:14,marginBottom:20}}>
                <div style={{width:50,height:50,borderRadius:12,background:'linear-gradient(135deg,#F59E0B,#EF4444)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:22,flexShrink:0}}>🚀</div>
                <div style={{flex:1}}>
                  <div style={{fontSize:19,fontWeight:800,letterSpacing:'-.5px',marginBottom:3}}>{founder.name||founder.url||'Your Startup'}</div>
                  {founder.url&&<a href={founder.url} target="_blank" rel="noreferrer" style={{fontSize:13,color:'#2563EB'}}>{founder.url}</a>}
                  {founder.category&&<div style={{fontSize:11,background:'#EEF2FF',color:'#4338CA',padding:'3px 9px',borderRadius:100,fontWeight:700,display:'inline-block',marginTop:8}}>{founder.category}</div>}
                </div>
                <div style={{textAlign:'right'}}><div style={{fontSize:22,fontWeight:800,color:'#F59E0B',fontFamily:"'DM Mono',monospace"}}>{founder.matchCount?.toLocaleString()}+</div><div style={{fontSize:10,color:'#9CA3AF',fontWeight:600,textTransform:'uppercase',letterSpacing:'.08em'}}>angels matched</div></div>
              </div>
              {founder.description&&<div style={{fontSize:14,color:'#374151',lineHeight:1.7,marginBottom:16,paddingBottom:16,borderBottom:'1px solid #F3F4F6'}}>{founder.description}</div>}
              <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(180px,1fr))',gap:10}}>

                {founder.funding&&<div style={{background:'#F9FAFB',border:'1px solid #E5E7EB',padding:'12px 14px',borderRadius:10}}><div style={{fontSize:9,fontWeight:700,color:'#9CA3AF',textTransform:'uppercase',letterSpacing:'.1em',marginBottom:5}}>Raising</div><div style={{fontSize:13,fontWeight:700}}>{founder.funding}</div></div>}
                {founder.checkSize&&<div style={{background:'#F9FAFB',border:'1px solid #E5E7EB',padding:'12px 14px',borderRadius:10}}><div style={{fontSize:9,fontWeight:700,color:'#9CA3AF',textTransform:'uppercase',letterSpacing:'.1em',marginBottom:5}}>Check Size</div><div style={{fontSize:13,fontWeight:700}}>{founder.checkSize}</div></div>}
              </div>
              {!founder.description&&(
                <div style={{background:'#FFFBEB',border:'1px solid #FDE68A',borderRadius:10,padding:'16px 18px',marginTop:8}}>
                  <div style={{fontSize:13,fontWeight:700,color:'#92400E',marginBottom:4}}>Complete your profile to get more angel messages</div>
                  <div style={{fontSize:12,color:'#92400E',marginBottom:12}}>Startups with full details get 3x more inbound from angels.</div>
                  <button onClick={()=>setEditing(true)} style={{background:'#F59E0B',color:'#000',border:'none',padding:'9px 18px',borderRadius:8,fontSize:12,fontWeight:700,cursor:'pointer'}}>Add Details →</button>
                </div>
              )}
            </>}
          </div>

          {/* ── INTERESTED ANGELS - paid only ── */}
          <InterestedAngels token={token} msgCredits={msgCredits} onUpgrade={()=>setShowBuyCredits(true)}/>
        </>}
      </div>

      {/* Buy Credits modal - 3 pricing tiers */}
      {showBuyCredits&&!showStripe&&(
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.5)',zIndex:999,display:'flex',alignItems:'center',justifyContent:'center',padding:16,backdropFilter:'blur(4px)',overflowY:'auto'}}>
          <div style={{background:'#fff',borderRadius:20,padding:'32px 28px',maxWidth:760,width:'100%',boxShadow:'0 20px 60px rgba(0,0,0,.2)',position:'relative',margin:'auto'}}>
            <button onClick={()=>setShowBuyCredits(false)} style={{position:'absolute',top:14,right:14,background:'#F3F4F6',border:'none',width:28,height:28,borderRadius:'50%',fontSize:16,cursor:'pointer',color:'#6B7280',display:'flex',alignItems:'center',justifyContent:'center'}}>×</button>
            <div style={{textAlign:'center',marginBottom:26}}>
              <div style={{fontSize:36,marginBottom:10}}>💬</div>
              <div style={{fontSize:22,fontWeight:800,marginBottom:8,letterSpacing:'-.5px'}}>Fill In Credits</div>
              <div style={{fontSize:13,color:'#6B7280',lineHeight:1.65}}>One Time Charge · Each message costs <strong style={{color:'#0f0f0f'}}>1 credit</strong>. Higher tiers unlock more of our {TOTAL_ANGELS.toLocaleString()} angel investors.</div>
            </div>
            <div className="tier-grid" style={{marginBottom:16}}>
              {TIERS.map(t=>(
                <div key={t.id} style={{background:t.popular?'linear-gradient(135deg,#FFFBEB,#FEF3C7)':'#fff',border:`2px solid ${t.popular?'#F59E0B':'#E5E7EB'}`,borderRadius:16,padding:'20px 16px',position:'relative',display:'flex',flexDirection:'column'}}>
                  {t.popular&&<div style={{position:'absolute',top:-11,left:'50%',transform:'translateX(-50%)',background:'#F59E0B',color:'#000',fontSize:10,fontWeight:800,padding:'3px 12px',borderRadius:100,whiteSpace:'nowrap'}}>MOST POPULAR</div>}
                  {t.test&&<div style={{position:'absolute',top:-11,left:'50%',transform:'translateX(-50%)',background:'#6366F1',color:'#fff',fontSize:10,fontWeight:800,padding:'3px 12px',borderRadius:100,whiteSpace:'nowrap'}}>TEST</div>}
                  <div style={{textAlign:'center',marginBottom:14}}>
                    <div style={{fontSize:12,fontWeight:700,color:'#9CA3AF',textTransform:'uppercase',letterSpacing:'.06em',marginBottom:6}}>{t.label}</div>
                    <div style={{fontSize:30,fontWeight:800,color:'#0f0f0f',letterSpacing:'-1px'}}>${t.price}</div>
                  </div>
                  <div style={{flex:1,display:'flex',flexDirection:'column',gap:8,marginBottom:16}}>
                    <div style={{display:'flex',alignItems:'flex-start',gap:7,fontSize:12,color:'#374151'}}>
                      <span style={{color:'#10B981',fontWeight:800,flexShrink:0}}>✓</span>
                      <span><strong>{t.credits.toLocaleString()}</strong> message credits</span>
                    </div>
                    <div style={{display:'flex',alignItems:'flex-start',gap:7,fontSize:12,color:'#374151'}}>
                      <span style={{color:'#10B981',fontWeight:800,flexShrink:0}}>✓</span>
                      <span>Access to <strong>{t.angelAccess}</strong> angel investors</span>
                    </div>
                    <div style={{display:'flex',alignItems:'flex-start',gap:7,fontSize:12,color:'#374151'}}>
                      <span style={{color:'#10B981',fontWeight:800,flexShrink:0}}>✓</span>
                      <span>Credits never expire</span>
                    </div>
                    {t.refund&&(
                      <div style={{display:'flex',alignItems:'flex-start',gap:7,fontSize:12,color:'#7C3AED',fontWeight:600,marginTop:2}}>
                        <span style={{color:'#7C3AED',fontWeight:800,flexShrink:0}}>★</span>
                        <span>50% refunded if you haven't raised within 1 year</span>
                      </div>
                    )}
                  </div>
                  <button onClick={()=>{setSelectedTier(t);setShowStripe(true);}} style={{width:'100%',background:t.popular?'#0f0f0f':'#fff',color:t.popular?'#fff':'#0f0f0f',border:`1.5px solid ${t.popular?'#0f0f0f':'#E5E7EB'}`,padding:'11px 0',fontSize:13,fontWeight:700,borderRadius:9,cursor:'pointer'}}>
                    Choose {t.label} →
                  </button>
                </div>
              ))}
            </div>
            <div style={{fontSize:11,color:'#9CA3AF',textAlign:'center'}}>Secure payment via Stripe · Instant activation · {TOTAL_ANGELS.toLocaleString()} angels on the platform</div>
          </div>
        </div>
      )}
      <Pay username={selectedTier?`VCInvest - ${selectedTier.label} (${selectedTier.credits.toLocaleString()} credits)`:'VCInvest Credits'} selectedPrice={selectedTier?.price||30} isOpen={showStripe}
        onClose={s=>{setShowStripe(false);if(s==='success')handleCreditsPurchase('success');else{setShowBuyCredits(false);setSelectedTier(null);}}}
        onSuccess={()=>{setShowStripe(false);handleCreditsPurchase('success');}}
      />
    </div>
  );
}


// ─── ANGEL INVESTOR APP ───────────────────────────────────────────────────────
function AngelApp(){
  const[token,setToken]=useState(()=>localStorage.getItem('wi_angel_token'));
  const[tab,setTab]=useState('browse');
  const[founders,setFounders]=useState([]);const[catFilter,setCatFilter]=useState('');const[searchQ,setSearchQ]=useState('');
  const[activeFounder,setActiveFounder]=useState(null);const[messages,setMessages]=useState([]);const[msgLoading,setMsgLoading]=useState(false);
  const[chats,setChats]=useState([]);
  const[signupMode,setSignupMode]=useState('login');const[step,setStep]=useState(1);
  const[phone,setPhone]=useState('');const[cc,setCc]=useState('+1');const[otp,setOtp]=useState('');
  const[form,setForm]=useState({name:'',firm:'',title:'',checkSize:'',bio:'',linkedin:''});
  const[loading,setLoading]=useState(false);const[err,setErr]=useState('');
  const[angelData,setAngelData]=useState(null);
  const[approved,setApproved]=useState(true);
  const[selectMode,setSelectMode]=useState(false);const[selected,setSelected]=useState(new Set());
  const[showBulkCompose,setShowBulkCompose]=useState(false);const[bulkText,setBulkText]=useState('');
  const[bookmarks,setBookmarks]=useState(new Set());
  const[bookmarkList,setBookmarkList]=useState([]);
  const[bulkSending,setBulkSending]=useState(false);const[bulkResult,setBulkResult]=useState(null);
  const[angelCredits,setAngelCredits]=useState(0);
  const[showBuyAngel,setShowBuyAngel]=useState(false);const[showStripeAngel,setShowStripeAngel]=useState(false);
  const[selectedAngelTier,setSelectedAngelTier]=useState(null);
  const ANGEL_TIERS=[
    {id:'starter',price:30,credits:1000,label:'Starter'},
    {id:'growth',price:90,credits:3000,label:'Growth',popular:true},
    {id:'all-access',price:120,credits:10000,label:'All Access'},
  ];
  const CCS=['+1','+44','+91','+61','+49','+33','+55','+65','+971','+81','+82','+86'];

  useEffect(()=>{
    if(!token)return;
    fetch(API+'/angel/me',{headers:{'x-angel-token':token}}).then(r=>r.json()).then(d=>{
      if(d.angel){setAngelData(d.angel);setApproved(d.angel.approved===true);setAngelCredits(d.angel.msgCredits||0);}
    }).catch(()=>{});
  },[token]);
  useEffect(()=>{if(token)loadFounders();},[token,catFilter,searchQ]);
  useEffect(()=>{
    if(!token)return;
    fetch(API+'/angel/bookmarks',{headers:{'x-angel-token':token}}).then(r=>r.json()).then(d=>{
      setBookmarkList(d.bookmarks||[]);
      setBookmarks(new Set((d.bookmarks||[]).map(b=>b.founderId?.toString())));
    }).catch(()=>{});
  },[token]);
  async function loadFounders(){try{const p=new URLSearchParams();if(catFilter)p.set('category',catFilter);if(searchQ)p.set('q',searchQ);const r=await fetch(`${API}/angel/founders?${p}`,{headers:{'x-angel-token':token}});if(r.status===401){localStorage.removeItem('wi_angel_token');setToken(null);return;}if(r.status===403){setApproved(false);return;}const d=await r.json();setFounders(d.founders||[]);}catch(_){}}
  useEffect(()=>{if(token&&tab==='chats')fetch(API+'/angel/chats',{headers:{'x-angel-token':token}}).then(r=>r.json()).then(d=>setChats(d.chats||[])).catch(()=>{});},[token,tab]);
  useEffect(()=>{
    if(!activeFounder)return;
    const load=()=>fetch(`${API}/angel/messages/${activeFounder._id}`,{headers:{'x-angel-token':token}}).then(r=>r.json()).then(d=>{setMessages(d.messages||[]);setMsgLoading(false);}).catch(()=>{});
    setMsgLoading(true);load();const t=setInterval(load,3000);return()=>clearInterval(t);
  },[activeFounder,token]);

  async function sendMsg(text){
    try{
      const r=await fetch(`${API}/angel/messages/${activeFounder._id}`,{method:'POST',headers:{'Content-Type':'application/json','x-angel-token':token},body:JSON.stringify({text})});
      if(r.status===402){setShowBuyAngel(true);return;}
      const d=await r.json();
      if(typeof d.creditsRemaining==='number')setAngelCredits(d.creditsRemaining);
      fetch(`${API}/angel/messages/${activeFounder._id}`,{headers:{'x-angel-token':token}}).then(r=>r.json()).then(d=>setMessages(d.messages||[]));
    }catch(_){}
  }

  function handleAngelCreditsPurchase(status){
    if(status!=='success'||!selectedAngelTier)return;
    const n=angelCredits+selectedAngelTier.credits;setAngelCredits(n);setShowBuyAngel(false);setSelectedAngelTier(null);
    fetch(API+'/angel/add-credits',{method:'POST',headers:{'Content-Type':'application/json','x-angel-token':token},body:JSON.stringify({credits:selectedAngelTier.credits,tier:selectedAngelTier.id,price:selectedAngelTier.price})}).catch(()=>{});
  }

  function toggleSelect(id){setSelected(prev=>{const next=new Set(prev);if(next.has(id))next.delete(id);else next.add(id);return next;});}
  function selectAll(){setSelected(new Set(founders.map(f=>f._id)));}
  function clearSelection(){setSelected(new Set());}
  function exitSelectMode(){setSelectMode(false);setSelected(new Set());}

  async function sendBulkMessage(){
    if(!bulkText.trim()||selected.size===0)return;
    setBulkSending(true);setBulkResult(null);
    try{
      const r=await fetch(API+'/angel/bulk-message',{method:'POST',headers:{'Content-Type':'application/json','x-angel-token':token},body:JSON.stringify({founderIds:[...selected],text:bulkText})});
      const d=await r.json();
      if(!r.ok)throw new Error(d.error||'Failed to send');
      setBulkResult({ok:true,sent:d.sent,total:d.total});
      setTimeout(()=>{setShowBulkCompose(false);setBulkText('');setBulkResult(null);exitSelectMode();},1800);
    }catch(e){setBulkResult({error:e.message});}
    setBulkSending(false);
  }

  async function toggleBookmark(e,f){
    e.stopPropagation();
    const fid=f._id.toString();
    // Optimistic update
    setBookmarks(prev=>{const next=new Set(prev);if(next.has(fid))next.delete(fid);else next.add(fid);return next;});
    try{
      const r=await fetch(`${API}/angel/bookmark/${fid}`,{method:'POST',headers:{'x-angel-token':token}});
      const d=await r.json();
      if(d.bookmarked){
        setBookmarkList(prev=>[{founderId:fid,founder:f,createdAt:new Date()},...prev.filter(b=>b.founderId?.toString()!==fid)]);
      }else{
        setBookmarkList(prev=>prev.filter(b=>b.founderId?.toString()!==fid));
      }
    }catch(_){
      // Revert on error
      setBookmarks(prev=>{const next=new Set(prev);if(next.has(fid))next.delete(fid);else next.add(fid);return next;});
    }
  }

  async function sendOtp(){setErr('');if(phone.length<5){setErr('Enter a valid phone number');return;}setLoading(true);
    try{const endpoint=signupMode==='signup'?'/angel/send-otp':'/angel/login';const body=signupMode==='signup'?{phone:cc+phone.replace(/^0+/,''),...form}:{phone:cc+phone.replace(/^0+/,'')};const r=await fetch(API+endpoint,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)});const text=await r.text();let d;try{d=JSON.parse(text);}catch(_){throw new Error('Server error - check deployment');}if(!r.ok)throw new Error(d.error||'Failed');setStep(2);}
    catch(e){setErr(e.message);}setLoading(false);}

  async function verifyOtp(){setErr('');setLoading(true);
    try{const endpoint=signupMode==='signup'?'/angel/verify-otp':'/angel/login-verify';const r=await fetch(API+endpoint,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({phone:cc+phone.replace(/^0+/,''),otp})});const text=await r.text();let d;try{d=JSON.parse(text);}catch(_){throw new Error('Server error - check deployment');}if(!r.ok)throw new Error(d.error||'Failed');localStorage.setItem('wi_angel_token',d.token);setToken(d.token);}
    catch(e){setErr(e.message);}setLoading(false);}

  const cats=[...new Set(founders.map(f=>f.category).filter(Boolean))].sort();

  if(!token)return(
    <div style={{minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center',background:'var(--s2)',fontFamily:"'Inter',sans-serif"}}>
      <div style={{background:'#fff',border:'1px solid var(--bd)',borderRadius:'var(--radius-xl)',padding:'36px 32px',maxWidth:420,width:'100%',boxShadow:'var(--shadow-lg)'}}>
        <div style={{textAlign:'center',marginBottom:20}}>
          <div style={{fontSize:26,marginBottom:8}}>💼</div>
          <div style={{fontSize:20,fontWeight:800,marginBottom:4}}>Angel Investor Portal</div>
          <div style={{fontSize:13,color:'var(--mu)'}}>Browse startups and connect directly with founders.</div>
        </div>
        <div style={{display:'flex',gap:6,marginBottom:20,background:'var(--s2)',padding:4,borderRadius:'var(--radius)'}}>
          {[['login','Log In'],['signup','Sign Up']].map(([m,lbl])=><button key={m} onClick={()=>{setSignupMode(m);setStep(1);setErr('');}} style={{flex:1,padding:'8px 0',border:'none',borderRadius:6,fontSize:13,fontWeight:700,cursor:'pointer',background:signupMode===m?'#fff':'transparent',color:signupMode===m?'var(--ink)':'var(--mu)',boxShadow:signupMode===m?'0 1px 3px rgba(0,0,0,.08)':'none'}}>{lbl}</button>)}
        </div>
        {err&&<div style={{fontSize:12,color:'var(--r)',background:'#FEF2F2',border:'1px solid #FECACA',padding:'10px 14px',borderRadius:'var(--radius)',marginBottom:14}}>⚠ {err}</div>}
        {step===1&&<>
          {signupMode==='signup'&&[['name','Your Name *'],['firm','Fund / Firm'],['title','Title'],['checkSize','Typical check size'],['bio','Short bio']].map(([k,lbl])=>(
            <div key={k} style={{marginBottom:10}}><label style={{display:'block',fontSize:10,fontWeight:700,letterSpacing:'.08em',textTransform:'uppercase',color:'var(--mu)',marginBottom:4}}>{lbl}</label><input value={form[k]||''} onChange={e=>setForm(f=>({...f,[k]:e.target.value}))} style={{width:'100%',background:'var(--s2)',border:'1.5px solid var(--bd)',padding:'9px 13px',borderRadius:'var(--radius)',outline:'none',fontSize:13,fontFamily:'inherit'}}/></div>
          ))}
          {signupMode==='signup'&&<div style={{marginBottom:10}}>
            <label style={{display:'block',fontSize:10,fontWeight:700,letterSpacing:'.08em',textTransform:'uppercase',color:'var(--mu)',marginBottom:4}}>LinkedIn URL <span style={{color:'var(--r)'}}>* Required</span></label>
            <input value={form.linkedin||''} onChange={e=>setForm(f=>({...f,linkedin:e.target.value}))} placeholder="https://linkedin.com/in/yourname" style={{width:'100%',background:'var(--s2)',border:`1.5px solid ${form.linkedin&&!form.linkedin.includes('linkedin')?'var(--r)':'var(--bd)'}`,padding:'9px 13px',borderRadius:'var(--radius)',outline:'none',fontSize:13,fontFamily:'inherit'}}/>
            {form.linkedin&&!form.linkedin.includes('linkedin')&&<div style={{fontSize:11,color:'var(--r)',marginTop:4}}>Must be a LinkedIn URL</div>}
          </div>}
          <label style={{display:'block',fontSize:10,fontWeight:700,letterSpacing:'.08em',textTransform:'uppercase',color:'var(--mu)',marginBottom:6}}>Phone Number</label>
          <div style={{display:'flex',gap:8,marginBottom:16}}>
            <select value={cc} onChange={e=>setCc(e.target.value)} style={{background:'var(--s2)',border:'1.5px solid var(--bd)',fontSize:13,fontWeight:600,padding:'0 10px',borderRadius:'var(--radius)',outline:'none',height:46,minWidth:80,cursor:'pointer'}}>{CCS.map(c=><option key={c} value={c}>{c}</option>)}</select>
            <input style={{flex:1,background:'var(--s2)',border:'1.5px solid var(--bd)',padding:'11px 14px',borderRadius:'var(--radius)',outline:'none',fontSize:14,fontFamily:'inherit'}} type="tel" placeholder="555 000 0000" value={phone} onChange={e=>setPhone(e.target.value)}/>
          </div>
          <button className="btn-primary" style={{width:'100%'}} onClick={sendOtp} disabled={loading}>{loading?'Sending...':'Send Verification Code'}</button>
        </>}
        {step===2&&<>
          <div style={{fontSize:13,color:'var(--mu)',marginBottom:16,textAlign:'center'}}>Code sent to <strong>{cc}{phone}</strong></div>
          <input style={{width:'100%',background:'var(--s2)',border:'2px solid var(--bd)',fontFamily:"'DM Mono',monospace",fontSize:28,letterSpacing:'.4em',padding:13,textAlign:'center',outline:'none',borderRadius:'var(--radius)',marginBottom:14}} placeholder="000000" maxLength={6} value={otp} onChange={e=>setOtp(e.target.value.replace(/[^0-9]/g,''))} autoFocus/>
          <button className="btn-primary" style={{width:'100%',marginBottom:10}} onClick={verifyOtp} disabled={loading||otp.length!==6}>{loading?'Verifying...':'Enter Portal'}</button>
          <button style={{background:'none',border:'none',fontSize:12,color:'var(--mu)',textDecoration:'underline',cursor:'pointer',width:'100%',textAlign:'center'}} onClick={sendOtp}>Resend code</button>
        </>}
      </div>
    </div>
  );

  // ── Pending approval screen ───────────────────────────────────────────────
  if(token&&!approved)return(
    <div style={{minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center',background:'var(--s2)',fontFamily:"'Inter',sans-serif",padding:16}}>
      <div style={{background:'#fff',border:'1px solid var(--bd)',borderRadius:20,padding:'40px 32px',maxWidth:420,width:'100%',boxShadow:'var(--shadow-lg)',textAlign:'center'}}>
        <div style={{width:64,height:64,borderRadius:'50%',background:'#FFFBEB',border:'2px solid #FDE68A',display:'flex',alignItems:'center',justifyContent:'center',fontSize:32,margin:'0 auto 18px'}}>⏳</div>
        <div style={{fontSize:22,fontWeight:800,marginBottom:8,letterSpacing:'-.5px'}}>Application Under Review</div>
        <div style={{fontSize:14,color:'var(--mu)',lineHeight:1.7,marginBottom:20}}>We manually verify every investor before granting access. You will receive an SMS once your account is approved - usually within 24 hours.</div>
        {angelData?.linkedin&&<div style={{background:'#EFF6FF',border:'1px solid #BFDBFE',borderRadius:10,padding:'10px 16px',marginBottom:20,fontSize:13,color:'#1D4ED8'}}>✓ LinkedIn submitted: <a href={angelData.linkedin} target="_blank" rel="noreferrer" style={{color:'#1D4ED8',fontWeight:700}}>{angelData.linkedin.replace('https://','').slice(0,40)}</a></div>}
        <div style={{fontSize:12,color:'var(--mu)',marginBottom:20}}>Questions? Email <strong>hello@vcinvest.pro</strong></div>
        <button onClick={()=>{localStorage.removeItem('wi_angel_token');setToken(null);}} style={{background:'none',border:'1px solid var(--bd)',color:'var(--mu)',padding:'10px 24px',borderRadius:'var(--radius)',fontSize:13,cursor:'pointer'}}>Log out</button>
      </div>
    </div>
  );

  return(
    <div style={{minHeight:'100vh',background:'var(--s2)',fontFamily:"'Inter',sans-serif"}}>
      <div style={{background:'#fff',borderBottom:'1px solid var(--bd)',padding:'12px 16px',display:'flex',alignItems:'center',justifyContent:'space-between',flexWrap:'wrap',gap:8,position:'sticky',top:0,zIndex:50}}>
        <div style={{fontSize:17,fontWeight:800}}>VC<em style={{fontStyle:'normal',color:'var(--y)'}}>Invest</em><span style={{fontSize:12,fontWeight:500,color:'var(--mu)',marginLeft:8}}>Investor Portal</span></div>
        <div style={{display:'flex',gap:8,alignItems:'center'}}>
          <div onClick={()=>setShowBuyAngel(true)} style={{display:'flex',alignItems:'center',gap:5,background:'#FFFBEB',border:'1px solid #FDE68A',padding:'5px 10px',borderRadius:8,cursor:'pointer'}}>
            <span style={{fontSize:14,fontWeight:800,color:'#92400E',fontFamily:"'DM Mono',monospace"}}>{angelCredits}</span>
            <span style={{fontSize:10,color:'#92400E',fontWeight:700,textTransform:'uppercase',letterSpacing:'.06em'}}>credits</span>
            {angelCredits===0&&<span style={{background:'#DC2626',color:'#fff',fontSize:10,fontWeight:700,padding:'1px 6px',borderRadius:4}}>Buy</span>}
          </div>
          <button onClick={()=>{setTab('browse');setActiveFounder(null);}} style={{background:tab==='browse'?'var(--ink)':'#fff',color:tab==='browse'?'#fff':'var(--mu)',border:'1px solid var(--bd)',padding:'7px 16px',borderRadius:'var(--radius)',fontSize:13,fontWeight:600,cursor:'pointer'}}>Browse Startups</button>
          <button onClick={()=>setTab('chats')} style={{background:tab==='chats'?'var(--ink)':'#fff',color:tab==='chats'?'#fff':'var(--mu)',border:'1px solid var(--bd)',padding:'7px 16px',borderRadius:'var(--radius)',fontSize:13,fontWeight:600,cursor:'pointer'}}>Messages{chats.reduce((s,c)=>s+c.unread,0)>0?` (${chats.reduce((s,c)=>s+c.unread,0)})`:''}</button>
          <button onClick={()=>setTab('bookmarks')} style={{background:tab==='bookmarks'?'var(--ink)':'#fff',color:tab==='bookmarks'?'#fff':'var(--mu)',border:'1px solid var(--bd)',padding:'7px 16px',borderRadius:'var(--radius)',fontSize:13,fontWeight:600,cursor:'pointer'}}>🔖 Saved{bookmarks.size>0?` (${bookmarks.size})`:''}</button>
          <button onClick={()=>{localStorage.removeItem('wi_angel_token');setToken(null);}} style={{background:'none',border:'1px solid var(--bd)',color:'var(--mu)',padding:'7px 14px',borderRadius:'var(--radius)',fontSize:12,cursor:'pointer'}}>Logout</button>
        </div>
      </div>
      <div style={{maxWidth:1100,margin:'0 auto',padding:'14px 12px 80px'}}>
        {tab==='browse'&&<div>
          <div style={{marginBottom:16,display:'flex',gap:8,flexWrap:'wrap',alignItems:'center'}}>
            <input value={searchQ} onChange={e=>setSearchQ(e.target.value)} placeholder="Search startups by name, category, or description..." style={{flex:'1 1 220px',background:'#fff',border:'1.5px solid var(--bd)',padding:'10px 16px',borderRadius:'var(--radius)',outline:'none',fontSize:13,fontFamily:'inherit'}}/>
            <select value={catFilter} onChange={e=>setCatFilter(e.target.value)} style={{flex:'0 1 180px',background:'#fff',border:'1.5px solid var(--bd)',padding:'10px 12px',borderRadius:'var(--radius)',outline:'none',fontSize:13,color:catFilter?'var(--ink)':'var(--mu)'}}>
              <option value="">All categories</option>{cats.map(c=><option key={c} value={c}>{c}</option>)}
            </select>
            <button onClick={()=>selectMode?exitSelectMode():setSelectMode(true)} style={{background:selectMode?'#0f0f0f':'#fff',color:selectMode?'#fff':'#0f0f0f',border:'1.5px solid #0f0f0f',padding:'10px 18px',borderRadius:'var(--radius)',fontSize:13,fontWeight:700,cursor:'pointer',whiteSpace:'nowrap'}}>
              {selectMode?'✕ Cancel':'☑ Select Multiple'}
            </button>
          </div>

          {selectMode&&(
            <div style={{background:'#FFFBEB',border:'1px solid #FDE68A',borderRadius:'var(--radius)',padding:'10px 16px',marginBottom:14,display:'flex',alignItems:'center',justifyContent:'space-between',gap:10,flexWrap:'wrap'}}>
              <div style={{fontSize:13,color:'#92400E',fontWeight:600}}>{selected.size} of {founders.length} selected</div>
              <div style={{display:'flex',gap:8}}>
                <button onClick={selectAll} style={{background:'none',border:'1px solid #FDE68A',color:'#92400E',padding:'6px 14px',borderRadius:7,fontSize:12,fontWeight:700,cursor:'pointer'}}>Select All</button>
                <button onClick={clearSelection} style={{background:'none',border:'1px solid #FDE68A',color:'#92400E',padding:'6px 14px',borderRadius:7,fontSize:12,fontWeight:700,cursor:'pointer'}}>Clear</button>
                <button onClick={()=>selected.size>0&&setShowBulkCompose(true)} disabled={selected.size===0} style={{background:selected.size>0?'#0f0f0f':'#E5E7EB',color:selected.size>0?'#fff':'#9CA3AF',border:'none',padding:'6px 16px',borderRadius:7,fontSize:12,fontWeight:700,cursor:selected.size>0?'pointer':'default'}}>
                  💬 Message {selected.size>0?selected.size:''} Founder{selected.size!==1?'s':''}
                </button>
              </div>
            </div>
          )}

          <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(280px,1fr))',gap:12}}>
            {founders.length===0&&<div style={{gridColumn:'1/-1',background:'#fff',border:'1px solid var(--bd)',borderRadius:'var(--radius-lg)',padding:40,textAlign:'center',fontSize:13,color:'var(--mu)'}}>No startups found</div>}
            {founders.map(f=>{
              const isSel=selected.has(f._id);
              return(
              <div key={f._id} onClick={()=>selectMode?toggleSelect(f._id):setActiveFounder(f)} style={{background:'#fff',border:`1.5px solid ${isSel?'#F59E0B':'var(--bd)'}`,borderRadius:'var(--radius-lg)',padding:'16px 18px',cursor:'pointer',boxShadow:isSel?'0 0 0 3px rgba(245,158,11,.15)':'var(--shadow-sm)',transition:'all .15s',position:'relative'}}
                onMouseEnter={e=>{if(!isSel){e.currentTarget.style.borderColor='#F59E0B';e.currentTarget.style.boxShadow='0 4px 16px rgba(0,0,0,.08)';}}}
                onMouseLeave={e=>{if(!isSel){e.currentTarget.style.borderColor='var(--bd)';e.currentTarget.style.boxShadow='var(--shadow-sm)';}}}>
                {selectMode&&(
                  <div style={{position:'absolute',top:14,right:14,width:22,height:22,borderRadius:6,border:`2px solid ${isSel?'#F59E0B':'#D1D5DB'}`,background:isSel?'#F59E0B':'#fff',display:'flex',alignItems:'center',justifyContent:'center',fontSize:13,color:'#fff',fontWeight:800}}>
                    {isSel?'✓':''}
                  </div>
                )}
                <div style={{display:'flex',alignItems:'flex-start',justifyContent:'space-between',gap:8,marginBottom:8,paddingRight:selectMode?28:0}}>
                  <div style={{fontSize:15,fontWeight:800,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',flex:1}}>{f.name||f.url||'Startup'}</div>
                  <div style={{display:'flex',alignItems:'center',gap:5,flexShrink:0}}>
                    {!selectMode&&<button onClick={e=>toggleBookmark(e,f)} title={bookmarks.has(f._id.toString())?'Remove bookmark':'Bookmark this startup'} style={{background:'none',border:'none',fontSize:18,cursor:'pointer',lineHeight:1,padding:2,transition:'transform .15s'}} onMouseEnter={e=>e.currentTarget.style.transform='scale(1.2)'} onMouseLeave={e=>e.currentTarget.style.transform='scale(1)'}>{bookmarks.has(f._id.toString())?'🔖':'🤍'}</button>}
                    {!selectMode&&f.category&&<span style={{fontSize:9,background:'#EDE9FE',color:'#5B21B6',padding:'2px 7px',borderRadius:100,fontWeight:700,whiteSpace:'nowrap'}}>{f.category.split('/')[0].trim()}</span>}
                  </div>
                </div>
                {f.description&&<div style={{fontSize:12,color:'var(--mu)',lineHeight:1.55,marginBottom:10,overflow:'hidden',display:'-webkit-box',WebkitLineClamp:3,WebkitBoxOrient:'vertical',minHeight:54}}>{f.description}</div>}
                <div style={{display:'flex',gap:8,flexWrap:'wrap',marginBottom:12}}>
                  {f.funding&&<span style={{fontSize:11,fontWeight:600,color:'var(--ink)',background:'var(--s2)',padding:'3px 9px',borderRadius:6}}>{f.funding}</span>}
                  {f.traction&&<span style={{fontSize:11,color:'var(--g)',fontWeight:600,background:'#F0FDF4',padding:'3px 9px',borderRadius:6}}>📈 {f.traction.slice(0,28)}</span>}
                </div>
                {!selectMode&&(
                  <button onClick={e=>{e.stopPropagation();setActiveFounder(f);}} style={{width:'100%',background:'#0f0f0f',color:'#fff',border:'none',padding:'9px 0',fontSize:12,fontWeight:700,borderRadius:8,cursor:'pointer'}}>
                    💬 Message Founder →
                  </button>
                )}
              </div>
            );})}
          </div>

          {/* Floating action bar when scrolled, for quick access */}
          {selectMode&&selected.size>0&&(
            <div style={{position:'fixed',bottom:20,left:'50%',transform:'translateX(-50%)',background:'#0f0f0f',color:'#fff',padding:'12px 20px',borderRadius:100,boxShadow:'0 8px 24px rgba(0,0,0,.3)',display:'flex',alignItems:'center',gap:14,zIndex:90}}>
              <span style={{fontSize:13,fontWeight:600}}>{selected.size} selected</span>
              <button onClick={()=>setShowBulkCompose(true)} style={{background:'#F59E0B',color:'#000',border:'none',padding:'8px 18px',borderRadius:100,fontSize:12,fontWeight:700,cursor:'pointer'}}>💬 Message All →</button>
            </div>
          )}
        </div>}
        {tab==='chats'&&<div style={{background:'#fff',border:'1px solid var(--bd)',borderRadius:'var(--radius-xl)',overflow:'hidden',boxShadow:'var(--shadow-sm)',minHeight:300}}>
          <div style={{padding:'16px 18px',borderBottom:'1px solid var(--bd)',fontSize:14,fontWeight:700}}>Conversations</div>
          {chats.length===0&&<div style={{padding:40,fontSize:13,color:'var(--mu)',textAlign:'center'}}>No conversations yet. Browse startups to message a founder.</div>}
          {chats.map(c=><div key={c.founderId} onClick={()=>setActiveFounder({_id:c.founderId,...c.founder})} style={{padding:'14px 18px',cursor:'pointer',borderBottom:'1px solid var(--s3)',background:'#fff',transition:'background .1s'}}
            onMouseEnter={e=>e.currentTarget.style.background='#FFFBEB'} onMouseLeave={e=>e.currentTarget.style.background='#fff'}>
            <div style={{display:'flex',alignItems:'center',justifyContent:'space-between'}}>
              <div style={{fontSize:14,fontWeight:700,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{c.founder?.name||c.founder?.url||'Startup'}</div>
              {c.unread>0&&<span style={{background:'var(--r)',color:'#fff',borderRadius:100,fontSize:10,fontWeight:800,padding:'1px 7px'}}>{c.unread}</span>}
            </div>
            <div style={{fontSize:11,color:'var(--mu2)',marginTop:3,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{c.lastMsg?.text?.slice(0,60)}</div>
          </div>)}
        </div>}
      </div>

        {tab==='bookmarks'&&<div>
          <div style={{marginBottom:16,display:'flex',alignItems:'center',justifyContent:'space-between',flexWrap:'wrap',gap:10}}>
            <div>
              <div style={{fontSize:20,fontWeight:800,letterSpacing:'-.5px',marginBottom:4}}>Saved Startups</div>
              <div style={{fontSize:13,color:'var(--mu)'}}>{bookmarkList.length} startup{bookmarkList.length!==1?'s':''} shortlisted - founders get notified when you save them</div>
            </div>
            {bookmarkList.length>0&&(
              <button onClick={()=>{setSelected(new Set(bookmarkList.map(b=>b.founderId?.toString())));setSelectMode(true);setTab('browse');}} style={{background:'var(--ink)',color:'#fff',border:'none',padding:'9px 18px',borderRadius:'var(--radius)',fontSize:12,fontWeight:700,cursor:'pointer'}}>
                💬 Message All Saved →
              </button>
            )}
          </div>
          {bookmarkList.length===0&&(
            <div style={{background:'#fff',border:'1px solid var(--bd)',borderRadius:'var(--radius-xl)',padding:60,textAlign:'center'}}>
              <div style={{fontSize:40,marginBottom:12}}>🤍</div>
              <div style={{fontSize:15,fontWeight:700,marginBottom:6}}>No saved startups yet</div>
              <div style={{fontSize:13,color:'var(--mu)',marginBottom:18}}>Tap 🤍 on any startup card to shortlist it. Founders get an SMS notification when you save them.</div>
              <button onClick={()=>setTab('browse')} style={{background:'var(--ink)',color:'#fff',border:'none',padding:'11px 24px',borderRadius:'var(--radius)',fontSize:13,fontWeight:700,cursor:'pointer'}}>Browse Startups →</button>
            </div>
          )}
          <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(280px,1fr))',gap:12}}>
            {bookmarkList.map(b=>{const f=b.founder;if(!f)return null;return(
              <div key={b.founderId} style={{background:'#fff',border:'1.5px solid var(--bd)',borderRadius:'var(--radius-lg)',padding:'16px 18px',boxShadow:'var(--shadow-sm)',transition:'all .15s',cursor:'pointer'}} onClick={()=>setActiveFounder(f)}
                onMouseEnter={e=>{e.currentTarget.style.borderColor='#F59E0B';e.currentTarget.style.boxShadow='0 4px 16px rgba(0,0,0,.08)';}}
                onMouseLeave={e=>{e.currentTarget.style.borderColor='var(--bd)';e.currentTarget.style.boxShadow='var(--shadow-sm)';}}>
                <div style={{display:'flex',alignItems:'flex-start',justifyContent:'space-between',gap:8,marginBottom:8}}>
                  <div style={{fontSize:15,fontWeight:800,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',flex:1}}>{f.name||f.url||'Startup'}</div>
                  <div style={{display:'flex',alignItems:'center',gap:5}}>
                    <button onClick={e=>toggleBookmark(e,f)} style={{background:'none',border:'none',fontSize:18,cursor:'pointer',lineHeight:1,padding:2}}>🔖</button>
                    {f.category&&<span style={{fontSize:9,background:'#EDE9FE',color:'#5B21B6',padding:'2px 7px',borderRadius:100,fontWeight:700,whiteSpace:'nowrap'}}>{f.category.split('/')[0].trim()}</span>}
                  </div>
                </div>
                {f.description&&<div style={{fontSize:12,color:'var(--mu)',lineHeight:1.55,marginBottom:10,overflow:'hidden',display:'-webkit-box',WebkitLineClamp:3,WebkitBoxOrient:'vertical'}}>{f.description}</div>}
                <div style={{display:'flex',gap:8,flexWrap:'wrap',marginBottom:12}}>
                  {f.funding&&<span style={{fontSize:11,fontWeight:600,color:'var(--ink)',background:'var(--s2)',padding:'3px 9px',borderRadius:6}}>{f.funding}</span>}
                  {f.traction&&<span style={{fontSize:11,color:'var(--g)',fontWeight:600,background:'#F0FDF4',padding:'3px 9px',borderRadius:6}}>📈 {f.traction.slice(0,28)}</span>}
                </div>
                <div style={{display:'flex',gap:8}}>
                  <button onClick={e=>{e.stopPropagation();setActiveFounder(f);}} style={{flex:1,background:'#0f0f0f',color:'#fff',border:'none',padding:'9px 0',fontSize:12,fontWeight:700,borderRadius:8,cursor:'pointer'}}>💬 Message →</button>
                </div>
                <div style={{fontSize:10,color:'var(--mu)',marginTop:8,textAlign:'center'}}>Saved {new Date(b.createdAt).toLocaleDateString()}</div>
              </div>
            );})}
          </div>
        </div>}

      {/* ── BULK MESSAGE POPUP ── */}
      {showBulkCompose&&(
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.5)',zIndex:999,display:'flex',alignItems:'center',justifyContent:'center',padding:16,backdropFilter:'blur(4px)'}} onClick={()=>!bulkSending&&setShowBulkCompose(false)}>
          <div onClick={e=>e.stopPropagation()} style={{background:'#fff',borderRadius:20,maxWidth:480,width:'100%',boxShadow:'0 24px 64px rgba(0,0,0,.25)',overflow:'hidden'}}>
            <div style={{padding:'20px 22px',borderBottom:'1px solid var(--bd)',display:'flex',alignItems:'flex-start',justifyContent:'space-between'}}>
              <div>
                <div style={{fontSize:18,fontWeight:800,marginBottom:3}}>📢 Message {selected.size} Founder{selected.size!==1?'s':''}</div>
                <div style={{fontSize:12,color:'var(--mu)'}}>The same message will be sent to every selected founder.</div>
              </div>
              <button onClick={()=>setShowBulkCompose(false)} style={{background:'#F9FAFB',border:'none',width:30,height:30,borderRadius:'50%',color:'var(--mu)',fontSize:18,cursor:'pointer',flexShrink:0}}>×</button>
            </div>
            <div style={{padding:'18px 22px'}}>
              {/* Selected founder chips */}
              <div style={{display:'flex',flexWrap:'wrap',gap:6,marginBottom:16,maxHeight:90,overflowY:'auto'}}>
                {founders.filter(f=>selected.has(f._id)).map(f=>(
                  <span key={f._id} style={{fontSize:11,background:'var(--s2)',border:'1px solid var(--bd)',color:'var(--ink2)',padding:'4px 10px',borderRadius:100,fontWeight:600,whiteSpace:'nowrap'}}>{f.name||f.url||'Startup'}</span>
                ))}
              </div>
              <textarea
                value={bulkText} onChange={e=>setBulkText(e.target.value)}
                placeholder="Hi! I'm an angel investor interested in your space. Would love to learn more about what you're building..."
                rows={5}
                style={{width:'100%',background:'var(--s2)',border:'1.5px solid var(--bd)',padding:'12px 14px',borderRadius:'var(--radius)',outline:'none',fontSize:13,fontFamily:'inherit',resize:'none',lineHeight:1.6,boxSizing:'border-box',marginBottom:14}}
                autoFocus
              />
              {bulkResult?.ok&&<div style={{background:'#F0FDF4',border:'1px solid #A7F3D0',borderRadius:'var(--radius)',padding:'10px 14px',marginBottom:14,fontSize:13,color:'#065F46',fontWeight:600}}>✓ Sent to {bulkResult.sent} of {bulkResult.total} founders!</div>}
              {bulkResult?.error&&<div style={{background:'#FEF2F2',border:'1px solid #FECACA',borderRadius:'var(--radius)',padding:'10px 14px',marginBottom:14,fontSize:13,color:'var(--r)'}}>⚠ {bulkResult.error}</div>}
              <button onClick={sendBulkMessage} disabled={bulkSending||!bulkText.trim()} style={{width:'100%',background:'#0f0f0f',color:'#fff',border:'none',padding:'13px 0',fontSize:14,fontWeight:700,borderRadius:10,cursor:'pointer',opacity:bulkSending||!bulkText.trim()?.5:1}}>
                {bulkSending?'Sending...':`Send to ${selected.size} Founder${selected.size!==1?'s':''} →`}
              </button>
              <div style={{fontSize:11,color:'var(--mu)',textAlign:'center',marginTop:10}}>Each founder gets an SMS notification with your message.</div>
            </div>
          </div>
        </div>
      )}

      {/* ── MESSAGE POPUP - opens on top, no scrolling needed ── */}
      {activeFounder&&(
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.5)',zIndex:999,display:'flex',alignItems:'center',justifyContent:'center',padding:16,backdropFilter:'blur(4px)'}} onClick={()=>setActiveFounder(null)}>
          <div onClick={e=>e.stopPropagation()} style={{background:'#fff',borderRadius:20,maxWidth:520,width:'100%',maxHeight:'85vh',display:'flex',flexDirection:'column',boxShadow:'0 24px 64px rgba(0,0,0,.25)',overflow:'hidden'}}>
            {/* Header - founder info, capped height so it never pushes out the chat input */}
            <div style={{padding:'20px 22px',borderBottom:'1px solid var(--bd)',flexShrink:0,maxHeight:'34vh',overflowY:'auto'}}>
              <div style={{display:'flex',alignItems:'flex-start',justifyContent:'space-between',marginBottom:10}}>
                <div>
                  <div style={{fontSize:18,fontWeight:800,marginBottom:2}}>{activeFounder.name||activeFounder.url||'Startup'}</div>
                  {activeFounder.url&&<a href={activeFounder.url} target="_blank" rel="noreferrer" style={{fontSize:12,color:'var(--bl)'}}>{activeFounder.url} ↗</a>}
                </div>
                <button onClick={()=>setActiveFounder(null)} style={{background:'#F9FAFB',border:'none',width:30,height:30,borderRadius:'50%',color:'var(--mu)',fontSize:18,cursor:'pointer',flexShrink:0}}>×</button>
              </div>
              {activeFounder.description&&<div style={{fontSize:13,color:'var(--ink2)',lineHeight:1.6,marginBottom:10,display:'-webkit-box',WebkitLineClamp:3,WebkitBoxOrient:'vertical',overflow:'hidden'}}>{activeFounder.description}</div>}
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:7}}>
                {activeFounder.vision&&<div style={{background:'#F5F3FF',border:'1px solid #DDD6FE',padding:'8px 11px',borderRadius:8}}><div style={{fontSize:8,fontWeight:700,color:'#7C3AED',textTransform:'uppercase',letterSpacing:'.1em',marginBottom:3}}>Vision</div><div style={{fontSize:11,color:'#3B0764',lineHeight:1.4,display:'-webkit-box',WebkitLineClamp:3,WebkitBoxOrient:'vertical',overflow:'hidden'}}>{activeFounder.vision}</div></div>}
                {activeFounder.traction&&<div style={{background:'#F0FDF4',border:'1px solid #A7F3D0',padding:'8px 11px',borderRadius:8}}><div style={{fontSize:8,fontWeight:700,color:'#10B981',textTransform:'uppercase',letterSpacing:'.1em',marginBottom:3}}>Traction</div><div style={{fontSize:11,color:'#065F46',lineHeight:1.4,display:'-webkit-box',WebkitLineClamp:3,WebkitBoxOrient:'vertical',overflow:'hidden'}}>{activeFounder.traction}</div></div>}
                {activeFounder.funding&&<div style={{background:'var(--s2)',border:'1px solid var(--bd)',padding:'8px 11px',borderRadius:8}}><div style={{fontSize:8,fontWeight:700,color:'var(--mu)',textTransform:'uppercase',letterSpacing:'.1em',marginBottom:3}}>Raising</div><div style={{fontSize:11,fontWeight:700}}>{activeFounder.funding}</div></div>}
                {activeFounder.checkSize&&<div style={{background:'var(--s2)',border:'1px solid var(--bd)',padding:'8px 11px',borderRadius:8}}><div style={{fontSize:8,fontWeight:700,color:'var(--mu)',textTransform:'uppercase',letterSpacing:'.1em',marginBottom:3}}>Check Size</div><div style={{fontSize:11,fontWeight:700}}>{activeFounder.checkSize}</div></div>}
              </div>
            </div>
            {/* Chat - guaranteed remaining height, input always visible */}
            <div style={{flex:'1 1 auto',minHeight:220,display:'flex',flexDirection:'column'}}>
              <div style={{padding:'8px 16px',background:'var(--s2)',borderBottom:'1px solid var(--bd)',fontSize:11,fontWeight:700,color:'var(--mu)',textTransform:'uppercase',letterSpacing:'.06em',flexShrink:0}}>Message {activeFounder.name?.split(' ')[0]||'Founder'}</div>
              <div style={{flex:1,minHeight:0,overflow:'hidden'}}><ChatWindow messages={messages} onSend={sendMsg} meType="angel" loading={msgLoading}/></div>
            </div>
          </div>
        </div>
      )}

      {/* ── ANGEL BUY CREDITS MODAL ── */}
      {showBuyAngel&&!showStripeAngel&&(
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.5)',zIndex:999,display:'flex',alignItems:'center',justifyContent:'center',padding:16,backdropFilter:'blur(4px)',overflowY:'auto'}}>
          <div style={{background:'#fff',borderRadius:20,padding:'32px 28px',maxWidth:680,width:'100%',boxShadow:'0 20px 60px rgba(0,0,0,.2)',position:'relative',margin:'auto'}}>
            <button onClick={()=>setShowBuyAngel(false)} style={{position:'absolute',top:14,right:14,background:'#F3F4F6',border:'none',width:28,height:28,borderRadius:'50%',fontSize:16,cursor:'pointer',color:'#6B7280'}}>×</button>
            <div style={{textAlign:'center',marginBottom:24}}>
              <div style={{fontSize:22,fontWeight:800,marginBottom:6,letterSpacing:'-.5px'}}>Fill In Credits</div>
              <div style={{fontSize:13,color:'#6B7280'}}>One Time Charge · Each message to a founder costs 1 credit</div>
            </div>
            <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:12,marginBottom:16}}>
              {ANGEL_TIERS.map(t=>(
                <div key={t.id} style={{background:t.popular?'linear-gradient(135deg,#FFFBEB,#FEF3C7)':'#fff',border:`2px solid ${t.popular?'#F59E0B':'#E5E7EB'}`,borderRadius:14,padding:'18px 14px',position:'relative',display:'flex',flexDirection:'column',textAlign:'center'}}>
                  {t.popular&&<div style={{position:'absolute',top:-10,left:'50%',transform:'translateX(-50%)',background:'#F59E0B',color:'#000',fontSize:9,fontWeight:800,padding:'2px 10px',borderRadius:100,whiteSpace:'nowrap'}}>MOST POPULAR</div>}
                  <div style={{fontSize:11,fontWeight:700,color:'#9CA3AF',textTransform:'uppercase',letterSpacing:'.06em',marginBottom:6}}>{t.label}</div>
                  <div style={{fontSize:28,fontWeight:800,color:'#0f0f0f',letterSpacing:'-1px',marginBottom:4}}>${t.price}</div>
                  <div style={{fontSize:12,color:'#6B7280',marginBottom:14}}>{t.credits.toLocaleString()} credits</div>
                  <button onClick={()=>{setSelectedAngelTier(t);setShowStripeAngel(true);}} style={{width:'100%',background:t.popular?'#0f0f0f':'#fff',color:t.popular?'#fff':'#0f0f0f',border:`1.5px solid ${t.popular?'#0f0f0f':'#E5E7EB'}`,padding:'10px 0',fontSize:13,fontWeight:700,borderRadius:8,cursor:'pointer',marginTop:'auto'}}>
                    Choose {t.label} →
                  </button>
                </div>
              ))}
            </div>
            <div style={{fontSize:11,color:'#9CA3AF',textAlign:'center'}}>Stripe · Instant activation · Credits never expire</div>
          </div>
        </div>
      )}
      <Pay username={selectedAngelTier?`VCInvest Investor - ${selectedAngelTier.label} (${selectedAngelTier.credits.toLocaleString()} credits)`:'VCInvest Credits'} selectedPrice={selectedAngelTier?.price||30} isOpen={showStripeAngel}
        onClose={s=>{setShowStripeAngel(false);if(s==='success')handleAngelCreditsPurchase('success');else{setShowBuyAngel(false);setSelectedAngelTier(null);}}}
        onSuccess={()=>{setShowStripeAngel(false);handleAngelCreditsPurchase('success');}}
      />
    </div>
  );
}

// ─── ROOT ─────────────────────────────────────────────────────────────────────

export default function App(){
  const path=window.location.pathname;
  // Track referral source from URL path e.g. /twitter, /producthunt
  useEffect(()=>{
    const knownSources=['twitter','producthunt','linkedin','instagram','tiktok','reddit','ycombinator','techcrunch','hacker-news','facebook','newsletter','email','blog','friends'];
    const slug=path.replace('/','').toLowerCase().trim();
    if(slug&&!['admin','dashboard','invest','blog','tool'].includes(slug)){
      localStorage.setItem('wi_source',slug);
    }
    // Always save the full signup URL so admin SMS includes it
    localStorage.setItem('wi_signup_url',window.location.href);
  },[]);
  if(path.startsWith('/admin'))return<AdminApp/>;
  if(path.startsWith('/dashboard'))return<FounderDashboard/>;
  if(path.startsWith('/invest'))return<AngelApp/>;
  // Any path like /twitter, /producthunt etc → landing page (source already captured above)
  return<MainApp/>;
}